// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%20%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%3E%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M10.6944%208.33487C10.9653%207.67285%2011.6283%207.21423%2012.3869%207.21423C13.1346%207.21423%2013.7895%207.65975%2014.0675%208.30642C14.3487%208.13443%2014.6802%208.03569%2015.0322%208.03569C16.0254%208.03569%2016.8548%208.82187%2016.8548%209.8214V9.90652C17.103%209.78332%2017.383%209.71426%2017.6774%209.71426C18.6706%209.71426%2019.5%2010.5004%2019.5%2011.5V14.5714C19.5%2018.4111%2016.3018%2021.5%2012.3869%2021.5C11.4279%2021.5%2010.5029%2021.3687%209.61008%2020.9533C8.71611%2020.5373%207.89034%2019.8532%207.10147%2018.8019L5.08581%2016.1683C4.51001%2015.4567%204.57347%2014.4352%205.23%2013.797C5.93899%2013.1078%207.08249%2013.1078%207.79148%2013.797L7.79968%2013.805C7.84226%2013.8483%207.88165%2013.889%207.91846%2013.9273C7.92006%2013.726%207.91977%2013.4872%207.91942%2013.2045C7.91926%2013.0733%207.91909%2012.9325%207.91909%2012.7817V9.85709C7.91909%208.85756%208.74847%208.07138%209.7417%208.07138C10.0887%208.07138%2010.4158%208.16735%2010.6944%208.33487ZM10.5643%209.85712C10.5643%209.43634%2010.2095%209.07138%209.7417%209.07138C9.27389%209.07138%208.91909%209.43633%208.91909%209.85709V12.7817C8.91909%2012.9257%208.91926%2013.0621%208.91943%2013.1909C8.92002%2013.6625%208.92049%2014.0329%208.91187%2014.307C8.9064%2014.481%208.89684%2014.6361%208.87748%2014.7637C8.8624%2014.863%208.82868%2015.055%208.70064%2015.2061C8.62011%2015.3012%208.49922%2015.3839%208.34225%2015.4068C8.19872%2015.4279%208.07952%2015.3907%208.00536%2015.3581C7.87099%2015.299%207.7587%2015.1973%207.68787%2015.1301C7.60764%2015.0539%207.49797%2014.9378%207.37723%2014.8099C7.28546%2014.7128%207.18728%2014.6088%207.09077%2014.5105C6.76957%2014.2021%206.24669%2014.2033%205.92703%2014.514C5.63861%2014.7944%205.614%2015.2343%205.86566%2015.5423L5.87549%2015.5548L7.90002%2018.2C8.61071%2019.1475%209.31465%2019.7129%2010.032%2020.0466C10.751%2020.3812%2011.5195%2020.5%2012.3869%2020.5C15.7764%2020.5%2018.5%2017.8323%2018.5%2014.5714V11.5C18.5%2011.0792%2018.1452%2010.7143%2017.6774%2010.7143C17.2096%2010.7143%2016.8548%2011.0792%2016.8548%2011.5V12C16.8548%2012.2761%2016.6309%2012.5%2016.3548%2012.5C16.0786%2012.5%2015.8548%2012.2761%2015.8548%2012V9.8214C15.8548%209.40064%2015.5%209.03569%2015.0322%209.03569C14.5643%209.03569%2014.2095%209.40064%2014.2095%209.8214V11.1428C14.2095%2011.419%2013.9857%2011.6428%2013.7095%2011.6428C13.4334%2011.6428%2013.2095%2011.419%2013.2095%2011.1428V8.99995C13.2095%208.57919%2012.8547%208.21423%2012.3869%208.21423C11.9191%208.21423%2011.5643%208.57919%2011.5643%208.99995V11.1428C11.5643%2011.419%2011.3405%2011.6428%2011.0643%2011.6428C10.7882%2011.6428%2010.5643%2011.419%2010.5643%2011.1428V9.85712Z%22%20fill%3D%22black%22%20%2F%3E%20%3Cpath%20d%3D%22M9.7417%209.07138C10.2095%209.07138%2010.5643%209.43634%2010.5643%209.85712V11.1428C10.5643%2011.419%2010.7882%2011.6428%2011.0643%2011.6428C11.3405%2011.6428%2011.5643%2011.419%2011.5643%2011.1428V8.99995C11.5643%208.57919%2011.9191%208.21423%2012.3869%208.21423C12.8547%208.21423%2013.2095%208.57919%2013.2095%208.99995V11.1428C13.2095%2011.419%2013.4334%2011.6428%2013.7095%2011.6428C13.9857%2011.6428%2014.2095%2011.419%2014.2095%2011.1428V9.8214C14.2095%209.40064%2014.5643%209.03569%2015.0322%209.03569C15.5%209.03569%2015.8548%209.40064%2015.8548%209.8214V12C15.8548%2012.2761%2016.0786%2012.5%2016.3548%2012.5C16.6309%2012.5%2016.8548%2012.2761%2016.8548%2012V11.5C16.8548%2011.0792%2017.2096%2010.7143%2017.6774%2010.7143C18.1452%2010.7143%2018.5%2011.0792%2018.5%2011.5V14.5714C18.5%2017.8323%2015.7764%2020.5%2012.3869%2020.5C11.5195%2020.5%2010.751%2020.3812%2010.032%2020.0466C9.31465%2019.7129%208.61071%2019.1475%207.90002%2018.2L5.87549%2015.5548L5.86566%2015.5423C5.614%2015.2343%205.63861%2014.7944%205.92703%2014.514C6.24669%2014.2033%206.76957%2014.2021%207.09077%2014.5105C7.18728%2014.6088%207.28546%2014.7128%207.37723%2014.8099C7.49797%2014.9378%207.60764%2015.0539%207.68787%2015.1301C7.7587%2015.1973%207.87099%2015.299%208.00536%2015.3581C8.07952%2015.3907%208.19872%2015.4279%208.34225%2015.4068C8.49922%2015.3839%208.62011%2015.3012%208.70064%2015.2061C8.82868%2015.055%208.8624%2014.863%208.87748%2014.7637C8.89684%2014.6361%208.9064%2014.481%208.91187%2014.307C8.92049%2014.0329%208.92002%2013.6625%208.91943%2013.1909C8.91926%2013.0621%208.91909%2012.9257%208.91909%2012.7817V9.85709C8.91909%209.43633%209.27389%209.07138%209.7417%209.07138Z%22%20fill%3D%22white%22%20%2F%3E%20%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%20%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%3E%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M10.6944%203.62063C10.9653%202.95862%2011.6283%202.5%2012.3869%202.5C13.3802%202.5%2014.2096%203.28619%2014.2096%204.28571V4.40655C14.4578%204.28334%2014.7378%204.21429%2015.0322%204.21429C16.0254%204.21429%2016.8548%205.00047%2016.8548%206V6.97798C17.103%206.85477%2017.383%206.78571%2017.6774%206.78571C18.6706%206.78571%2019.5%207.5719%2019.5%208.57143V14.5714C19.5%2018.4111%2016.3018%2021.5%2012.3869%2021.5C11.4279%2021.5%2010.5029%2021.3687%209.61009%2020.9533C8.71742%2020.538%207.89275%2019.8553%207.10492%2018.8065L3.89715%2014.8057C3.31723%2014.0938%203.37951%2013.0692%204.03749%2012.4296C4.74649%2011.7404%205.88998%2011.7404%206.59897%2012.4296C6.60945%2012.4398%206.61948%2012.4504%206.62902%2012.4615L7.19243%2013.1145C7.49969%2013.4896%207.73216%2013.7452%207.90552%2013.9094C7.90575%2013.9058%207.90599%2013.9021%207.90621%2013.8984C7.92066%2013.6641%207.92009%2013.374%207.91941%2013.0239C7.91926%2012.9461%207.9191%2012.8654%207.9191%2012.7817V5.14286C7.9191%204.14333%208.74848%203.35714%209.74172%203.35714C10.0887%203.35714%2010.4158%203.45312%2010.6944%203.62063ZM11.5643%2011.1429C11.5643%2011.419%2011.3405%2011.6429%2011.0643%2011.6429C10.7882%2011.6429%2010.5643%2011.419%2010.5643%2011.1429V5.14286C10.5643%204.7221%2010.2095%204.35714%209.74172%204.35714C9.2739%204.35714%208.9191%204.7221%208.9191%205.14286V12.7817C8.9191%2012.858%208.91927%2012.9337%208.91943%2013.0085C8.92019%2013.3597%208.92092%2013.6907%208.90432%2013.9599C8.89417%2014.1245%208.87652%2014.2886%208.84181%2014.4348C8.80979%2014.5696%208.74873%2014.7552%208.60644%2014.9018C8.43071%2015.0827%208.19413%2015.142%207.96546%2015.0976C7.77497%2015.0607%207.60654%2014.9565%207.46937%2014.8519C7.18917%2014.6383%206.84626%2014.2699%206.4228%2013.7533L5.88792%2013.1333C5.56593%2012.8348%205.05078%2012.8392%204.73453%2013.1467C4.44611%2013.427%204.4215%2013.8669%204.67315%2014.175L4.67604%2014.1785L7.89011%2018.1872L7.90002%2018.2C8.6107%2019.1476%209.31466%2019.7129%2010.032%2020.0467C10.751%2020.3813%2011.5195%2020.5%2012.3869%2020.5C15.7764%2020.5%2018.5%2017.8323%2018.5%2014.5714V8.57143C18.5%208.15067%2018.1452%207.78571%2017.6774%207.78571C17.2096%207.78571%2016.8548%208.15067%2016.8548%208.57143V12C16.8548%2012.2761%2016.6309%2012.5%2016.3548%2012.5C16.0786%2012.5%2015.8548%2012.2761%2015.8548%2012V6C15.8548%205.57924%2015.5%205.21429%2015.0322%205.21429C14.5644%205.21429%2014.2096%205.57924%2014.2096%206V11.1429C14.2096%2011.419%2013.9857%2011.6429%2013.7096%2011.6429C13.4334%2011.6429%2013.2096%2011.419%2013.2096%2011.1429V4.28571C13.2096%203.86496%2012.8548%203.5%2012.3869%203.5C11.9191%203.5%2011.5643%203.86496%2011.5643%204.28571V11.1429Z%22%20fill%3D%22black%22%20%2F%3E%20%3Cpath%20d%3D%22M11.0643%2011.6429C11.3405%2011.6429%2011.5643%2011.419%2011.5643%2011.1429V4.28571C11.5643%203.86496%2011.9191%203.5%2012.3869%203.5C12.8548%203.5%2013.2096%203.86496%2013.2096%204.28571V11.1429C13.2096%2011.419%2013.4334%2011.6429%2013.7096%2011.6429C13.9857%2011.6429%2014.2096%2011.419%2014.2096%2011.1429V6C14.2096%205.57924%2014.5644%205.21429%2015.0322%205.21429C15.5%205.21429%2015.8548%205.57924%2015.8548%206V12C15.8548%2012.2761%2016.0786%2012.5%2016.3548%2012.5C16.6309%2012.5%2016.8548%2012.2761%2016.8548%2012V8.57143C16.8548%208.15067%2017.2096%207.78571%2017.6774%207.78571C18.1452%207.78571%2018.5%208.15067%2018.5%208.57143V14.5714C18.5%2017.8323%2015.7764%2020.5%2012.3869%2020.5C11.5195%2020.5%2010.751%2020.3813%2010.032%2020.0467C9.31466%2019.7129%208.6107%2019.1476%207.90002%2018.2L7.89011%2018.1872L4.67604%2014.1785L4.67315%2014.175C4.4215%2013.8669%204.44611%2013.427%204.73453%2013.1467C5.05078%2012.8392%205.56593%2012.8348%205.88792%2013.1333L6.4228%2013.7533C6.84626%2014.2699%207.18917%2014.6383%207.46937%2014.8519C7.60654%2014.9565%207.77497%2015.0607%207.96546%2015.0976C8.19413%2015.142%208.43071%2015.0827%208.60644%2014.9018C8.74873%2014.7552%208.80979%2014.5696%208.84181%2014.4348C8.87652%2014.2886%208.89417%2014.1245%208.90432%2013.9599C8.92092%2013.6907%208.92019%2013.3597%208.91943%2013.0085C8.91927%2012.9337%208.9191%2012.858%208.9191%2012.7817V5.14286C8.9191%204.7221%209.2739%204.35714%209.74172%204.35714C10.2095%204.35714%2010.5643%204.7221%2010.5643%205.14286V11.1429C10.5643%2011.419%2010.7882%2011.6429%2011.0643%2011.6429Z%22%20fill%3D%22white%22%20%2F%3E%20%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.1.7 | MIT License | https://tailwindcss.com */
@layer properties;
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
      "Courier New", monospace;
    --color-red-50: oklch(97.1% 0.013 17.38);
    --color-red-100: oklch(93.6% 0.032 17.717);
    --color-red-200: oklch(88.5% 0.062 18.334);
    --color-red-300: oklch(80.8% 0.114 19.571);
    --color-red-400: oklch(70.4% 0.191 22.216);
    --color-red-500: oklch(63.7% 0.237 25.331);
    --color-red-600: oklch(57.7% 0.245 27.325);
    --color-red-700: oklch(50.5% 0.213 27.518);
    --color-yellow-50: oklch(98.7% 0.026 102.212);
    --color-yellow-500: oklch(79.5% 0.184 86.047);
    --color-green-50: oklch(98.2% 0.018 155.826);
    --color-blue-50: oklch(97% 0.014 254.604);
    --color-blue-100: oklch(93.2% 0.032 255.585);
    --color-blue-200: oklch(88.2% 0.059 254.128);
    --color-blue-500: oklch(62.3% 0.214 259.815);
    --color-blue-600: oklch(54.6% 0.245 262.881);
    --color-blue-700: oklch(48.8% 0.243 264.376);
    --color-blue-900: oklch(37.9% 0.146 265.522);
    --color-gray-50: oklch(98.5% 0.002 247.839);
    --color-gray-100: oklch(96.7% 0.003 264.542);
    --color-gray-200: oklch(92.8% 0.006 264.531);
    --color-gray-300: oklch(87.2% 0.01 258.338);
    --color-gray-400: oklch(70.7% 0.022 261.325);
    --color-gray-500: oklch(55.1% 0.027 264.364);
    --color-gray-600: oklch(44.6% 0.03 256.802);
    --color-gray-700: oklch(37.3% 0.034 259.733);
    --color-gray-900: oklch(21% 0.034 264.665);
    --color-zinc-100: oklch(96.7% 0.001 286.375);
    --color-zinc-500: oklch(55.2% 0.016 285.938);
    --color-black: #000;
    --color-white: #fff;
    --spacing: 0.25rem;
    --container-sm: 24rem;
    --container-lg: 32rem;
    --container-3xl: 48rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-3xl: 1.875rem;
    --text-3xl--line-height: calc(2.25 / 1.875);
    --text-5xl: 3rem;
    --text-5xl--line-height: 1;
    --font-weight-normal: 400;
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --font-weight-extrabold: 800;
    --tracking-tight: -0.025em;
    --tracking-wider: 0.05em;
    --tracking-widest: 0.1em;
    --leading-normal: 1.5;
    --leading-relaxed: 1.625;
    --radius-sm: calc(var(--radius) - 4px);
    --radius-md: calc(var(--radius) - 2px);
    --radius-lg: var(--radius);
    --radius-xl: 0.75rem;
    --ease-out: cubic-bezier(0, 0, 0.2, 1);
    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
    --animate-spin: spin 1s linear infinite;
    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    --blur-sm: 8px;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
    --color-border: hsl(var(--border));
    --color-input: hsl(var(--input));
    --color-ring: hsl(var(--ring));
    --color-background: hsl(var(--background));
    --color-foreground: hsl(var(--foreground));
    --color-primary: hsl(var(--primary));
    --color-primary-foreground: hsl(var(--primary-foreground));
    --color-secondary: hsl(var(--secondary));
    --color-secondary-foreground: hsl(var(--secondary-foreground));
    --color-destructive: hsl(var(--destructive));
    --color-destructive-foreground: hsl(var(--destructive-foreground));
    --color-muted: hsl(var(--muted));
    --color-muted-foreground: hsl(var(--muted-foreground));
    --color-accent: hsl(var(--accent));
    --color-accent-foreground: hsl(var(--accent-foreground));
    --color-popover: hsl(var(--popover));
    --color-popover-foreground: hsl(var(--popover-foreground));
    --color-card: hsl(var(--card));
    --color-card-foreground: hsl(var(--card-foreground));
    --animate-accordion-down: accordion-down 0.2s ease-out;
    --animate-accordion-up: accordion-up 0.2s ease-out;
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    -moz-tab-size: 4;
      -o-tab-size: 4;
         tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::-moz-placeholder {
    opacity: 1;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::-moz-placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    -webkit-appearance: button;
       -moz-appearance: button;
            appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .\\@container {
    container-type: inline-size;
  }
  .pointer-events-auto {
    pointer-events: auto;
  }
  .pointer-events-none {
    pointer-events: none;
  }
  .collapse {
    visibility: collapse;
  }
  .invisible {
    visibility: hidden;
  }
  .visible {
    visibility: visible;
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .static {
    position: static;
  }
  .sticky {
    position: sticky;
  }
  .inset-0 {
    inset: calc(var(--spacing) * 0);
  }
  .inset-x-0 {
    inset-inline: calc(var(--spacing) * 0);
  }
  .inset-y-0 {
    inset-block: calc(var(--spacing) * 0);
  }
  .-top-12 {
    top: calc(var(--spacing) * -12);
  }
  .top-0 {
    top: calc(var(--spacing) * 0);
  }
  .top-1\\/2 {
    top: calc(1/2 * 100%);
  }
  .top-1\\/4 {
    top: calc(1/4 * 100%);
  }
  .top-2 {
    top: calc(var(--spacing) * 2);
  }
  .top-4 {
    top: calc(var(--spacing) * 4);
  }
  .top-5 {
    top: calc(var(--spacing) * 5);
  }
  .top-7 {
    top: calc(var(--spacing) * 7);
  }
  .top-\\[1px\\] {
    top: 1px;
  }
  .top-\\[50\\%\\] {
    top: 50%;
  }
  .top-\\[60\\%\\] {
    top: 60%;
  }
  .top-full {
    top: 100%;
  }
  .-right-12 {
    right: calc(var(--spacing) * -12);
  }
  .right-0 {
    right: calc(var(--spacing) * 0);
  }
  .right-1 {
    right: calc(var(--spacing) * 1);
  }
  .right-2 {
    right: calc(var(--spacing) * 2);
  }
  .right-4 {
    right: calc(var(--spacing) * 4);
  }
  .right-7 {
    right: calc(var(--spacing) * 7);
  }
  .-bottom-6 {
    bottom: calc(var(--spacing) * -6);
  }
  .-bottom-12 {
    bottom: calc(var(--spacing) * -12);
  }
  .bottom-0 {
    bottom: calc(var(--spacing) * 0);
  }
  .bottom-\\[-25px\\] {
    bottom: -25px;
  }
  .-left-12 {
    left: calc(var(--spacing) * -12);
  }
  .left-0 {
    left: calc(var(--spacing) * 0);
  }
  .left-1 {
    left: calc(var(--spacing) * 1);
  }
  .left-1\\/2 {
    left: calc(1/2 * 100%);
  }
  .left-2 {
    left: calc(var(--spacing) * 2);
  }
  .left-6 {
    left: calc(var(--spacing) * 6);
  }
  .left-11 {
    left: calc(var(--spacing) * 11);
  }
  .left-\\[50\\%\\] {
    left: 50%;
  }
  .isolate {
    isolation: isolate;
  }
  .z-10 {
    z-index: 10;
  }
  .z-50 {
    z-index: 50;
  }
  .z-\\[1\\] {
    z-index: 1;
  }
  .z-\\[100\\] {
    z-index: 100;
  }
  .container {
    width: 100%;
    @media (width >= 40rem) {
      max-width: 40rem;
    }
    @media (width >= 48rem) {
      max-width: 48rem;
    }
    @media (width >= 64rem) {
      max-width: 64rem;
    }
    @media (width >= 80rem) {
      max-width: 80rem;
    }
    @media (width >= 96rem) {
      max-width: 96rem;
    }
  }
  .m-0 {
    margin: calc(var(--spacing) * 0);
  }
  .m-2 {
    margin: calc(var(--spacing) * 2);
  }
  .container {
    margin-inline: auto;
    padding-inline: 2rem;
    @media (width >= 40rem) {
      max-width: none;
    }
    @media (width >= 1400px) {
      max-width: 1400px;
    }
  }
  .container {
    margin-inline: auto;
    padding-inline: 2rem;
    @media (width >= 40rem) {
      max-width: none;
    }
    @media (width >= 1400px) {
      max-width: 1400px;
    }
  }
  .-mx-1 {
    margin-inline: calc(var(--spacing) * -1);
  }
  .mx-auto {
    margin-inline: auto;
  }
  .my-1 {
    margin-block: calc(var(--spacing) * 1);
  }
  .my-2 {
    margin-block: calc(var(--spacing) * 2);
  }
  .-mt-4 {
    margin-top: calc(var(--spacing) * -4);
  }
  .mt-0\\.5 {
    margin-top: calc(var(--spacing) * 0.5);
  }
  .mt-1 {
    margin-top: calc(var(--spacing) * 1);
  }
  .mt-1\\.5 {
    margin-top: calc(var(--spacing) * 1.5);
  }
  .mt-2 {
    margin-top: calc(var(--spacing) * 2);
  }
  .mt-3 {
    margin-top: calc(var(--spacing) * 3);
  }
  .mt-4 {
    margin-top: calc(var(--spacing) * 4);
  }
  .mt-5 {
    margin-top: calc(var(--spacing) * 5);
  }
  .mt-6 {
    margin-top: calc(var(--spacing) * 6);
  }
  .mt-16 {
    margin-top: calc(var(--spacing) * 16);
  }
  .mt-24 {
    margin-top: calc(var(--spacing) * 24);
  }
  .mt-60 {
    margin-top: calc(var(--spacing) * 60);
  }
  .mt-auto {
    margin-top: auto;
  }
  .mr-0 {
    margin-right: calc(var(--spacing) * 0);
  }
  .mr-1 {
    margin-right: calc(var(--spacing) * 1);
  }
  .mr-1\\.5 {
    margin-right: calc(var(--spacing) * 1.5);
  }
  .mr-2 {
    margin-right: calc(var(--spacing) * 2);
  }
  .mr-3 {
    margin-right: calc(var(--spacing) * 3);
  }
  .mr-6 {
    margin-right: calc(var(--spacing) * 6);
  }
  .mb-1 {
    margin-bottom: calc(var(--spacing) * 1);
  }
  .mb-2 {
    margin-bottom: calc(var(--spacing) * 2);
  }
  .mb-3 {
    margin-bottom: calc(var(--spacing) * 3);
  }
  .mb-4 {
    margin-bottom: calc(var(--spacing) * 4);
  }
  .mb-5 {
    margin-bottom: calc(var(--spacing) * 5);
  }
  .mb-6 {
    margin-bottom: calc(var(--spacing) * 6);
  }
  .mb-16 {
    margin-bottom: calc(var(--spacing) * 16);
  }
  .-ml-4 {
    margin-left: calc(var(--spacing) * -4);
  }
  .ml-1 {
    margin-left: calc(var(--spacing) * 1);
  }
  .ml-2 {
    margin-left: calc(var(--spacing) * 2);
  }
  .ml-8 {
    margin-left: calc(var(--spacing) * 8);
  }
  .ml-auto {
    margin-left: auto;
  }
  .\\!table {
    display: table !important;
  }
  .block {
    display: block;
  }
  .block\\! {
    display: block !important;
  }
  .contents {
    display: contents;
  }
  .flex {
    display: flex;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .inline {
    display: inline;
  }
  .inline-block {
    display: inline-block;
  }
  .inline-flex {
    display: inline-flex;
  }
  .inline-grid {
    display: inline-grid;
  }
  .list-item {
    display: list-item;
  }
  .table {
    display: table;
  }
  .aspect-square {
    aspect-ratio: 1 / 1;
  }
  .h-1 {
    height: calc(var(--spacing) * 1);
  }
  .h-1\\.5 {
    height: calc(var(--spacing) * 1.5);
  }
  .h-1\\/2 {
    height: calc(1/2 * 100%);
  }
  .h-2 {
    height: calc(var(--spacing) * 2);
  }
  .h-2\\.5 {
    height: calc(var(--spacing) * 2.5);
  }
  .h-3 {
    height: calc(var(--spacing) * 3);
  }
  .h-3\\.5 {
    height: calc(var(--spacing) * 3.5);
  }
  .h-3\\/4 {
    height: calc(3/4 * 100%);
  }
  .h-4 {
    height: calc(var(--spacing) * 4);
  }
  .h-5 {
    height: calc(var(--spacing) * 5);
  }
  .h-6 {
    height: calc(var(--spacing) * 6);
  }
  .h-7 {
    height: calc(var(--spacing) * 7);
  }
  .h-8 {
    height: calc(var(--spacing) * 8);
  }
  .h-9 {
    height: calc(var(--spacing) * 9);
  }
  .h-10 {
    height: calc(var(--spacing) * 10);
  }
  .h-11 {
    height: calc(var(--spacing) * 11);
  }
  .h-12 {
    height: calc(var(--spacing) * 12);
  }
  .h-14 {
    height: calc(var(--spacing) * 14);
  }
  .h-16 {
    height: calc(var(--spacing) * 16);
  }
  .h-24 {
    height: calc(var(--spacing) * 24);
  }
  .h-\\[1px\\] {
    height: 1px;
  }
  .h-\\[52px\\] {
    height: 52px;
  }
  .h-\\[56px\\] {
    height: 56px;
  }
  .h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\] {
    height: var(--radix-navigation-menu-viewport-height);
  }
  .h-\\[var\\(--radix-select-trigger-height\\)\\] {
    height: var(--radix-select-trigger-height);
  }
  .h-auto {
    height: auto;
  }
  .h-dvh {
    height: 100dvh;
  }
  .h-full {
    height: 100%;
  }
  .h-px {
    height: 1px;
  }
  .h-screen {
    height: 100vh;
  }
  .max-h-96 {
    max-height: calc(var(--spacing) * 96);
  }
  .max-h-\\[200px\\] {
    max-height: 200px;
  }
  .max-h-\\[300px\\] {
    max-height: 300px;
  }
  .max-h-\\[400px\\] {
    max-height: 400px;
  }
  .max-h-screen {
    max-height: 100vh;
  }
  .min-h-0 {
    min-height: calc(var(--spacing) * 0);
  }
  .min-h-48 {
    min-height: calc(var(--spacing) * 48);
  }
  .min-h-\\[80px\\] {
    min-height: 80px;
  }
  .w-1 {
    width: calc(var(--spacing) * 1);
  }
  .w-1\\.5 {
    width: calc(var(--spacing) * 1.5);
  }
  .w-2 {
    width: calc(var(--spacing) * 2);
  }
  .w-2\\.5 {
    width: calc(var(--spacing) * 2.5);
  }
  .w-3 {
    width: calc(var(--spacing) * 3);
  }
  .w-3\\.5 {
    width: calc(var(--spacing) * 3.5);
  }
  .w-3\\/4 {
    width: calc(3/4 * 100%);
  }
  .w-4 {
    width: calc(var(--spacing) * 4);
  }
  .w-5 {
    width: calc(var(--spacing) * 5);
  }
  .w-6 {
    width: calc(var(--spacing) * 6);
  }
  .w-7 {
    width: calc(var(--spacing) * 7);
  }
  .w-8 {
    width: calc(var(--spacing) * 8);
  }
  .w-9 {
    width: calc(var(--spacing) * 9);
  }
  .w-10 {
    width: calc(var(--spacing) * 10);
  }
  .w-11 {
    width: calc(var(--spacing) * 11);
  }
  .w-12 {
    width: calc(var(--spacing) * 12);
  }
  .w-16 {
    width: calc(var(--spacing) * 16);
  }
  .w-64 {
    width: calc(var(--spacing) * 64);
  }
  .w-72 {
    width: calc(var(--spacing) * 72);
  }
  .w-\\[1px\\] {
    width: 1px;
  }
  .w-\\[40px\\] {
    width: 40px;
  }
  .w-\\[70px\\] {
    width: 70px;
  }
  .w-\\[100px\\] {
    width: 100px;
  }
  .w-\\[120px\\] {
    width: 120px;
  }
  .w-\\[150px\\] {
    width: 150px;
  }
  .w-\\[214px\\] {
    width: 214px;
  }
  .w-\\[350px\\] {
    width: 350px;
  }
  .w-\\[1024px\\] {
    width: 1024px;
  }
  .w-fit {
    width: -moz-fit-content;
    width: fit-content;
  }
  .w-full {
    width: 100%;
  }
  .w-max {
    width: -moz-max-content;
    width: max-content;
  }
  .w-px {
    width: 1px;
  }
  .max-w-3xl {
    max-width: var(--container-3xl);
  }
  .max-w-56 {
    max-width: calc(var(--spacing) * 56);
  }
  .max-w-96 {
    max-width: calc(var(--spacing) * 96);
  }
  .max-w-\\[50vw\\] {
    max-width: 50vw;
  }
  .max-w-\\[57px\\] {
    max-width: 57px;
  }
  .max-w-\\[150px\\] {
    max-width: 150px;
  }
  .max-w-\\[200px\\] {
    max-width: 200px;
  }
  .max-w-\\[800px\\] {
    max-width: 800px;
  }
  .max-w-\\[1800px\\] {
    max-width: 1800px;
  }
  .max-w-full {
    max-width: 100%;
  }
  .max-w-lg {
    max-width: var(--container-lg);
  }
  .max-w-max {
    max-width: -moz-max-content;
    max-width: max-content;
  }
  .max-w-none {
    max-width: none;
  }
  .max-w-sm {
    max-width: var(--container-sm);
  }
  .min-w-0 {
    min-width: calc(var(--spacing) * 0);
  }
  .min-w-56 {
    min-width: calc(var(--spacing) * 56);
  }
  .min-w-\\[8rem\\] {
    min-width: 8rem;
  }
  .min-w-\\[12rem\\] {
    min-width: 12rem;
  }
  .min-w-\\[57px\\] {
    min-width: 57px;
  }
  .min-w-\\[80px\\] {
    min-width: 80px;
  }
  .min-w-\\[160px\\] {
    min-width: 160px;
  }
  .min-w-\\[var\\(--radix-select-trigger-width\\)\\] {
    min-width: var(--radix-select-trigger-width);
  }
  .flex-1 {
    flex: 1;
  }
  .flex-3 {
    flex: 3;
  }
  .flex-none {
    flex: none;
  }
  .flex-shrink {
    flex-shrink: 1;
  }
  .flex-shrink-0 {
    flex-shrink: 0;
  }
  .shrink {
    flex-shrink: 1;
  }
  .shrink-0 {
    flex-shrink: 0;
  }
  .flex-grow {
    flex-grow: 1;
  }
  .grow {
    flex-grow: 1;
  }
  .grow-0 {
    flex-grow: 0;
  }
  .basis-full {
    flex-basis: 100%;
  }
  .caption-bottom {
    caption-side: bottom;
  }
  .border-collapse {
    border-collapse: collapse;
  }
  .-translate-x-1\\/2 {
    --tw-translate-x: calc(calc(1/2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-\\[-50\\%\\] {
    --tw-translate-x: -50%;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-y-1\\/2 {
    --tw-translate-y: calc(calc(1/2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-y-\\[-50\\%\\] {
    --tw-translate-y: -50%;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-y-\\[2px\\] {
    --tw-translate-y: 2px;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .rotate-45 {
    rotate: 45deg;
  }
  .rotate-90 {
    rotate: 90deg;
  }
  .transform {
    transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
  }
  .animate-pulse {
    animation: var(--animate-pulse);
  }
  .animate-spin {
    animation: var(--animate-spin);
  }
  .cursor-default {
    cursor: default;
  }
  .cursor-not-allowed {
    cursor: not-allowed;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .touch-none {
    touch-action: none;
  }
  .resize {
    resize: both;
  }
  .list-none {
    list-style-type: none;
  }
  .flex-col {
    flex-direction: column;
  }
  .flex-col-reverse {
    flex-direction: column-reverse;
  }
  .flex-row {
    flex-direction: row;
  }
  .flex-nowrap {
    flex-wrap: nowrap;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .items-center {
    align-items: center;
  }
  .items-end {
    align-items: flex-end;
  }
  .items-start {
    align-items: flex-start;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .justify-start {
    justify-content: flex-start;
  }
  .gap-1 {
    gap: calc(var(--spacing) * 1);
  }
  .gap-1\\.5 {
    gap: calc(var(--spacing) * 1.5);
  }
  .gap-2 {
    gap: calc(var(--spacing) * 2);
  }
  .gap-3 {
    gap: calc(var(--spacing) * 3);
  }
  .gap-4 {
    gap: calc(var(--spacing) * 4);
  }
  .gap-5 {
    gap: calc(var(--spacing) * 5);
  }
  .gap-6 {
    gap: calc(var(--spacing) * 6);
  }
  .gap-9 {
    gap: calc(var(--spacing) * 9);
  }
  .gap-10 {
    gap: calc(var(--spacing) * 10);
  }
  .gap-\\[6px\\] {
    gap: 6px;
  }
  .space-y-1 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 1) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 1) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-1\\.5 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 1.5) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 1.5) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-2 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-3 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 3) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 3) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-4 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-\\[8px\\] {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(8px * var(--tw-space-y-reverse));
      margin-block-end: calc(8px * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-\\[10px\\] {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(10px * var(--tw-space-y-reverse));
      margin-block-end: calc(10px * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .gap-x-4 {
    -moz-column-gap: calc(var(--spacing) * 4);
         column-gap: calc(var(--spacing) * 4);
  }
  .space-x-1 {
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 1) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 1) * calc(1 - var(--tw-space-x-reverse)));
    }
  }
  .space-x-2 {
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 2) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-x-reverse)));
    }
  }
  .space-x-4 {
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 4) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-x-reverse)));
    }
  }
  .space-x-6 {
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 6) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-x-reverse)));
    }
  }
  .space-x-\\[6px\\] {
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(6px * var(--tw-space-x-reverse));
      margin-inline-end: calc(6px * calc(1 - var(--tw-space-x-reverse)));
    }
  }
  .space-x-\\[10px\\] {
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(10px * var(--tw-space-x-reverse));
      margin-inline-end: calc(10px * calc(1 - var(--tw-space-x-reverse)));
    }
  }
  .gap-y-2 {
    row-gap: calc(var(--spacing) * 2);
  }
  .divide-y {
    :where(& > :not(:last-child)) {
      --tw-divide-y-reverse: 0;
      border-bottom-style: var(--tw-border-style);
      border-top-style: var(--tw-border-style);
      border-top-width: calc(1px * var(--tw-divide-y-reverse));
      border-bottom-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
    }
  }
  .divide-gray-100 {
    :where(& > :not(:last-child)) {
      border-color: var(--color-gray-100);
    }
  }
  .divide-gray-200 {
    :where(& > :not(:last-child)) {
      border-color: var(--color-gray-200);
    }
  }
  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .overflow-auto {
    overflow: auto;
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .overflow-visible {
    overflow: visible;
  }
  .overflow-x-hidden {
    overflow-x: hidden;
  }
  .overflow-y-auto {
    overflow-y: auto;
  }
  .rounded {
    border-radius: 0.25rem;
  }
  .rounded-\\[6px\\] {
    border-radius: 6px;
  }
  .rounded-\\[inherit\\] {
    border-radius: inherit;
  }
  .rounded-full {
    border-radius: calc(infinity * 1px);
  }
  .rounded-lg {
    border-radius: var(--radius-lg);
  }
  .rounded-md {
    border-radius: var(--radius-md);
  }
  .rounded-sm {
    border-radius: var(--radius-sm);
  }
  .rounded-xl {
    border-radius: var(--radius-xl);
  }
  .rounded-t-\\[10px\\] {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .rounded-tl-sm {
    border-top-left-radius: var(--radius-sm);
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-2 {
    border-style: var(--tw-border-style);
    border-width: 2px;
  }
  .border-y {
    border-block-style: var(--tw-border-style);
    border-block-width: 1px;
  }
  .border-t {
    border-top-style: var(--tw-border-style);
    border-top-width: 1px;
  }
  .border-r {
    border-right-style: var(--tw-border-style);
    border-right-width: 1px;
  }
  .border-b {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  .border-b-0 {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 0px;
  }
  .border-l {
    border-left-style: var(--tw-border-style);
    border-left-width: 1px;
  }
  .border-dashed {
    --tw-border-style: dashed;
    border-style: dashed;
  }
  .border-blue-100 {
    border-color: var(--color-blue-100);
  }
  .border-blue-200 {
    border-color: var(--color-blue-200);
  }
  .border-blue-500 {
    border-color: var(--color-blue-500);
  }
  .border-destructive {
    border-color: var(--color-destructive);
  }
  .border-destructive\\/50 {
    border-color: color-mix(in srgb, hsl(var(--destructive)) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-destructive) 50%, transparent);
    }
  }
  .border-gray-100 {
    border-color: var(--color-gray-100);
  }
  .border-gray-300 {
    border-color: var(--color-gray-300);
  }
  .border-input {
    border-color: var(--color-input);
  }
  .border-primary {
    border-color: var(--color-primary);
  }
  .border-red-100 {
    border-color: var(--color-red-100);
  }
  .border-red-200 {
    border-color: var(--color-red-200);
  }
  .border-transparent {
    border-color: transparent;
  }
  .border-t-transparent {
    border-top-color: transparent;
  }
  .border-l-transparent {
    border-left-color: transparent;
  }
  .bg-accent {
    background-color: var(--color-accent);
  }
  .bg-background {
    background-color: var(--color-background);
  }
  .bg-black\\/80 {
    background-color: color-mix(in srgb, #000 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 80%, transparent);
    }
  }
  .bg-blue-50 {
    background-color: var(--color-blue-50);
  }
  .bg-blue-50\\/50 {
    background-color: color-mix(in srgb, oklch(97% 0.014 254.604) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-blue-50) 50%, transparent);
    }
  }
  .bg-blue-100 {
    background-color: var(--color-blue-100);
  }
  .bg-blue-500 {
    background-color: var(--color-blue-500);
  }
  .bg-border {
    background-color: var(--color-border);
  }
  .bg-card {
    background-color: var(--color-card);
  }
  .bg-current {
    background-color: currentcolor;
  }
  .bg-destructive {
    background-color: var(--color-destructive);
  }
  .bg-foreground {
    background-color: var(--color-foreground);
  }
  .bg-gray-50 {
    background-color: var(--color-gray-50);
  }
  .bg-gray-50\\/30 {
    background-color: color-mix(in srgb, oklch(98.5% 0.002 247.839) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-gray-50) 30%, transparent);
    }
  }
  .bg-gray-50\\/50 {
    background-color: color-mix(in srgb, oklch(98.5% 0.002 247.839) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-gray-50) 50%, transparent);
    }
  }
  .bg-gray-900 {
    background-color: var(--color-gray-900);
  }
  .bg-green-50 {
    background-color: var(--color-green-50);
  }
  .bg-muted {
    background-color: var(--color-muted);
  }
  .bg-muted-foreground {
    background-color: var(--color-muted-foreground);
  }
  .bg-muted\\/50 {
    background-color: color-mix(in srgb, hsl(var(--muted)) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-muted) 50%, transparent);
    }
  }
  .bg-popover {
    background-color: var(--color-popover);
  }
  .bg-primary {
    background-color: var(--color-primary);
  }
  .bg-red-50 {
    background-color: var(--color-red-50);
  }
  .bg-red-100 {
    background-color: var(--color-red-100);
  }
  .bg-red-400 {
    background-color: var(--color-red-400);
  }
  .bg-red-500 {
    background-color: var(--color-red-500);
  }
  .bg-secondary {
    background-color: var(--color-secondary);
  }
  .bg-transparent {
    background-color: transparent;
  }
  .bg-white {
    background-color: var(--color-white);
  }
  .bg-yellow-50 {
    background-color: var(--color-yellow-50);
  }
  .bg-yellow-500 {
    background-color: var(--color-yellow-500);
  }
  .bg-zinc-100 {
    background-color: var(--color-zinc-100);
  }
  .fill-current {
    fill: currentcolor;
  }
  .object-contain {
    -o-object-fit: contain;
       object-fit: contain;
  }
  .object-cover {
    -o-object-fit: cover;
       object-fit: cover;
  }
  .object-right-bottom {
    -o-object-position: right bottom;
       object-position: right bottom;
  }
  .p-0 {
    padding: calc(var(--spacing) * 0);
  }
  .p-0\\.5 {
    padding: calc(var(--spacing) * 0.5);
  }
  .p-1 {
    padding: calc(var(--spacing) * 1);
  }
  .p-1\\.5 {
    padding: calc(var(--spacing) * 1.5);
  }
  .p-2 {
    padding: calc(var(--spacing) * 2);
  }
  .p-3 {
    padding: calc(var(--spacing) * 3);
  }
  .p-4 {
    padding: calc(var(--spacing) * 4);
  }
  .p-5 {
    padding: calc(var(--spacing) * 5);
  }
  .p-6 {
    padding: calc(var(--spacing) * 6);
  }
  .p-8 {
    padding: calc(var(--spacing) * 8);
  }
  .p-\\[1px\\] {
    padding: 1px;
  }
  .p-\\[5px\\] {
    padding: 5px;
  }
  .px-0 {
    padding-inline: calc(var(--spacing) * 0);
  }
  .px-1 {
    padding-inline: calc(var(--spacing) * 1);
  }
  .px-2 {
    padding-inline: calc(var(--spacing) * 2);
  }
  .px-2\\.5 {
    padding-inline: calc(var(--spacing) * 2.5);
  }
  .px-3 {
    padding-inline: calc(var(--spacing) * 3);
  }
  .px-4 {
    padding-inline: calc(var(--spacing) * 4);
  }
  .px-5 {
    padding-inline: calc(var(--spacing) * 5);
  }
  .px-6 {
    padding-inline: calc(var(--spacing) * 6);
  }
  .px-8 {
    padding-inline: calc(var(--spacing) * 8);
  }
  .py-0\\.5 {
    padding-block: calc(var(--spacing) * 0.5);
  }
  .py-1 {
    padding-block: calc(var(--spacing) * 1);
  }
  .py-1\\.5 {
    padding-block: calc(var(--spacing) * 1.5);
  }
  .py-2 {
    padding-block: calc(var(--spacing) * 2);
  }
  .py-3 {
    padding-block: calc(var(--spacing) * 3);
  }
  .py-4 {
    padding-block: calc(var(--spacing) * 4);
  }
  .py-5 {
    padding-block: calc(var(--spacing) * 5);
  }
  .py-6 {
    padding-block: calc(var(--spacing) * 6);
  }
  .py-8 {
    padding-block: calc(var(--spacing) * 8);
  }
  .py-12 {
    padding-block: calc(var(--spacing) * 12);
  }
  .py-\\[6px\\] {
    padding-block: 6px;
  }
  .py-\\[14px\\] {
    padding-block: 14px;
  }
  .pt-0 {
    padding-top: calc(var(--spacing) * 0);
  }
  .pt-1 {
    padding-top: calc(var(--spacing) * 1);
  }
  .pt-2 {
    padding-top: calc(var(--spacing) * 2);
  }
  .pt-4 {
    padding-top: calc(var(--spacing) * 4);
  }
  .pr-2 {
    padding-right: calc(var(--spacing) * 2);
  }
  .pr-2\\.5 {
    padding-right: calc(var(--spacing) * 2.5);
  }
  .pr-8 {
    padding-right: calc(var(--spacing) * 8);
  }
  .pb-0 {
    padding-bottom: calc(var(--spacing) * 0);
  }
  .pb-4 {
    padding-bottom: calc(var(--spacing) * 4);
  }
  .pl-1 {
    padding-left: calc(var(--spacing) * 1);
  }
  .pl-2 {
    padding-left: calc(var(--spacing) * 2);
  }
  .pl-2\\.5 {
    padding-left: calc(var(--spacing) * 2.5);
  }
  .pl-4 {
    padding-left: calc(var(--spacing) * 4);
  }
  .pl-8 {
    padding-left: calc(var(--spacing) * 8);
  }
  .text-center {
    text-align: center;
  }
  .text-left {
    text-align: left;
  }
  .align-middle {
    vertical-align: middle;
  }
  .font-mono {
    font-family: var(--font-mono);
  }
  .text-2xl {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
  }
  .text-3xl {
    font-size: var(--text-3xl);
    line-height: var(--tw-leading, var(--text-3xl--line-height));
  }
  .text-5xl {
    font-size: var(--text-5xl);
    line-height: var(--tw-leading, var(--text-5xl--line-height));
  }
  .text-base {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
  }
  .text-lg {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-xl {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
  }
  .text-xs {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .text-\\[0\\.8rem\\] {
    font-size: 0.8rem;
  }
  .text-\\[11px\\] {
    font-size: 11px;
  }
  .text-\\[14px\\] {
    font-size: 14px;
  }
  .text-\\[15px\\] {
    font-size: 15px;
  }
  .text-\\[20px\\] {
    font-size: 20px;
  }
  .leading-6 {
    --tw-leading: calc(var(--spacing) * 6);
    line-height: calc(var(--spacing) * 6);
  }
  .leading-6\\.5 {
    --tw-leading: calc(var(--spacing) * 6.5);
    line-height: calc(var(--spacing) * 6.5);
  }
  .leading-7 {
    --tw-leading: calc(var(--spacing) * 7);
    line-height: calc(var(--spacing) * 7);
  }
  .leading-none {
    --tw-leading: 1;
    line-height: 1;
  }
  .leading-normal {
    --tw-leading: var(--leading-normal);
    line-height: var(--leading-normal);
  }
  .leading-relaxed {
    --tw-leading: var(--leading-relaxed);
    line-height: var(--leading-relaxed);
  }
  .font-bold {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .font-extrabold {
    --tw-font-weight: var(--font-weight-extrabold);
    font-weight: var(--font-weight-extrabold);
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .font-normal {
    --tw-font-weight: var(--font-weight-normal);
    font-weight: var(--font-weight-normal);
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .tracking-tight {
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .tracking-wider {
    --tw-tracking: var(--tracking-wider);
    letter-spacing: var(--tracking-wider);
  }
  .tracking-widest {
    --tw-tracking: var(--tracking-widest);
    letter-spacing: var(--tracking-widest);
  }
  .text-balance {
    text-wrap: balance;
  }
  .text-nowrap {
    text-wrap: nowrap;
  }
  .text-wrap {
    text-wrap: wrap;
  }
  .break-words {
    overflow-wrap: break-word;
  }
  .break-all {
    word-break: break-all;
  }
  .text-ellipsis {
    text-overflow: ellipsis;
  }
  .whitespace-nowrap {
    white-space: nowrap;
  }
  .whitespace-pre-wrap {
    white-space: pre-wrap;
  }
  .text-accent-foreground {
    color: var(--color-accent-foreground);
  }
  .text-blue-500 {
    color: var(--color-blue-500);
  }
  .text-blue-600 {
    color: var(--color-blue-600);
  }
  .text-blue-700 {
    color: var(--color-blue-700);
  }
  .text-blue-900 {
    color: var(--color-blue-900);
  }
  .text-card-foreground {
    color: var(--color-card-foreground);
  }
  .text-current {
    color: currentcolor;
  }
  .text-destructive {
    color: var(--color-destructive);
  }
  .text-destructive-foreground {
    color: var(--color-destructive-foreground);
  }
  .text-foreground {
    color: var(--color-foreground);
  }
  .text-foreground\\/50 {
    color: color-mix(in srgb, hsl(var(--foreground)) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-foreground) 50%, transparent);
    }
  }
  .text-gray-400 {
    color: var(--color-gray-400);
  }
  .text-gray-500 {
    color: var(--color-gray-500);
  }
  .text-gray-600 {
    color: var(--color-gray-600);
  }
  .text-gray-700 {
    color: var(--color-gray-700);
  }
  .text-gray-900 {
    color: var(--color-gray-900);
  }
  .text-input {
    color: var(--color-input);
  }
  .text-muted-foreground {
    color: var(--color-muted-foreground);
  }
  .text-popover-foreground {
    color: var(--color-popover-foreground);
  }
  .text-primary {
    color: var(--color-primary);
  }
  .text-primary-foreground {
    color: var(--color-primary-foreground);
  }
  .text-red-500 {
    color: var(--color-red-500);
  }
  .text-red-600 {
    color: var(--color-red-600);
  }
  .text-red-700 {
    color: var(--color-red-700);
  }
  .text-secondary-foreground {
    color: var(--color-secondary-foreground);
  }
  .text-yellow-500 {
    color: var(--color-yellow-500);
  }
  .text-zinc-500 {
    color: var(--color-zinc-500);
  }
  .capitalize {
    text-transform: capitalize;
  }
  .lowercase {
    text-transform: lowercase;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .italic {
    font-style: italic;
  }
  .line-through {
    text-decoration-line: line-through;
  }
  .underline {
    text-decoration-line: underline;
  }
  .underline-offset-4 {
    text-underline-offset: 4px;
  }
  .opacity-0 {
    opacity: 0%;
  }
  .opacity-20 {
    opacity: 20%;
  }
  .opacity-25 {
    opacity: 25%;
  }
  .opacity-50 {
    opacity: 50%;
  }
  .opacity-60 {
    opacity: 60%;
  }
  .opacity-70 {
    opacity: 70%;
  }
  .opacity-75 {
    opacity: 75%;
  }
  .opacity-80 {
    opacity: 80%;
  }
  .opacity-90 {
    opacity: 90%;
  }
  .opacity-100 {
    opacity: 100%;
  }
  .shadow {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-lg {
    --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-md {
    --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-sm {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-0 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-2 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-ring {
    --tw-ring-color: var(--color-ring);
  }
  .ring-offset-background {
    --tw-ring-offset-color: var(--color-background);
  }
  .outline {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
  .blur {
    --tw-blur: blur(8px);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .drop-shadow {
    --tw-drop-shadow-size: drop-shadow(0 1px 2px var(--tw-drop-shadow-color, rgb(0 0 0 / 0.1))) drop-shadow(0 1px 1px var(--tw-drop-shadow-color, rgb(0 0 0 / 0.06)));
    --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow( 0 1px 1px rgb(0 0 0 / 0.06));
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .filter {
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .backdrop-blur-sm {
    --tw-backdrop-blur: blur(var(--blur-sm));
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .backdrop-filter {
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .transition {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, backdrop-filter, display, visibility, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-all {
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-colors {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-opacity {
    transition-property: opacity;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-transform {
    transition-property: transform, translate, scale, rotate;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .duration-200 {
    --tw-duration: 200ms;
    transition-duration: 200ms;
  }
  .duration-300 {
    --tw-duration: 300ms;
    transition-duration: 300ms;
  }
  .duration-1000 {
    --tw-duration: 1000ms;
    transition-duration: 1000ms;
  }
  .ease-in-out {
    --tw-ease: var(--ease-in-out);
    transition-timing-function: var(--ease-in-out);
  }
  .ease-out {
    --tw-ease: var(--ease-out);
    transition-timing-function: var(--ease-out);
  }
  .animate-in {
    animation-name: enter;
    animation-duration: 150ms;
    --tw-enter-opacity: initial;
    --tw-enter-scale: initial;
    --tw-enter-rotate: initial;
    --tw-enter-translate-x: initial;
    --tw-enter-translate-y: initial;
  }
  .animate-in {
    animation-name: enter;
    animation-duration: 150ms;
    --tw-enter-opacity: initial;
    --tw-enter-scale: initial;
    --tw-enter-rotate: initial;
    --tw-enter-translate-x: initial;
    --tw-enter-translate-y: initial;
  }
  .outline-none {
    --tw-outline-style: none;
    outline-style: none;
  }
  .select-all {
    -webkit-user-select: all;
    -moz-user-select: all;
         user-select: all;
  }
  .select-none {
    -webkit-user-select: none;
    -moz-user-select: none;
         user-select: none;
  }
  .\\[space\\:push-doc-update\\] {
    space: push-doc-update;
  }
  .duration-200 {
    animation-duration: 200ms;
  }
  .duration-200 {
    animation-duration: 200ms;
  }
  .duration-300 {
    animation-duration: 300ms;
  }
  .duration-300 {
    animation-duration: 300ms;
  }
  .duration-1000 {
    animation-duration: 1000ms;
  }
  .duration-1000 {
    animation-duration: 1000ms;
  }
  .ease-in-out {
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
  .ease-in-out {
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
  .ease-out {
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  .ease-out {
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  .fade-in-0 {
    --tw-enter-opacity: 0;
  }
  .fade-in-0 {
    --tw-enter-opacity: 0;
  }
  .fade-in-80 {
    --tw-enter-opacity: 0.8;
  }
  .fade-in-80 {
    --tw-enter-opacity: 0.8;
  }
  .paused {
    animation-play-state: paused;
  }
  .paused {
    animation-play-state: paused;
  }
  .running {
    animation-play-state: running;
  }
  .running {
    animation-play-state: running;
  }
  .zoom-in {
    --tw-enter-scale: 0;
  }
  .zoom-in {
    --tw-enter-scale: 0;
  }
  .zoom-in-95 {
    --tw-enter-scale: .95;
  }
  .zoom-in-95 {
    --tw-enter-scale: .95;
  }
  .zoom-out {
    --tw-exit-scale: 0;
  }
  .zoom-out {
    --tw-exit-scale: 0;
  }
  .\\*\\:visible {
    :is(& > *) {
      visibility: visible;
    }
  }
  .group-hover\\:opacity-100 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        opacity: 100%;
      }
    }
  }
  .group-data-\\[state\\=open\\]\\:rotate-180 {
    &:is(:where(.group)[data-state="open"] *) {
      rotate: 180deg;
    }
  }
  .group-\\[\\.destructive\\]\\:border-muted\\/40 {
    &:is(:where(.group):is(.destructive) *) {
      border-color: color-mix(in srgb, hsl(var(--muted)) 40%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        border-color: color-mix(in oklab, var(--color-muted) 40%, transparent);
      }
    }
  }
  .group-\\[\\.destructive\\]\\:text-red-300 {
    &:is(:where(.group):is(.destructive) *) {
      color: var(--color-red-300);
    }
  }
  .group-\\[\\.toast\\]\\:bg-muted {
    &:is(:where(.group):is(.toast) *) {
      background-color: var(--color-muted);
    }
  }
  .group-\\[\\.toast\\]\\:bg-primary {
    &:is(:where(.group):is(.toast) *) {
      background-color: var(--color-primary);
    }
  }
  .group-\\[\\.toast\\]\\:text-muted-foreground {
    &:is(:where(.group):is(.toast) *) {
      color: var(--color-muted-foreground);
    }
  }
  .group-\\[\\.toast\\]\\:text-primary-foreground {
    &:is(:where(.group):is(.toast) *) {
      color: var(--color-primary-foreground);
    }
  }
  .group-\\[\\.toaster\\]\\:border-border {
    &:is(:where(.group):is(.toaster) *) {
      border-color: var(--color-border);
    }
  }
  .group-\\[\\.toaster\\]\\:bg-background {
    &:is(:where(.group):is(.toaster) *) {
      background-color: var(--color-background);
    }
  }
  .group-\\[\\.toaster\\]\\:text-foreground {
    &:is(:where(.group):is(.toaster) *) {
      color: var(--color-foreground);
    }
  }
  .group-\\[\\.toaster\\]\\:shadow-lg {
    &:is(:where(.group):is(.toaster) *) {
      --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .peer-disabled\\:cursor-not-allowed {
    &:is(:where(.peer):disabled ~ *) {
      cursor: not-allowed;
    }
  }
  .peer-disabled\\:opacity-70 {
    &:is(:where(.peer):disabled ~ *) {
      opacity: 70%;
    }
  }
  .file\\:border-0 {
    &::file-selector-button {
      border-style: var(--tw-border-style);
      border-width: 0px;
    }
  }
  .file\\:bg-transparent {
    &::file-selector-button {
      background-color: transparent;
    }
  }
  .file\\:text-sm {
    &::file-selector-button {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
  }
  .file\\:font-medium {
    &::file-selector-button {
      --tw-font-weight: var(--font-weight-medium);
      font-weight: var(--font-weight-medium);
    }
  }
  .placeholder\\:text-muted-foreground {
    &::-moz-placeholder {
      color: var(--color-muted-foreground);
    }
    &::placeholder {
      color: var(--color-muted-foreground);
    }
  }
  .placeholder\\:opacity-50 {
    &::-moz-placeholder {
      opacity: 50%;
    }
    &::placeholder {
      opacity: 50%;
    }
  }
  .after\\:absolute {
    &::after {
      content: var(--tw-content);
      position: absolute;
    }
  }
  .after\\:inset-y-0 {
    &::after {
      content: var(--tw-content);
      inset-block: calc(var(--spacing) * 0);
    }
  }
  .after\\:left-1\\/2 {
    &::after {
      content: var(--tw-content);
      left: calc(1/2 * 100%);
    }
  }
  .after\\:w-1 {
    &::after {
      content: var(--tw-content);
      width: calc(var(--spacing) * 1);
    }
  }
  .after\\:-translate-x-1\\/2 {
    &::after {
      content: var(--tw-content);
      --tw-translate-x: calc(calc(1/2 * 100%) * -1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .first\\:rounded-l-md {
    &:first-child {
      border-top-left-radius: var(--radius-md);
      border-bottom-left-radius: var(--radius-md);
    }
  }
  .first\\:border-l {
    &:first-child {
      border-left-style: var(--tw-border-style);
      border-left-width: 1px;
    }
  }
  .last\\:rounded-r-md {
    &:last-child {
      border-top-right-radius: var(--radius-md);
      border-bottom-right-radius: var(--radius-md);
    }
  }
  .focus-within\\:relative {
    &:focus-within {
      position: relative;
    }
  }
  .focus-within\\:z-20 {
    &:focus-within {
      z-index: 20;
    }
  }
  .hover\\:scale-105 {
    &:hover {
      @media (hover: hover) {
        --tw-scale-x: 105%;
        --tw-scale-y: 105%;
        --tw-scale-z: 105%;
        scale: var(--tw-scale-x) var(--tw-scale-y);
      }
    }
  }
  .hover\\:border-gray-100 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-gray-100);
      }
    }
  }
  .hover\\:border-gray-200 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-gray-200);
      }
    }
  }
  .hover\\:bg-accent {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-accent);
      }
    }
  }
  .hover\\:bg-blue-50 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-blue-50);
      }
    }
  }
  .hover\\:bg-blue-100 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-blue-100);
      }
    }
  }
  .hover\\:bg-blue-200 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-blue-200);
      }
    }
  }
  .hover\\:bg-destructive\\/80 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, hsl(var(--destructive)) 80%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-destructive) 80%, transparent);
        }
      }
    }
  }
  .hover\\:bg-destructive\\/90 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, hsl(var(--destructive)) 90%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-destructive) 90%, transparent);
        }
      }
    }
  }
  .hover\\:bg-gray-50 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-50);
      }
    }
  }
  .hover\\:bg-gray-100 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-100);
      }
    }
  }
  .hover\\:bg-gray-200 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-200);
      }
    }
  }
  .hover\\:bg-muted {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-muted);
      }
    }
  }
  .hover\\:bg-muted\\/50 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, hsl(var(--muted)) 50%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-muted) 50%, transparent);
        }
      }
    }
  }
  .hover\\:bg-primary {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-primary);
      }
    }
  }
  .hover\\:bg-primary\\/80 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, hsl(var(--primary)) 80%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-primary) 80%, transparent);
        }
      }
    }
  }
  .hover\\:bg-primary\\/90 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, hsl(var(--primary)) 90%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-primary) 90%, transparent);
        }
      }
    }
  }
  .hover\\:bg-red-50 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-red-50);
      }
    }
  }
  .hover\\:bg-red-100 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-red-100);
      }
    }
  }
  .hover\\:bg-red-200 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-red-200);
      }
    }
  }
  .hover\\:bg-secondary {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-secondary);
      }
    }
  }
  .hover\\:bg-secondary\\/80 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, hsl(var(--secondary)) 80%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-secondary) 80%, transparent);
        }
      }
    }
  }
  .hover\\:text-accent-foreground {
    &:hover {
      @media (hover: hover) {
        color: var(--color-accent-foreground);
      }
    }
  }
  .hover\\:text-foreground {
    &:hover {
      @media (hover: hover) {
        color: var(--color-foreground);
      }
    }
  }
  .hover\\:text-muted-foreground {
    &:hover {
      @media (hover: hover) {
        color: var(--color-muted-foreground);
      }
    }
  }
  .hover\\:text-primary-foreground {
    &:hover {
      @media (hover: hover) {
        color: var(--color-primary-foreground);
      }
    }
  }
  .hover\\:text-red-500 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-red-500);
      }
    }
  }
  .hover\\:underline {
    &:hover {
      @media (hover: hover) {
        text-decoration-line: underline;
      }
    }
  }
  .hover\\:opacity-100 {
    &:hover {
      @media (hover: hover) {
        opacity: 100%;
      }
    }
  }
  .hover\\:shadow-md {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .hover\\:shadow-sm {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30 {
    &:is(:where(.group):is(.destructive) *) {
      &:hover {
        @media (hover: hover) {
          border-color: color-mix(in srgb, hsl(var(--destructive)) 30%, transparent);
          @supports (color: color-mix(in lab, red, red)) {
            border-color: color-mix(in oklab, var(--color-destructive) 30%, transparent);
          }
        }
      }
    }
  }
  .group-\\[\\.destructive\\]\\:hover\\:bg-destructive {
    &:is(:where(.group):is(.destructive) *) {
      &:hover {
        @media (hover: hover) {
          background-color: var(--color-destructive);
        }
      }
    }
  }
  .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground {
    &:is(:where(.group):is(.destructive) *) {
      &:hover {
        @media (hover: hover) {
          color: var(--color-destructive-foreground);
        }
      }
    }
  }
  .group-\\[\\.destructive\\]\\:hover\\:text-red-50 {
    &:is(:where(.group):is(.destructive) *) {
      &:hover {
        @media (hover: hover) {
          color: var(--color-red-50);
        }
      }
    }
  }
  .focus\\:bg-accent {
    &:focus {
      background-color: var(--color-accent);
    }
  }
  .focus\\:bg-primary {
    &:focus {
      background-color: var(--color-primary);
    }
  }
  .focus\\:text-accent-foreground {
    &:focus {
      color: var(--color-accent-foreground);
    }
  }
  .focus\\:text-primary-foreground {
    &:focus {
      color: var(--color-primary-foreground);
    }
  }
  .focus\\:text-red-500 {
    &:focus {
      color: var(--color-red-500);
    }
  }
  .focus\\:opacity-100 {
    &:focus {
      opacity: 100%;
    }
  }
  .focus\\:ring-2 {
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus\\:ring-ring {
    &:focus {
      --tw-ring-color: var(--color-ring);
    }
  }
  .focus\\:ring-offset-2 {
    &:focus {
      --tw-ring-offset-width: 2px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    }
  }
  .focus\\:outline-none {
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .group-\\[\\.destructive\\]\\:focus\\:ring-destructive {
    &:is(:where(.group):is(.destructive) *) {
      &:focus {
        --tw-ring-color: var(--color-destructive);
      }
    }
  }
  .group-\\[\\.destructive\\]\\:focus\\:ring-red-400 {
    &:is(:where(.group):is(.destructive) *) {
      &:focus {
        --tw-ring-color: var(--color-red-400);
      }
    }
  }
  .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600 {
    &:is(:where(.group):is(.destructive) *) {
      &:focus {
        --tw-ring-offset-color: var(--color-red-600);
      }
    }
  }
  .focus-visible\\:ring-1 {
    &:focus-visible {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus-visible\\:ring-2 {
    &:focus-visible {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus-visible\\:ring-ring {
    &:focus-visible {
      --tw-ring-color: var(--color-ring);
    }
  }
  .focus-visible\\:ring-offset-1 {
    &:focus-visible {
      --tw-ring-offset-width: 1px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    }
  }
  .focus-visible\\:ring-offset-2 {
    &:focus-visible {
      --tw-ring-offset-width: 2px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    }
  }
  .focus-visible\\:ring-offset-background {
    &:focus-visible {
      --tw-ring-offset-color: var(--color-background);
    }
  }
  .focus-visible\\:outline-none {
    &:focus-visible {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .disabled\\:pointer-events-none {
    &:disabled {
      pointer-events: none;
    }
  }
  .disabled\\:cursor-not-allowed {
    &:disabled {
      cursor: not-allowed;
    }
  }
  .disabled\\:opacity-50 {
    &:disabled {
      opacity: 50%;
    }
  }
  .has-\\[\\:disabled\\]\\:opacity-50 {
    &:has(*:is(:disabled)) {
      opacity: 50%;
    }
  }
  .aria-selected\\:bg-accent {
    &[aria-selected="true"] {
      background-color: var(--color-accent);
    }
  }
  .aria-selected\\:bg-accent\\/50 {
    &[aria-selected="true"] {
      background-color: color-mix(in srgb, hsl(var(--accent)) 50%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-accent) 50%, transparent);
      }
    }
  }
  .aria-selected\\:text-accent-foreground {
    &[aria-selected="true"] {
      color: var(--color-accent-foreground);
    }
  }
  .aria-selected\\:text-muted-foreground {
    &[aria-selected="true"] {
      color: var(--color-muted-foreground);
    }
  }
  .aria-selected\\:opacity-30 {
    &[aria-selected="true"] {
      opacity: 30%;
    }
  }
  .aria-selected\\:opacity-100 {
    &[aria-selected="true"] {
      opacity: 100%;
    }
  }
  .data-\\[active\\]\\:bg-accent\\/50 {
    &[data-active] {
      background-color: color-mix(in srgb, hsl(var(--accent)) 50%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-accent) 50%, transparent);
      }
    }
  }
  .data-\\[disabled\\]\\:pointer-events-none {
    &[data-disabled] {
      pointer-events: none;
    }
  }
  .data-\\[disabled\\]\\:opacity-50 {
    &[data-disabled] {
      opacity: 50%;
    }
  }
  .data-\\[disabled\\=true\\]\\:pointer-events-none {
    &[data-disabled="true"] {
      pointer-events: none;
    }
  }
  .data-\\[disabled\\=true\\]\\:opacity-50 {
    &[data-disabled="true"] {
      opacity: 50%;
    }
  }
  .data-\\[motion\\=from-end\\]\\:slide-in-from-right-52 {
    &[data-motion="from-end"] {
      --tw-enter-translate-x: 13rem;
    }
  }
  .data-\\[motion\\=from-end\\]\\:slide-in-from-right-52 {
    &[data-motion="from-end"] {
      --tw-enter-translate-x: 13rem;
    }
  }
  .data-\\[motion\\=from-start\\]\\:slide-in-from-left-52 {
    &[data-motion="from-start"] {
      --tw-enter-translate-x: -13rem;
    }
  }
  .data-\\[motion\\=from-start\\]\\:slide-in-from-left-52 {
    &[data-motion="from-start"] {
      --tw-enter-translate-x: -13rem;
    }
  }
  .data-\\[motion\\=to-end\\]\\:slide-out-to-right-52 {
    &[data-motion="to-end"] {
      --tw-exit-translate-x: 13rem;
    }
  }
  .data-\\[motion\\=to-end\\]\\:slide-out-to-right-52 {
    &[data-motion="to-end"] {
      --tw-exit-translate-x: 13rem;
    }
  }
  .data-\\[motion\\=to-start\\]\\:slide-out-to-left-52 {
    &[data-motion="to-start"] {
      --tw-exit-translate-x: -13rem;
    }
  }
  .data-\\[motion\\=to-start\\]\\:slide-out-to-left-52 {
    &[data-motion="to-start"] {
      --tw-exit-translate-x: -13rem;
    }
  }
  .data-\\[motion\\^\\=from-\\]\\:animate-in {
    &[data-motion^="from-"] {
      animation-name: enter;
      animation-duration: 150ms;
      --tw-enter-opacity: initial;
      --tw-enter-scale: initial;
      --tw-enter-rotate: initial;
      --tw-enter-translate-x: initial;
      --tw-enter-translate-y: initial;
    }
  }
  .data-\\[motion\\^\\=from-\\]\\:animate-in {
    &[data-motion^="from-"] {
      animation-name: enter;
      animation-duration: 150ms;
      --tw-enter-opacity: initial;
      --tw-enter-scale: initial;
      --tw-enter-rotate: initial;
      --tw-enter-translate-x: initial;
      --tw-enter-translate-y: initial;
    }
  }
  .data-\\[motion\\^\\=from-\\]\\:fade-in {
    &[data-motion^="from-"] {
      --tw-enter-opacity: 0;
    }
  }
  .data-\\[motion\\^\\=from-\\]\\:fade-in {
    &[data-motion^="from-"] {
      --tw-enter-opacity: 0;
    }
  }
  .data-\\[motion\\^\\=to-\\]\\:animate-out {
    &[data-motion^="to-"] {
      animation-name: exit;
      animation-duration: 150ms;
      --tw-exit-opacity: initial;
      --tw-exit-scale: initial;
      --tw-exit-rotate: initial;
      --tw-exit-translate-x: initial;
      --tw-exit-translate-y: initial;
    }
  }
  .data-\\[motion\\^\\=to-\\]\\:animate-out {
    &[data-motion^="to-"] {
      animation-name: exit;
      animation-duration: 150ms;
      --tw-exit-opacity: initial;
      --tw-exit-scale: initial;
      --tw-exit-rotate: initial;
      --tw-exit-translate-x: initial;
      --tw-exit-translate-y: initial;
    }
  }
  .data-\\[motion\\^\\=to-\\]\\:fade-out {
    &[data-motion^="to-"] {
      --tw-exit-opacity: 0;
    }
  }
  .data-\\[motion\\^\\=to-\\]\\:fade-out {
    &[data-motion^="to-"] {
      --tw-exit-opacity: 0;
    }
  }
  .data-\\[panel-group-direction\\=vertical\\]\\:h-px {
    &[data-panel-group-direction="vertical"] {
      height: 1px;
    }
  }
  .data-\\[panel-group-direction\\=vertical\\]\\:w-full {
    &[data-panel-group-direction="vertical"] {
      width: 100%;
    }
  }
  .data-\\[panel-group-direction\\=vertical\\]\\:flex-col {
    &[data-panel-group-direction="vertical"] {
      flex-direction: column;
    }
  }
  .data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0 {
    &[data-panel-group-direction="vertical"] {
      &::after {
        content: var(--tw-content);
        left: calc(var(--spacing) * 0);
      }
    }
  }
  .data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1 {
    &[data-panel-group-direction="vertical"] {
      &::after {
        content: var(--tw-content);
        height: calc(var(--spacing) * 1);
      }
    }
  }
  .data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full {
    &[data-panel-group-direction="vertical"] {
      &::after {
        content: var(--tw-content);
        width: 100%;
      }
    }
  }
  .data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0 {
    &[data-panel-group-direction="vertical"] {
      &::after {
        content: var(--tw-content);
        --tw-translate-x: calc(var(--spacing) * 0);
        translate: var(--tw-translate-x) var(--tw-translate-y);
      }
    }
  }
  .data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2 {
    &[data-panel-group-direction="vertical"] {
      &::after {
        content: var(--tw-content);
        --tw-translate-y: calc(calc(1/2 * 100%) * -1);
        translate: var(--tw-translate-x) var(--tw-translate-y);
      }
    }
  }
  .data-\\[selected\\=true\\]\\:bg-accent {
    &[data-selected="true"] {
      background-color: var(--color-accent);
    }
  }
  .data-\\[selected\\=true\\]\\:text-accent-foreground {
    &[data-selected="true"] {
      color: var(--color-accent-foreground);
    }
  }
  .data-\\[side\\=bottom\\]\\:translate-y-1 {
    &[data-side="bottom"] {
      --tw-translate-y: calc(var(--spacing) * 1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .data-\\[side\\=bottom\\]\\:slide-in-from-top-2 {
    &[data-side="bottom"] {
      --tw-enter-translate-y: -0.5rem;
    }
  }
  .data-\\[side\\=bottom\\]\\:slide-in-from-top-2 {
    &[data-side="bottom"] {
      --tw-enter-translate-y: -0.5rem;
    }
  }
  .data-\\[side\\=left\\]\\:-translate-x-1 {
    &[data-side="left"] {
      --tw-translate-x: calc(var(--spacing) * -1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .data-\\[side\\=left\\]\\:slide-in-from-right-2 {
    &[data-side="left"] {
      --tw-enter-translate-x: 0.5rem;
    }
  }
  .data-\\[side\\=left\\]\\:slide-in-from-right-2 {
    &[data-side="left"] {
      --tw-enter-translate-x: 0.5rem;
    }
  }
  .data-\\[side\\=right\\]\\:translate-x-1 {
    &[data-side="right"] {
      --tw-translate-x: calc(var(--spacing) * 1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .data-\\[side\\=right\\]\\:slide-in-from-left-2 {
    &[data-side="right"] {
      --tw-enter-translate-x: -0.5rem;
    }
  }
  .data-\\[side\\=right\\]\\:slide-in-from-left-2 {
    &[data-side="right"] {
      --tw-enter-translate-x: -0.5rem;
    }
  }
  .data-\\[side\\=top\\]\\:-translate-y-1 {
    &[data-side="top"] {
      --tw-translate-y: calc(var(--spacing) * -1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .data-\\[side\\=top\\]\\:slide-in-from-bottom-2 {
    &[data-side="top"] {
      --tw-enter-translate-y: 0.5rem;
    }
  }
  .data-\\[side\\=top\\]\\:slide-in-from-bottom-2 {
    &[data-side="top"] {
      --tw-enter-translate-y: 0.5rem;
    }
  }
  .data-\\[state\\=active\\]\\:bg-background {
    &[data-state="active"] {
      background-color: var(--color-background);
    }
  }
  .data-\\[state\\=active\\]\\:text-foreground {
    &[data-state="active"] {
      color: var(--color-foreground);
    }
  }
  .data-\\[state\\=active\\]\\:shadow-sm {
    &[data-state="active"] {
      --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .data-\\[state\\=checked\\]\\:translate-x-5 {
    &[data-state="checked"] {
      --tw-translate-x: calc(var(--spacing) * 5);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .data-\\[state\\=checked\\]\\:bg-primary {
    &[data-state="checked"] {
      background-color: var(--color-primary);
    }
  }
  .data-\\[state\\=checked\\]\\:text-primary-foreground {
    &[data-state="checked"] {
      color: var(--color-primary-foreground);
    }
  }
  .data-\\[state\\=closed\\]\\:animate-accordion-up {
    &[data-state="closed"] {
      animation: var(--animate-accordion-up);
    }
  }
  .data-\\[state\\=closed\\]\\:duration-300 {
    &[data-state="closed"] {
      --tw-duration: 300ms;
      transition-duration: 300ms;
    }
  }
  .data-\\[state\\=closed\\]\\:animate-out {
    &[data-state="closed"] {
      animation-name: exit;
      animation-duration: 150ms;
      --tw-exit-opacity: initial;
      --tw-exit-scale: initial;
      --tw-exit-rotate: initial;
      --tw-exit-translate-x: initial;
      --tw-exit-translate-y: initial;
    }
  }
  .data-\\[state\\=closed\\]\\:animate-out {
    &[data-state="closed"] {
      animation-name: exit;
      animation-duration: 150ms;
      --tw-exit-opacity: initial;
      --tw-exit-scale: initial;
      --tw-exit-rotate: initial;
      --tw-exit-translate-x: initial;
      --tw-exit-translate-y: initial;
    }
  }
  .data-\\[state\\=closed\\]\\:duration-300 {
    &[data-state="closed"] {
      animation-duration: 300ms;
    }
  }
  .data-\\[state\\=closed\\]\\:duration-300 {
    &[data-state="closed"] {
      animation-duration: 300ms;
    }
  }
  .data-\\[state\\=closed\\]\\:fade-out-0 {
    &[data-state="closed"] {
      --tw-exit-opacity: 0;
    }
  }
  .data-\\[state\\=closed\\]\\:fade-out-0 {
    &[data-state="closed"] {
      --tw-exit-opacity: 0;
    }
  }
  .data-\\[state\\=closed\\]\\:fade-out-80 {
    &[data-state="closed"] {
      --tw-exit-opacity: 0.8;
    }
  }
  .data-\\[state\\=closed\\]\\:fade-out-80 {
    &[data-state="closed"] {
      --tw-exit-opacity: 0.8;
    }
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-bottom {
    &[data-state="closed"] {
      --tw-exit-translate-y: 100%;
    }
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-bottom {
    &[data-state="closed"] {
      --tw-exit-translate-y: 100%;
    }
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-left {
    &[data-state="closed"] {
      --tw-exit-translate-x: -100%;
    }
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-left {
    &[data-state="closed"] {
      --tw-exit-translate-x: -100%;
    }
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2 {
    &[data-state="closed"] {
      --tw-exit-translate-x: -50%;
    }
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2 {
    &[data-state="closed"] {
      --tw-exit-translate-x: -50%;
    }
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-right {
    &[data-state="closed"] {
      --tw-exit-translate-x: 100%;
    }
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-right {
    &[data-state="closed"] {
      --tw-exit-translate-x: 100%;
    }
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-right-full {
    &[data-state="closed"] {
      --tw-exit-translate-x: 100%;
    }
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-right-full {
    &[data-state="closed"] {
      --tw-exit-translate-x: 100%;
    }
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-top {
    &[data-state="closed"] {
      --tw-exit-translate-y: -100%;
    }
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-top {
    &[data-state="closed"] {
      --tw-exit-translate-y: -100%;
    }
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\] {
    &[data-state="closed"] {
      --tw-exit-translate-y: -48%;
    }
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\] {
    &[data-state="closed"] {
      --tw-exit-translate-y: -48%;
    }
  }
  .data-\\[state\\=closed\\]\\:zoom-out-95 {
    &[data-state="closed"] {
      --tw-exit-scale: .95;
    }
  }
  .data-\\[state\\=closed\\]\\:zoom-out-95 {
    &[data-state="closed"] {
      --tw-exit-scale: .95;
    }
  }
  .data-\\[state\\=hidden\\]\\:animate-out {
    &[data-state="hidden"] {
      animation-name: exit;
      animation-duration: 150ms;
      --tw-exit-opacity: initial;
      --tw-exit-scale: initial;
      --tw-exit-rotate: initial;
      --tw-exit-translate-x: initial;
      --tw-exit-translate-y: initial;
    }
  }
  .data-\\[state\\=hidden\\]\\:animate-out {
    &[data-state="hidden"] {
      animation-name: exit;
      animation-duration: 150ms;
      --tw-exit-opacity: initial;
      --tw-exit-scale: initial;
      --tw-exit-rotate: initial;
      --tw-exit-translate-x: initial;
      --tw-exit-translate-y: initial;
    }
  }
  .data-\\[state\\=hidden\\]\\:fade-out {
    &[data-state="hidden"] {
      --tw-exit-opacity: 0;
    }
  }
  .data-\\[state\\=hidden\\]\\:fade-out {
    &[data-state="hidden"] {
      --tw-exit-opacity: 0;
    }
  }
  .data-\\[state\\=on\\]\\:bg-accent {
    &[data-state="on"] {
      background-color: var(--color-accent);
    }
  }
  .data-\\[state\\=on\\]\\:text-accent-foreground {
    &[data-state="on"] {
      color: var(--color-accent-foreground);
    }
  }
  .data-\\[state\\=open\\]\\:animate-accordion-down {
    &[data-state="open"] {
      animation: var(--animate-accordion-down);
    }
  }
  .data-\\[state\\=open\\]\\:bg-accent {
    &[data-state="open"] {
      background-color: var(--color-accent);
    }
  }
  .data-\\[state\\=open\\]\\:bg-accent\\/50 {
    &[data-state="open"] {
      background-color: color-mix(in srgb, hsl(var(--accent)) 50%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-accent) 50%, transparent);
      }
    }
  }
  .data-\\[state\\=open\\]\\:bg-muted {
    &[data-state="open"] {
      background-color: var(--color-muted);
    }
  }
  .data-\\[state\\=open\\]\\:bg-secondary {
    &[data-state="open"] {
      background-color: var(--color-secondary);
    }
  }
  .data-\\[state\\=open\\]\\:text-accent-foreground {
    &[data-state="open"] {
      color: var(--color-accent-foreground);
    }
  }
  .data-\\[state\\=open\\]\\:text-muted-foreground {
    &[data-state="open"] {
      color: var(--color-muted-foreground);
    }
  }
  .data-\\[state\\=open\\]\\:duration-500 {
    &[data-state="open"] {
      --tw-duration: 500ms;
      transition-duration: 500ms;
    }
  }
  .data-\\[state\\=open\\]\\:animate-in {
    &[data-state="open"] {
      animation-name: enter;
      animation-duration: 150ms;
      --tw-enter-opacity: initial;
      --tw-enter-scale: initial;
      --tw-enter-rotate: initial;
      --tw-enter-translate-x: initial;
      --tw-enter-translate-y: initial;
    }
  }
  .data-\\[state\\=open\\]\\:animate-in {
    &[data-state="open"] {
      animation-name: enter;
      animation-duration: 150ms;
      --tw-enter-opacity: initial;
      --tw-enter-scale: initial;
      --tw-enter-rotate: initial;
      --tw-enter-translate-x: initial;
      --tw-enter-translate-y: initial;
    }
  }
  .data-\\[state\\=open\\]\\:duration-500 {
    &[data-state="open"] {
      animation-duration: 500ms;
    }
  }
  .data-\\[state\\=open\\]\\:duration-500 {
    &[data-state="open"] {
      animation-duration: 500ms;
    }
  }
  .data-\\[state\\=open\\]\\:fade-in-0 {
    &[data-state="open"] {
      --tw-enter-opacity: 0;
    }
  }
  .data-\\[state\\=open\\]\\:fade-in-0 {
    &[data-state="open"] {
      --tw-enter-opacity: 0;
    }
  }
  .data-\\[state\\=open\\]\\:slide-in-from-bottom {
    &[data-state="open"] {
      --tw-enter-translate-y: 100%;
    }
  }
  .data-\\[state\\=open\\]\\:slide-in-from-bottom {
    &[data-state="open"] {
      --tw-enter-translate-y: 100%;
    }
  }
  .data-\\[state\\=open\\]\\:slide-in-from-left {
    &[data-state="open"] {
      --tw-enter-translate-x: -100%;
    }
  }
  .data-\\[state\\=open\\]\\:slide-in-from-left {
    &[data-state="open"] {
      --tw-enter-translate-x: -100%;
    }
  }
  .data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2 {
    &[data-state="open"] {
      --tw-enter-translate-x: -50%;
    }
  }
  .data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2 {
    &[data-state="open"] {
      --tw-enter-translate-x: -50%;
    }
  }
  .data-\\[state\\=open\\]\\:slide-in-from-right {
    &[data-state="open"] {
      --tw-enter-translate-x: 100%;
    }
  }
  .data-\\[state\\=open\\]\\:slide-in-from-right {
    &[data-state="open"] {
      --tw-enter-translate-x: 100%;
    }
  }
  .data-\\[state\\=open\\]\\:slide-in-from-top {
    &[data-state="open"] {
      --tw-enter-translate-y: -100%;
    }
  }
  .data-\\[state\\=open\\]\\:slide-in-from-top {
    &[data-state="open"] {
      --tw-enter-translate-y: -100%;
    }
  }
  .data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\] {
    &[data-state="open"] {
      --tw-enter-translate-y: -48%;
    }
  }
  .data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\] {
    &[data-state="open"] {
      --tw-enter-translate-y: -48%;
    }
  }
  .data-\\[state\\=open\\]\\:slide-in-from-top-full {
    &[data-state="open"] {
      --tw-enter-translate-y: -100%;
    }
  }
  .data-\\[state\\=open\\]\\:slide-in-from-top-full {
    &[data-state="open"] {
      --tw-enter-translate-y: -100%;
    }
  }
  .data-\\[state\\=open\\]\\:zoom-in-90 {
    &[data-state="open"] {
      --tw-enter-scale: .9;
    }
  }
  .data-\\[state\\=open\\]\\:zoom-in-90 {
    &[data-state="open"] {
      --tw-enter-scale: .9;
    }
  }
  .data-\\[state\\=open\\]\\:zoom-in-95 {
    &[data-state="open"] {
      --tw-enter-scale: .95;
    }
  }
  .data-\\[state\\=open\\]\\:zoom-in-95 {
    &[data-state="open"] {
      --tw-enter-scale: .95;
    }
  }
  .data-\\[state\\=selected\\]\\:bg-muted {
    &[data-state="selected"] {
      background-color: var(--color-muted);
    }
  }
  .data-\\[state\\=unchecked\\]\\:translate-x-0 {
    &[data-state="unchecked"] {
      --tw-translate-x: calc(var(--spacing) * 0);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .data-\\[state\\=unchecked\\]\\:bg-input {
    &[data-state="unchecked"] {
      background-color: var(--color-input);
    }
  }
  .data-\\[state\\=visible\\]\\:animate-in {
    &[data-state="visible"] {
      animation-name: enter;
      animation-duration: 150ms;
      --tw-enter-opacity: initial;
      --tw-enter-scale: initial;
      --tw-enter-rotate: initial;
      --tw-enter-translate-x: initial;
      --tw-enter-translate-y: initial;
    }
  }
  .data-\\[state\\=visible\\]\\:animate-in {
    &[data-state="visible"] {
      animation-name: enter;
      animation-duration: 150ms;
      --tw-enter-opacity: initial;
      --tw-enter-scale: initial;
      --tw-enter-rotate: initial;
      --tw-enter-translate-x: initial;
      --tw-enter-translate-y: initial;
    }
  }
  .data-\\[state\\=visible\\]\\:fade-in {
    &[data-state="visible"] {
      --tw-enter-opacity: 0;
    }
  }
  .data-\\[state\\=visible\\]\\:fade-in {
    &[data-state="visible"] {
      --tw-enter-opacity: 0;
    }
  }
  .data-\\[swipe\\=cancel\\]\\:translate-x-0 {
    &[data-swipe="cancel"] {
      --tw-translate-x: calc(var(--spacing) * 0);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\] {
    &[data-swipe="end"] {
      --tw-translate-x: var(--radix-toast-swipe-end-x);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .data-\\[swipe\\=end\\]\\:animate-out {
    &[data-swipe="end"] {
      animation-name: exit;
      animation-duration: 150ms;
      --tw-exit-opacity: initial;
      --tw-exit-scale: initial;
      --tw-exit-rotate: initial;
      --tw-exit-translate-x: initial;
      --tw-exit-translate-y: initial;
    }
  }
  .data-\\[swipe\\=end\\]\\:animate-out {
    &[data-swipe="end"] {
      animation-name: exit;
      animation-duration: 150ms;
      --tw-exit-opacity: initial;
      --tw-exit-scale: initial;
      --tw-exit-rotate: initial;
      --tw-exit-translate-x: initial;
      --tw-exit-translate-y: initial;
    }
  }
  .data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\] {
    &[data-swipe="move"] {
      --tw-translate-x: var(--radix-toast-swipe-move-x);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .data-\\[swipe\\=move\\]\\:transition-none {
    &[data-swipe="move"] {
      transition-property: none;
    }
  }
  .max-lg\\:mt-5 {
    @media (width < 64rem) {
      margin-top: calc(var(--spacing) * 5);
    }
  }
  .max-lg\\:mt-16 {
    @media (width < 64rem) {
      margin-top: calc(var(--spacing) * 16);
    }
  }
  .max-lg\\:items-center {
    @media (width < 64rem) {
      align-items: center;
    }
  }
  .max-lg\\:p-4 {
    @media (width < 64rem) {
      padding: calc(var(--spacing) * 4);
    }
  }
  .max-lg\\:px-4 {
    @media (width < 64rem) {
      padding-inline: calc(var(--spacing) * 4);
    }
  }
  .max-lg\\:text-3xl {
    @media (width < 64rem) {
      font-size: var(--text-3xl);
      line-height: var(--tw-leading, var(--text-3xl--line-height));
    }
  }
  .max-lg\\:text-lg {
    @media (width < 64rem) {
      font-size: var(--text-lg);
      line-height: var(--tw-leading, var(--text-lg--line-height));
    }
  }
  .max-lg\\:font-bold {
    @media (width < 64rem) {
      --tw-font-weight: var(--font-weight-bold);
      font-weight: var(--font-weight-bold);
    }
  }
  .max-md\\:mt-5 {
    @media (width < 48rem) {
      margin-top: calc(var(--spacing) * 5);
    }
  }
  .max-md\\:hidden {
    @media (width < 48rem) {
      display: none;
    }
  }
  .max-sm\\:mb-6 {
    @media (width < 40rem) {
      margin-bottom: calc(var(--spacing) * 6);
    }
  }
  .sm\\:top-auto {
    @media (width >= 40rem) {
      top: auto;
    }
  }
  .sm\\:right-0 {
    @media (width >= 40rem) {
      right: calc(var(--spacing) * 0);
    }
  }
  .sm\\:bottom-0 {
    @media (width >= 40rem) {
      bottom: calc(var(--spacing) * 0);
    }
  }
  .sm\\:mt-0 {
    @media (width >= 40rem) {
      margin-top: calc(var(--spacing) * 0);
    }
  }
  .sm\\:mb-0 {
    @media (width >= 40rem) {
      margin-bottom: calc(var(--spacing) * 0);
    }
  }
  .sm\\:w-\\[460px\\] {
    @media (width >= 40rem) {
      width: 460px;
    }
  }
  .sm\\:w-auto {
    @media (width >= 40rem) {
      width: auto;
    }
  }
  .sm\\:max-w-\\[425px\\] {
    @media (width >= 40rem) {
      max-width: 425px;
    }
  }
  .sm\\:max-w-\\[460px\\] {
    @media (width >= 40rem) {
      max-width: 460px;
    }
  }
  .sm\\:max-w-\\[480px\\] {
    @media (width >= 40rem) {
      max-width: 480px;
    }
  }
  .sm\\:max-w-\\[720px\\] {
    @media (width >= 40rem) {
      max-width: 720px;
    }
  }
  .sm\\:max-w-sm {
    @media (width >= 40rem) {
      max-width: var(--container-sm);
    }
  }
  .sm\\:flex-col {
    @media (width >= 40rem) {
      flex-direction: column;
    }
  }
  .sm\\:flex-row {
    @media (width >= 40rem) {
      flex-direction: row;
    }
  }
  .sm\\:justify-between {
    @media (width >= 40rem) {
      justify-content: space-between;
    }
  }
  .sm\\:justify-end {
    @media (width >= 40rem) {
      justify-content: flex-end;
    }
  }
  .sm\\:gap-2\\.5 {
    @media (width >= 40rem) {
      gap: calc(var(--spacing) * 2.5);
    }
  }
  .sm\\:space-y-0 {
    @media (width >= 40rem) {
      :where(& > :not(:last-child)) {
        --tw-space-y-reverse: 0;
        margin-block-start: calc(calc(var(--spacing) * 0) * var(--tw-space-y-reverse));
        margin-block-end: calc(calc(var(--spacing) * 0) * calc(1 - var(--tw-space-y-reverse)));
      }
    }
  }
  .sm\\:space-x-2 {
    @media (width >= 40rem) {
      :where(& > :not(:last-child)) {
        --tw-space-x-reverse: 0;
        margin-inline-start: calc(calc(var(--spacing) * 2) * var(--tw-space-x-reverse));
        margin-inline-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-x-reverse)));
      }
    }
  }
  .sm\\:space-x-4 {
    @media (width >= 40rem) {
      :where(& > :not(:last-child)) {
        --tw-space-x-reverse: 0;
        margin-inline-start: calc(calc(var(--spacing) * 4) * var(--tw-space-x-reverse));
        margin-inline-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-x-reverse)));
      }
    }
  }
  .sm\\:rounded-lg {
    @media (width >= 40rem) {
      border-radius: var(--radius-lg);
    }
  }
  .sm\\:text-left {
    @media (width >= 40rem) {
      text-align: left;
    }
  }
  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full {
    &[data-state="open"] {
      @media (width >= 40rem) {
        --tw-enter-translate-y: 100%;
      }
    }
  }
  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full {
    &[data-state="open"] {
      @media (width >= 40rem) {
        --tw-enter-translate-y: 100%;
      }
    }
  }
  .md\\:absolute {
    @media (width >= 48rem) {
      position: absolute;
    }
  }
  .md\\:inline-block {
    @media (width >= 48rem) {
      display: inline-block;
    }
  }
  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\] {
    @media (width >= 48rem) {
      width: var(--radix-navigation-menu-viewport-width);
    }
  }
  .md\\:w-auto {
    @media (width >= 48rem) {
      width: auto;
    }
  }
  .md\\:max-w-\\[420px\\] {
    @media (width >= 48rem) {
      max-width: 420px;
    }
  }
  .md\\:space-x-2 {
    @media (width >= 48rem) {
      :where(& > :not(:last-child)) {
        --tw-space-x-reverse: 0;
        margin-inline-start: calc(calc(var(--spacing) * 2) * var(--tw-space-x-reverse));
        margin-inline-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-x-reverse)));
      }
    }
  }
  .md\\:px-2 {
    @media (width >= 48rem) {
      padding-inline: calc(var(--spacing) * 2);
    }
  }
  .lg\\:block {
    @media (width >= 64rem) {
      display: block;
    }
  }
  .lg\\:flex {
    @media (width >= 64rem) {
      display: flex;
    }
  }
  .lg\\:grid {
    @media (width >= 64rem) {
      display: grid;
    }
  }
  .lg\\:min-h-\\[600px\\] {
    @media (width >= 64rem) {
      min-height: 600px;
    }
  }
  .lg\\:w-\\[250px\\] {
    @media (width >= 64rem) {
      width: 250px;
    }
  }
  .lg\\:grid-cols-2 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .lg\\:justify-center {
    @media (width >= 64rem) {
      justify-content: center;
    }
  }
  .lg\\:space-x-8 {
    @media (width >= 64rem) {
      :where(& > :not(:last-child)) {
        --tw-space-x-reverse: 0;
        margin-inline-start: calc(calc(var(--spacing) * 8) * var(--tw-space-x-reverse));
        margin-inline-end: calc(calc(var(--spacing) * 8) * calc(1 - var(--tw-space-x-reverse)));
      }
    }
  }
  .lg\\:px-3 {
    @media (width >= 64rem) {
      padding-inline: calc(var(--spacing) * 3);
    }
  }
  .lg\\:pl-0 {
    @media (width >= 64rem) {
      padding-left: calc(var(--spacing) * 0);
    }
  }
  .lg\\:pl-36 {
    @media (width >= 64rem) {
      padding-left: calc(var(--spacing) * 36);
    }
  }
  .xl\\:min-h-\\[800px\\] {
    @media (width >= 80rem) {
      min-height: 800px;
    }
  }
  .dark\\:border-destructive {
    &:is(.dark *) {
      border-color: var(--color-destructive);
    }
  }
  .dark\\:brightness-\\[0\\.2\\] {
    &:is(.dark *) {
      --tw-brightness: brightness(0.2);
      filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
    }
  }
  .dark\\:grayscale {
    &:is(.dark *) {
      --tw-grayscale: grayscale(100%);
      filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
    }
  }
  .\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 {
    & [cmdk-group-heading] {
      padding-inline: calc(var(--spacing) * 2);
    }
  }
  .\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 {
    & [cmdk-group-heading] {
      padding-block: calc(var(--spacing) * 1.5);
    }
  }
  .\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs {
    & [cmdk-group-heading] {
      font-size: var(--text-xs);
      line-height: var(--tw-leading, var(--text-xs--line-height));
    }
  }
  .\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium {
    & [cmdk-group-heading] {
      --tw-font-weight: var(--font-weight-medium);
      font-weight: var(--font-weight-medium);
    }
  }
  .\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground {
    & [cmdk-group-heading] {
      color: var(--color-muted-foreground);
    }
  }
  .\\[\\&_\\[cmdk-group\\]\\]\\:px-2 {
    & [cmdk-group] {
      padding-inline: calc(var(--spacing) * 2);
    }
  }
  .\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 {
    & [cmdk-group]:not([hidden]) ~[cmdk-group] {
      padding-top: calc(var(--spacing) * 0);
    }
  }
  .\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 {
    & [cmdk-input-wrapper] svg {
      height: calc(var(--spacing) * 5);
    }
  }
  .\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 {
    & [cmdk-input-wrapper] svg {
      width: calc(var(--spacing) * 5);
    }
  }
  .\\[\\&_\\[cmdk-input\\]\\]\\:h-12 {
    & [cmdk-input] {
      height: calc(var(--spacing) * 12);
    }
  }
  .\\[\\&_\\[cmdk-item\\]\\]\\:px-2 {
    & [cmdk-item] {
      padding-inline: calc(var(--spacing) * 2);
    }
  }
  .\\[\\&_\\[cmdk-item\\]\\]\\:py-3 {
    & [cmdk-item] {
      padding-block: calc(var(--spacing) * 3);
    }
  }
  .\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 {
    & [cmdk-item] svg {
      height: calc(var(--spacing) * 5);
    }
  }
  .\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 {
    & [cmdk-item] svg {
      width: calc(var(--spacing) * 5);
    }
  }
  .\\[\\&_p\\]\\:leading-relaxed {
    & p {
      --tw-leading: var(--leading-relaxed);
      line-height: var(--leading-relaxed);
    }
  }
  .\\[\\&_tr\\]\\:border-b {
    & tr {
      border-bottom-style: var(--tw-border-style);
      border-bottom-width: 1px;
    }
  }
  .\\[\\&_tr\\:last-child\\]\\:border-0 {
    & tr:last-child {
      border-style: var(--tw-border-style);
      border-width: 0px;
    }
  }
  .\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent {
    &:has([aria-selected]) {
      background-color: var(--color-accent);
    }
  }
  .first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md {
    &:first-child {
      &:has([aria-selected]) {
        border-top-left-radius: var(--radius-md);
        border-bottom-left-radius: var(--radius-md);
      }
    }
  }
  .last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md {
    &:last-child {
      &:has([aria-selected]) {
        border-top-right-radius: var(--radius-md);
        border-bottom-right-radius: var(--radius-md);
      }
    }
  }
  .\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50 {
    &:has([aria-selected].day-outside) {
      background-color: color-mix(in srgb, hsl(var(--accent)) 50%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-accent) 50%, transparent);
      }
    }
  }
  .\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md {
    &:has([aria-selected].day-range-end) {
      border-top-right-radius: var(--radius-md);
      border-bottom-right-radius: var(--radius-md);
    }
  }
  .\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0 {
    &:has([role=checkbox]) {
      padding-right: calc(var(--spacing) * 0);
    }
  }
  .\\[\\&\\>\\*\\:first-child\\]\\:\\!block {
    &>*:first-child {
      display: block !important;
    }
  }
  .\\[\\&\\>div\\]\\:\\!block {
    &>div {
      display: block !important;
    }
  }
  .\\[\\&\\>span\\]\\:line-clamp-1 {
    &>span {
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
    }
  }
  .\\[\\&\\>svg\\]\\:absolute {
    &>svg {
      position: absolute;
    }
  }
  .\\[\\&\\>svg\\]\\:top-4 {
    &>svg {
      top: calc(var(--spacing) * 4);
    }
  }
  .\\[\\&\\>svg\\]\\:left-4 {
    &>svg {
      left: calc(var(--spacing) * 4);
    }
  }
  .\\[\\&\\>svg\\]\\:hidden {
    &>svg {
      display: none;
    }
  }
  .\\[\\&\\>svg\\]\\:size-3\\.5 {
    &>svg {
      width: calc(var(--spacing) * 3.5);
      height: calc(var(--spacing) * 3.5);
    }
  }
  .\\[\\&\\>svg\\]\\:text-destructive {
    &>svg {
      color: var(--color-destructive);
    }
  }
  .\\[\\&\\>svg\\]\\:text-foreground {
    &>svg {
      color: var(--color-foreground);
    }
  }
  .\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\] {
    &>svg+div {
      --tw-translate-y: -3px;
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .\\[\\&\\>svg\\~\\*\\]\\:pl-7 {
    &>svg~* {
      padding-left: calc(var(--spacing) * 7);
    }
  }
  .\\[\\&\\>tr\\]\\:last\\:border-b-0 {
    &>tr {
      &:last-child {
        border-bottom-style: var(--tw-border-style);
        border-bottom-width: 0px;
      }
    }
  }
  .\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90 {
    &[data-panel-group-direction=vertical]>div {
      rotate: 90deg;
    }
  }
  .\\[\\&\\[data-state\\=closed\\]\\>svg\\]\\:rotate-270 {
    &[data-state=closed]>svg {
      rotate: 270deg;
    }
  }
  .\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180 {
    &[data-state=open]>svg {
      rotate: 180deg;
    }
  }
  .\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-360 {
    &[data-state=open]>svg {
      rotate: 360deg;
    }
  }
}
:root {
  --affine-font-family: "Inter", "Source Sans 3", Poppins, apple-system, BlinkMacSystemFont, "Helvetica Neue", Tahoma, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji","Segoe UI Symbol", "Noto Color Emoji";
  --affine-font-serif-family: "Source Serif 4", "Noto Serif" , serif, "Cambria", apple-system, BlinkMacSystemFont, "Helvetica Neue", Tahoma, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji","Segoe UI Symbol", "Noto Color Emoji";
  --affine-font-mono-family: "Source Code Pro", "IBM Plex Mono", "Roboto Mono","Noto Sans Mono", "Noto Sans CJK", apple-system, BlinkMacSystemFont, "Helvetica Neue", Tahoma, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji","Segoe UI Symbol", "Noto Color Emoji";
  --affine-font-sans-family: "Inter", "Source Sans 3", Poppins, apple-system, BlinkMacSystemFont, "Helvetica Neue", Tahoma, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji","Segoe UI Symbol", "Noto Color Emoji";
  --affine-font-number-family: "Roboto Mono", "Noto Sans Mono", apple-system, BlinkMacSystemFont, "Helvetica Neue", Tahoma, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji","Segoe UI Symbol", "Noto Color Emoji";
  --affine-font-code-family: "IBM Plex Mono", "Space Mono", Consolas, Menlo, Monaco, Courier, monospace, apple-system, BlinkMacSystemFont, "Helvetica Neue", Tahoma, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji","Segoe UI Symbol", "Noto Color Emoji";
  --affine-font-title: 36px;
  --affine-font-h-1: 28px;
  --affine-font-h-2: 26px;
  --affine-font-h-3: 24px;
  --affine-font-h-4: 22px;
  --affine-font-h-5: 20px;
  --affine-font-h-6: 18px;
  --affine-font-base: 15px;
  --affine-font-sm: 14px;
  --affine-font-xs: 12px;
  --affine-line-height: calc(1em + 8px);
  --affine-z-index-modal: 1000;
  --affine-z-index-popover: 1000;
  --affine-paragraph-space: 8px;
  --affine-popover-radius: 12px;
  --affine-editor-width: 944px;
  --affine-editor-side-padding: 96px;
  --affine-zoom: 1;
  --affine-scale: calc(1 / var(--affine-zoom));
  --affine-palette-line-yellow: rgb(255, 211, 56);
  --affine-palette-line-orange: rgb(255, 175, 56);
  --affine-palette-line-tangerine: rgb(250, 124, 69);
  --affine-palette-line-red: rgb(237, 63, 63);
  --affine-palette-line-magenta: rgb(230, 96, 164);
  --affine-palette-line-purple: rgb(110, 82, 223);
  --affine-palette-line-navy: rgb(59, 37, 204);
  --affine-palette-line-blue: rgb(79, 144, 255);
  --affine-palette-line-teal: rgb(122, 226, 213);
  --affine-palette-line-green: rgb(124, 194, 112);
  --affine-palette-line-white: rgb(255, 255, 255);
  --affine-palette-line-black: rgb(35, 35, 35);
  --affine-palette-line-grey: rgb(191, 192, 191);
  --affine-palette-shape-yellow: rgb(255, 223, 107);
  --affine-palette-shape-orange: rgb(255, 196, 107);
  --affine-palette-shape-tangerine: rgb(251, 161, 121);
  --affine-palette-shape-red: rgb(241, 111, 111);
  --affine-palette-shape-magenta: rgb(237, 140, 189);
  --affine-palette-shape-purple: rgb(147, 126, 231);
  --affine-palette-shape-navy: rgb(122, 149, 246);
  --affine-palette-shape-blue: rgb(184, 227, 255);
  --affine-palette-shape-green: rgb(157, 209, 148);
  --affine-palette-shape-white: rgb(255, 255, 255);
  --affine-palette-shape-black: rgb(35, 35, 35);
  --affine-palette-shape-grey: rgb(216, 217, 216);
  --affine-multi-players-purple: rgba(123,97,255,1);
  --affine-multi-players-magenta: rgba(245, 49, 179, 1);
  --affine-multi-players-red: rgba(243,87,52,1);
  --affine-multi-players-orange: rgba(255, 138, 0, 1);
  --affine-multi-players-green: rgba(27, 196, 125, 1);
  --affine-palette-shape-teal: rgb(184, 242, 231);
  --affine-multi-players-blue: rgba(24, 160, 251, 1);
  --affine-multi-players-brown: rgba(154, 101, 51, 1);
  --affine-multi-players-grey: rgba(170, 170, 170, 1);
  --affine-blue: rgba(30, 150, 235, 1);
  --affine-pure-black: rgba(0, 0, 0, 1);
  --affine-pure-black-10: rgba(0, 0, 0, .1);
  --affine-pure-black-20: rgba(0, 0, 0, .2);
  --affine-pure-black-80: rgba(0, 0, 0, .8);
  --affine-pure-white: rgba(255, 255, 255, 1);
  --affine-pure-white-10: rgba(255, 255, 255, .1);
  --affine-toggle-circle-background-color: rgba(255, 255, 255, 1);
  --affine-toggle-disable-background-color: rgba(119, 117, 125, 1);
  --affine-toggle-circle-shadow: 0px 1px 2px 0px rgba(0, 0, 0, .25), inset -2px -3px 2px 0px rgba(0, 0, 0, .05);
  --affine-button-inner-shadow: unset;
  --affine-multi-cursors-shadow: 0px 2px 4px 0px rgba(0, 0, 0, .28);
  --affine-multi-players-shadow: 0px 1px 6px 0px rgba(0, 0, 0, .16);
  --affine-grabbing-cursor: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), grabbing;
  --affine-grab-cursor: url(${___CSS_LOADER_URL_REPLACEMENT_1___}), grab;
  --affine-theme-mode: light;
  --affine-brand-color: #1E96EB;
  --affine-tertiary-color: rgba(239, 250, 255, 1);
  --affine-primary-color: #1E96EB;
  --affine-primary-color-04: rgba(30, 150, 235, .04);
  --affine-secondary-color: rgb(125, 145, 255);
  --affine-blue-50: rgba(239, 250, 255, 1);
  --affine-blue-100: rgba(219, 244, 254, 1);
  --affine-blue-200: rgba(191, 236, 254, 1);
  --affine-blue-300: rgba(147, 226, 253, 1);
  --affine-blue-400: rgba(96, 207, 250, 1);
  --affine-blue-500: rgba(58, 181, 247, 1);
  --affine-blue-600: rgba(30, 150, 235, 1);
  --affine-blue-700: rgba(28, 129, 217, 1);
  --affine-blue-800: rgba(30, 103, 175, 1);
  --affine-blue-900: rgba(30, 87, 138, 1);
  --affine-blue-950: rgba(23, 54, 84, 1);
  --affine-background-success-color: rgba(231, 250, 243, 1);
  --affine-background-error-color: rgba(253, 236, 235, 1);
  --affine-background-processing-color: rgba(233, 241, 255, 1);
  --affine-background-warning-color: rgba(255, 237, 219, 1);
  --affine-background-primary-color: rgb(255, 255, 255);
  --affine-background-overlay-panel-color: rgb(251, 251, 252);
  --affine-background-secondary-color: rgba(244, 244, 245, 1);
  --affine-background-tertiary-color: rgb(238, 238, 238);
  --affine-background-code-block: rgba(247, 248, 250, 1);
  --affine-background-modal-color: rgba(0, 0, 0, .75);
  --affine-text-primary-color: rgb(18, 18, 18);
  --affine-text-secondary-color: rgb(142, 141, 145);
  --affine-text-disable-color: rgb(169, 169, 173);
  --affine-text-emphasis-color: #1E96EB;
  --affine-hover-color: rgba(0, 0, 0, .04);
  --affine-hover-color-filled: rgb(245, 245, 245);
  --affine-link-color: #1E67AF;
  --affine-quote-color: rgba(194, 193, 197, 1);
  --affine-list-color: rgba(133, 131, 140, 1);
  --affine-icon-color: rgb(119, 117, 125);
  --affine-icon-secondary: rgba(119, 117, 125, .6);
  --affine-border-color: rgb(227, 226, 228);
  --affine-divider-color: rgb(227, 226, 228);
  --affine-placeholder-color: rgb(192, 191, 193);
  --affine-edgeless-grid-color: rgb(230, 230, 230);
  --affine-success-color: rgb(16, 203, 134);
  --affine-warning-color: rgb(235, 67, 53);
  --affine-error-color: rgb(235, 67, 53);
  --affine-processing-color: rgb(39, 118, 255);
  --affine-black-10: rgba(0, 0, 0, .1);
  --affine-black-30: rgba(0, 0, 0, .3);
  --affine-black-50: rgba(0, 0, 0, .5);
  --affine-black-60: rgba(0, 0, 0, .6);
  --affine-black-80: rgba(0, 0, 0, .8);
  --affine-black-90: rgba(0, 0, 0, .9);
  --affine-black: rgb(0, 0, 0);
  --affine-white-10: rgba(255, 255, 255, .1);
  --affine-white-30: rgba(255, 255, 255, .3);
  --affine-white-50: rgba(255, 255, 255, .5);
  --affine-white-60: rgba(255, 255, 255, .6);
  --affine-white-80: rgba(255, 255, 255, .8);
  --affine-white-90: rgba(255, 255, 255, .9);
  --affine-white: rgb(255, 255, 255);
  --affine-tag-white: rgba(245, 245, 245, 1);
  --affine-tag-gray: rgba(227, 226, 224, 1);
  --affine-tag-red: rgba(255, 225, 225, 1);
  --affine-tag-orange: rgba(255, 233, 201, 1);
  --affine-tag-yellow: rgba(255, 243, 215, 1);
  --affine-tag-green: rgba(222, 244, 231, 1);
  --affine-tag-teal: rgba(222, 244, 243, 1);
  --affine-tag-blue: rgba(225, 238, 255, 1);
  --affine-tag-purple: rgba(243, 240, 255, 1);
  --affine-tag-pink: rgba(251, 231, 255, 1);
  --affine-tag-magenta: rgba(249, 232, 255, 1);
  --affine-tooltip: rgba(0, 0, 0, 1);
  --affine-button-shadow: 0px 0px 1px 0px rgba(0, 0, 0, .12), 0px 1px 5px 0px rgba(0, 0, 0, .12);
  --affine-overlay-panel-shadow: 0px 1px 6px rgba(0,0,0,.16), 0px 8px 14px rgba(0,0,0,.08);
  --affine-active-shadow: 0px 0px 0px 2px rgba(30, 150, 235, .3);
  --affine-embed-shadow: 0px 0px 0px 2px rgba(0, 0, 0, .08);
  --affine-menu-shadow: 0px 10px 18px rgba(0,0,0,.14), 0px -1px 12px rgba(0,0,0,.08);
  --affine-toolbar-shadow: 0px 6px 16px #00000024;
  --affine-shadow-1: 0px 0px 4px 0px rgba(66, 65, 73, .14);
  --affine-shadow-2: 0px 0px 12px 0px rgba(66, 65, 73, .18);
  --affine-shadow-3: 0px 0px 20px 0px rgba(66, 65, 73, .22);
  --affine-overlay-shadow: 0px 1px 6px 0px rgba(0, 0, 0, .16), 0px 8px 14px 0px rgba(0, 0, 0, .08);
  --affine-popover-shadow: 0px 0px 30px rgba(75, 75, 75, .2), 0px 0px 4px rgba(75, 75, 75, .3), inset 0px 0px 0px rgba(227, 226, 228, 1);
  --affine-float-button-shadow: 0px 0px 10px rgba(0, 0, 0, .05), 0px 0px 0px .5px rgba(0, 0, 0, .1);
  --affine-float-button-shadow-1: 0px 4px 6px -3px rgba(66, 65, 73, .1), 0px 10px 12px -2px rgba(66, 65, 73, .1);
  --affine-float-button-shadow-2: 0px 4px 4px -2px rgba(66, 65, 73, .1), 0px 6px 8px 1px rgba(66, 65, 73, .05);
  --affine-kanban-shadow: 0px 2px 3px 0px rgba(0, 0, 0, .05);
  --affine-cmd-shadow: 0px 10px 80px 0px rgba(0, 0, 0, .2);
  --affine-large-button-effect: 0px 12px 21px 4px rgba(30, 150, 235, .15);
  --affine-note-shadow-box: 0px 0px 4px 0px rgba(0, 0, 0, .14), 0px 2px 12px 0px rgba(0, 0, 0, .14);
  --affine-note-shadow-sticker: 0px 6px 16px 0px rgba(0, 0, 0, .08), 0px 26px 18px -20px rgba(0, 0, 0, .1);
  --affine-note-shadow-paper: 0px 2px 4px 0px rgba(0, 0, 0, .05), 0px 0px 0px 10px #FFF, 0px 3px 6px 12px rgba(0, 0, 0, .14);
  --affine-note-shadow-float: 0px 0px 32px 0px rgba(0, 0, 0, .09), 0px 0px 3px 0px rgba(0, 0, 0, .1);
  --affine-note-shadow-film: 10px 10px 0px 6px #000, 0px 0px 0px 6px #000;
  --affine-ai-empty-shadow: 0px 4px 4px rgba(66, 65, 73, .1), 0px 6px 8px rgba(66, 65, 73, .05);
  --affine-button-gray-color: rgba(245, 245, 245, 1);
  --affine-card-background-blue: linear-gradient(180deg, #F0F3FD 0%, #FCFCFD 100%);
  --affine-card-background-green: linear-gradient(180deg, #F3F9FD 0%, #FCFCFD 100%);
  --affine-card-background-grey: linear-gradient(180deg, #F1F1F1 0%, #FCFCFD 100%);
  --affine-windows-close-button: #C42B1C;
  --affine-text-highlight-pink: rgba(255, 206, 206, 1);
  --affine-text-highlight-red: rgba(254, 213, 213, 1);
  --affine-text-highlight-orange: rgba(254, 223, 187, 1);
  --affine-text-highlight-yellow: rgba(254, 243, 161, 1);
  --affine-text-highlight-green: rgba(225, 250, 177, 1);
  --affine-text-highlight-teal: rgba(173, 248, 233, 1);
  --affine-text-highlight-blue: rgba(204, 226, 254, 1);
  --affine-text-highlight-purple: rgba(237, 221, 255, 1);
  --affine-text-highlight-grey: rgba(234, 236, 239, 1);
  --affine-text-highlight-foreground-red: rgba(198, 34, 34, 1);
  --affine-text-highlight-foreground-orange: rgba(211, 79, 11, 1);
  --affine-text-highlight-foreground-yellow: rgba(182, 124, 4, 1);
  --affine-text-highlight-foreground-green: rgba(20, 147, 67, 1);
  --affine-text-highlight-foreground-teal: rgba(7, 130, 160, 1);
  --affine-text-highlight-foreground-blue: rgba(33, 89, 211, 1);
  --affine-text-highlight-foreground-purple: rgba(132, 46, 211, 1);
  --affine-text-highlight-foreground-grey: rgba(122, 122, 122, 1);
  --affine-note-background-yellow: rgba(253, 230, 138, 1);
  --affine-note-background-orange: rgba(255, 196, 143, 1);
  --affine-note-background-red: rgba(250, 182, 182, 1);
  --affine-note-background-magenta: rgba(255, 218, 237, 1);
  --affine-note-background-purple: rgba(221, 214, 254, 1);
  --affine-note-background-blue: rgba(205, 235, 255, 1);
  --affine-note-background-teal: rgba(199, 248, 242, 1);
  --affine-note-background-green: rgba(201, 248, 193, 1);
  --affine-note-background-black: rgba(0, 0, 0, 1);
  --affine-note-background-grey: rgba(230, 230, 230, 1);
  --affine-note-background-white: rgba(255, 255, 255, 1);
  --affine-v2-aI-applyBackground: #92929212;
  --affine-v2-aI-applyDeleteHighlight: #ed3f3f21;
  --affine-v2-aI-applyTextHighlight: #1e96eb;
  --affine-v2-aI-applyTextHighlightBackground: #1e96eb14;
  --affine-v2-aI-errorBackground: #fff4f5;
  --affine-v2-aI-errorDetailBackground: #ffffff99;
  --affine-v2-aI-errorText: #ed3f3f;
  --affine-v2-aI-thinkingOutputBackground: #0000000d;
  --affine-v2-aI-thinkingOutputText: #000000a6;
  --affine-v2-aI-userTextBackground: #f3f3f3;
  --affine-v2-adjustmentHandle-background: #00000085;
  --affine-v2-adjustmentHandle-border: #ffffff;
  --affine-v2-backlinks-blockBackgroundColor: #9292920d;
  --affine-v2-backlinks-blockBorder: #9292921a;
  --affine-v2-backlinks-blockHover: #0000000d;
  --affine-v2-badge-believer: #002742;
  --affine-v2-badge-free: #29a3fa;
  --affine-v2-badge-pro: #29a3fa;
  --affine-v2-block-callout-background-blue: #f0f9ff;
  --affine-v2-block-callout-background-green: #fbfef1;
  --affine-v2-block-callout-background-grey: #f9f9f9;
  --affine-v2-block-callout-background-magenta: #fefaff;
  --affine-v2-block-callout-background-orange: #fff7ee;
  --affine-v2-block-callout-background-purple: #f9f7ff;
  --affine-v2-block-callout-background-red: #fff4f5;
  --affine-v2-block-callout-background-teal: #eefffd;
  --affine-v2-block-callout-background-yellow: #fdfcf4;
  --affine-v2-block-callout-icon-blue: #53b2ef;
  --affine-v2-block-callout-icon-green: #22bf07;
  --affine-v2-block-callout-icon-grey: #cdcdcd;
  --affine-v2-block-callout-icon-magenta: #cc4187;
  --affine-v2-block-callout-icon-orange: #ffae63;
  --affine-v2-block-callout-icon-purple: #7c3aed;
  --affine-v2-block-callout-icon-red: #c83030;
  --affine-v2-block-callout-icon-teal: #448e86;
  --affine-v2-block-callout-icon-yellow: #fde047;
  --affine-v2-block-code-lineNum: #b3b3b3;
  --affine-v2-block-comment-hanelActive: #1e96eb05;
  --affine-v2-block-comment-highlightActive: #1e96eb4d;
  --affine-v2-block-comment-highlightDefault: #1e96eb14;
  --affine-v2-block-comment-highlightUnderline: #1e96ebb2;
  --affine-v2-block-divider-divider: #92929238;
  --affine-v2-block-footnote-numberBg: #e6e6e6;
  --affine-v2-block-footnote-numberBgHover: #1e96eb;
  --affine-v2-block-list-header: #0077cb;
  --affine-v2-block-notSupportedBlock-background: #ffffff;
  --affine-v2-block-notSupportedBlock-inlineBg-default: #f3f3f3;
  --affine-v2-block-notSupportedBlock-inlineBg-hover: #e6e6e6;
  --affine-v2-block-recordBlock-buttonBg: #f3f3f3;
  --affine-v2-block-recordBlock-primary: #f45353;
  --affine-v2-block-recordBlock-secordary: #ff9a9a;
  --affine-v2-block-recordBlock-timelineIndeicator: #ed3f3f;
  --affine-v2-button-actionActive: #1e96eb14;
  --affine-v2-button-badgesColor: #ed3f3f;
  --affine-v2-button-buttonOverHover: #ffffff;
  --affine-v2-button-checkBox: #1e96eb;
  --affine-v2-button-disable: #b3b3b3;
  --affine-v2-button-emptyIconBackground: #0000000d;
  --affine-v2-button-error: #ed3f3f;
  --affine-v2-button-iconButtonSolid: #ffffff;
  --affine-v2-button-innerBlackBorder: #0000001a;
  --affine-v2-button-primary: #1e96eb;
  --affine-v2-button-pureWhiteText: #ffffff;
  --affine-v2-button-secondary: #ffffff;
  --affine-v2-button-success: #44b931;
  --affine-v2-button-templateLabelBackground: #1e96eb0a;
  --affine-v2-button-grabber-select: #00000038;
  --affine-v2-button-grabber-default: #0000001a;
  --affine-v2-button-mobile-aIActionBackground: #252525;
  --affine-v2-button-mobile-deletedAction: #ed3f3f;
  --affine-v2-button-sidebarButton-background: #ffffff08;
  --affine-v2-button-siderbarPrimary-background: #ffffffab;
  --affine-v2-button-signinbutton-background: #ffffff;
  --affine-v2-calendar-blue: #4ab1fa;
  --affine-v2-calendar-green: #44b931;
  --affine-v2-calendar-grey: #b3b3b3;
  --affine-v2-calendar-magenta: #f37fba;
  --affine-v2-calendar-orange: #ffae63;
  --affine-v2-calendar-purple: #9681ef;
  --affine-v2-calendar-red: #f43f48;
  --affine-v2-calendar-teal: #8be7dc;
  --affine-v2-calendar-yellow: #fde047;
  --affine-v2-centerPeek-background: #ffffff;
  --affine-v2-centerPeek-buttonBackground: #ffffff;
  --affine-v2-centerPeek-icon: #7a7a7a;
  --affine-v2-centerPeek-overlay: #0000002b;
  --affine-v2-chatBlock-chatBlockBg: #ffffff;
  --affine-v2-chatBlock-chatBlockBoder: #e6e6e6;
  --affine-v2-chatBlock-chatBlockIcon: #7a7a7a;
  --affine-v2-chatBlock-chatBlockText: #141414;
  --affine-v2-chip-label-blue: #e6f5ff;
  --affine-v2-chip-label-green: #dcfdd7;
  --affine-v2-chip-label-grey: #e6e6e6;
  --affine-v2-chip-label-magenta: #ffecf6;
  --affine-v2-chip-label-orange: #ffebd5;
  --affine-v2-chip-label-purple: #ede9ff;
  --affine-v2-chip-label-red: #fce5e6;
  --affine-v2-chip-label-teal: #d7fbf6;
  --affine-v2-chip-label-text: #00000085;
  --affine-v2-chip-label-white: #f5f5f5;
  --affine-v2-chip-label-yellow: #fef3c7;
  --affine-v2-chip-tag-blue: #84cfff;
  --affine-v2-chip-tag-green: #69b87d;
  --affine-v2-chip-tag-grey: #b3b3b3;
  --affine-v2-chip-tag-orange: #ff8c38;
  --affine-v2-chip-tag-purple: #7c3aed;
  --affine-v2-chip-tag-red: #ed3f3f;
  --affine-v2-chip-tag-teal: #8be7dc;
  --affine-v2-chip-tag-yellow: #facc15;
  --affine-v2-database-border: #0000001a;
  --affine-v2-database-buttonBackground: #ffffff;
  --affine-v2-database-cardHover: #00000008;
  --affine-v2-database-filterHeaderFadeIn: #ffffff;
  --affine-v2-database-filterHeaderFadeOut: #ffffff08;
  --affine-v2-database-focusBackground: #1e96eb0a;
  --affine-v2-database-textSecondary: #00000085;
  --affine-v2-database-attachment-fileSolidBackground: #e6e6e6;
  --affine-v2-dialog-background-primary: #ffffff;
  --affine-v2-edgeless-alignment-edgeGuides: #cc4187;
  --affine-v2-edgeless-alignment-guides: #8b5cf6;
  --affine-v2-edgeless-frame-background-black: #cdcdcd;
  --affine-v2-edgeless-frame-background-blue: #e6f5ff;
  --affine-v2-edgeless-frame-background-green: #f1fdf4;
  --affine-v2-edgeless-frame-background-grey: #f3f3f3;
  --affine-v2-edgeless-frame-background-magenta: #ffecf6;
  --affine-v2-edgeless-frame-background-orange: #ffebd5;
  --affine-v2-edgeless-frame-background-purple: #ede9ff;
  --affine-v2-edgeless-frame-background-red: #fce5e6;
  --affine-v2-edgeless-frame-background-teal: #e2fdf9;
  --affine-v2-edgeless-frame-background-white: #ffffff;
  --affine-v2-edgeless-frame-background-yellow: #fffbd5;
  --affine-v2-edgeless-frame-border-active: #1e96eb;
  --affine-v2-edgeless-frame-border-default: #0000002b;
  --affine-v2-edgeless-frame-fontColor-font: #000000f2;
  --affine-v2-edgeless-group-background-background: #ffffff;
  --affine-v2-edgeless-group-border-active: #1e96eb;
  --affine-v2-edgeless-group-border-borderHint: #8fd1ff;
  --affine-v2-edgeless-group-border-hover: #1e96eb;
  --affine-v2-edgeless-group-fontColor-active: #1e96eb;
  --affine-v2-edgeless-group-fontColor-default: #00000085;
  --affine-v2-edgeless-group-fontColor-hover: #1e96eb;
  --affine-v2-edgeless-group-fontColor-rename: #000000;
  --affine-v2-edgeless-line-black: #000000;
  --affine-v2-edgeless-line-blue: #29a3fa;
  --affine-v2-edgeless-line-green: #3cbc36;
  --affine-v2-edgeless-line-grey: #929292;
  --affine-v2-edgeless-line-magenta: #e660a4;
  --affine-v2-edgeless-line-orange: #ff8c38;
  --affine-v2-edgeless-line-purple: #6e52df;
  --affine-v2-edgeless-line-red: #e11e41;
  --affine-v2-edgeless-line-teal: #5cc7ba;
  --affine-v2-edgeless-line-white: #ffffff;
  --affine-v2-edgeless-line-yellow: #facc15;
  --affine-v2-edgeless-lock-locked: #92929285;
  --affine-v2-edgeless-mindMap-line: #000000;
  --affine-v2-edgeless-note-black: #b3b3b3;
  --affine-v2-edgeless-note-blue: #ceecff;
  --affine-v2-edgeless-note-green: #c9f8c1;
  --affine-v2-edgeless-note-grey: #e6e6e6;
  --affine-v2-edgeless-note-magenta: #ffdaed;
  --affine-v2-edgeless-note-orange: #ffc58f;
  --affine-v2-edgeless-note-purple: #ddd6fe;
  --affine-v2-edgeless-note-red: #fbb7b7;
  --affine-v2-edgeless-note-teal: #c7f8f2;
  --affine-v2-edgeless-note-white: #ffffff;
  --affine-v2-edgeless-note-yellow: #fde68a;
  --affine-v2-edgeless-palette-black: #000000;
  --affine-v2-edgeless-palette-white: #ffffff;
  --affine-v2-edgeless-palette-heavy-blue: #1c70a5;
  --affine-v2-edgeless-palette-heavy-green: #447756;
  --affine-v2-edgeless-palette-heavy-magenta: #941555;
  --affine-v2-edgeless-palette-heavy-orange: #b55309;
  --affine-v2-edgeless-palette-heavy-purple: #5a21b6;
  --affine-v2-edgeless-palette-heavy-red: #761717;
  --affine-v2-edgeless-palette-heavy-yellow: #ac7400;
  --affine-v2-edgeless-palette-light-blueLight: #e6f5ff;
  --affine-v2-edgeless-palette-light-greenLight: #f1fdf4;
  --affine-v2-edgeless-palette-light-greyLight: #e6e6e6;
  --affine-v2-edgeless-palette-light-magentaLight: #ffecf6;
  --affine-v2-edgeless-palette-light-orangeLight: #ffebd5;
  --affine-v2-edgeless-palette-light-purpleLight: #ede9ff;
  --affine-v2-edgeless-palette-light-redLight: #fce5e6;
  --affine-v2-edgeless-palette-light-yellowLight: #fffbd5;
  --affine-v2-edgeless-palette-medium-blueMedium: #84cfff;
  --affine-v2-edgeless-palette-medium-greenMedium: #3cbc36;
  --affine-v2-edgeless-palette-medium-greyMedium: #929292;
  --affine-v2-edgeless-palette-medium-magentaMedium: #e96cab;
  --affine-v2-edgeless-palette-medium-orangeMedium: #ff8c38;
  --affine-v2-edgeless-palette-medium-purpleMedium: #6e52df;
  --affine-v2-edgeless-palette-medium-redMedium: #fb7081;
  --affine-v2-edgeless-palette-medium-yellowMedium: #fcd34d;
  --affine-v2-edgeless-selection-selectionMarqueeBackground: #1e96eb14;
  --affine-v2-edgeless-selection-selectionMarqueeBorder: #1e96eb;
  --affine-v2-edgeless-shape-black: #000000;
  --affine-v2-edgeless-shape-blue: #9fd9ff;
  --affine-v2-edgeless-shape-green: #9bda91;
  --affine-v2-edgeless-shape-grey: #cdcdcd;
  --affine-v2-edgeless-shape-magenta: #ffc0e0;
  --affine-v2-edgeless-shape-orange: #ffae63;
  --affine-v2-edgeless-shape-purple: #d7cdff;
  --affine-v2-edgeless-shape-red: #fecdd1;
  --affine-v2-edgeless-shape-teal: #8be7dc;
  --affine-v2-edgeless-shape-white: #ffffff;
  --affine-v2-edgeless-shape-yellow: #fde047;
  --affine-v2-edgelessToolbar-highlightPen-body: #fafafa;
  --affine-v2-edgelessToolbar-highlightPen-body1Linear1-1: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body1Linear1-2: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body1Linear1-3: #000000;
  --affine-v2-edgelessToolbar-highlightPen-body1Linear2-1: #ffffff00;
  --affine-v2-edgelessToolbar-highlightPen-body1Linear2-2: #ffffff00;
  --affine-v2-edgelessToolbar-highlightPen-body1Linear2-3: #ffffff00;
  --affine-v2-edgelessToolbar-highlightPen-body1Linear2-4: #ffffff00;
  --affine-v2-edgelessToolbar-highlightPen-body2: #f3f3f3;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear1-1: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear1-2: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear1-3: #000000;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear2-1: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear2-2: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear2-3: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear2-4: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear2-5: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-bodyColorLinear-1: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-bodyColorLinear-2: #000000fc;
  --affine-v2-edgelessToolbar-highlightPen-bodyColorLinear-3: #000000c4;
  --affine-v2-edgelessToolbar-media-whiteVector: #ffffff8f;
  --affine-v2-edgelessToolbar-note-background: #ffffff;
  --affine-v2-edgelessToolbar-note-textColor: #0000001a;
  --affine-v2-edgelessToolbar-others-background: #ffffff1f;
  --affine-v2-edgelessToolbar-others-highlightLinearEnd: #ffffff;
  --affine-v2-edgelessToolbar-others-highlightLinearStart: #ffffff00;
  --affine-v2-edgelessToolbar-others-linearCenter: #000000c4;
  --affine-v2-edgelessToolbar-others-linearEnd: #0000001f;
  --affine-v2-edgelessToolbar-others-linearStart: #ffffff1f;
  --affine-v2-edgelessToolbar-penEraser-eraserBlue-1: #173654;
  --affine-v2-edgelessToolbar-penEraser-eraserBlue-2: #effaff;
  --affine-v2-edgelessToolbar-penEraser-eraserBlue-3: #1e96eb;
  --affine-v2-edgelessToolbar-penEraser-eraserBodyFill: #f1f1f1;
  --affine-v2-edgelessToolbar-penEraser-eraserBodyHighlight: #ffffff8f;
  --affine-v2-edgelessToolbar-penEraser-eraserBodyShade2: #00000033;
  --affine-v2-edgelessToolbar-penEraser-eraserBodyShade3: #ffffff;
  --affine-v2-edgelessToolbar-penEraser-eraserBorder: #e7e7e7;
  --affine-v2-edgelessToolbar-penEraser-eraserBorder2: #e3e2e4;
  --affine-v2-edgelessToolbar-penEraser-eraserClothHighlight: #ffffff1c;
  --affine-v2-edgelessToolbar-penEraser-eraserClothShade2: #0f0f0f;
  --affine-v2-edgelessToolbar-penEraser-eraserClothShade3: #ffffff17;
  --affine-v2-edgelessToolbar-penEraser-eraserShadow: #00000040;
  --affine-v2-edgelessToolbar-penEraser-penBackground: #fafafa;
  --affine-v2-edgelessToolbar-penEraser-penBodyShade-1: #00000033;
  --affine-v2-edgelessToolbar-penEraser-penBodyShade-2: #0000001a;
  --affine-v2-edgelessToolbar-penEraser-penBodyShade-3: #00000003;
  --affine-v2-edgelessToolbar-penEraser-penBodyShade-4: #ffffff14;
  --affine-v2-edgelessToolbar-penEraser-penInlineShadow: #ffffff00;
  --affine-v2-icon-activated: #1e96eb;
  --affine-v2-icon-disable: #b3b3b3;
  --affine-v2-icon-fileIconBorder: #cdcdcd;
  --affine-v2-icon-monotone: #7a7a7a;
  --affine-v2-icon-primary: #7a7a7a;
  --affine-v2-icon-secondary: #b3b3b3;
  --affine-v2-icon-tertiary: #cdcdcd;
  --affine-v2-icon-transparentBlack: #00000085;
  --affine-v2-icon-fileIconColors-blue: #0077cb;
  --affine-v2-icon-fileIconColors-green: #1d9c07;
  --affine-v2-icon-fileIconColors-grey: #1e1b4b;
  --affine-v2-icon-fileIconColors-magenta: #e660a4;
  --affine-v2-icon-fileIconColors-purple: #6e52df;
  --affine-v2-icon-fileIconColors-red: #ed3f3f;
  --affine-v2-icon-fileIconColors-yellow: #facc15;
  --affine-v2-input-background: #ffffff;
  --affine-v2-input-scrollBar-handle: #0000001a;
  --affine-v2-input-border-active: #1e96eb;
  --affine-v2-input-border-default: #0000001a;
  --affine-v2-input-border-error: #ed3f3f;
  --affine-v2-integrations-background-iconSolid: #ffffff;
  --affine-v2-layer-black: #000000;
  --affine-v2-layer-pureBlack: #000000;
  --affine-v2-layer-pureWhite: #ffffff;
  --affine-v2-layer-white: #ffffff;
  --affine-v2-layer-insideBorder-blackBorder: #0000001a;
  --affine-v2-layer-insideBorder-border: #e6e6e6;
  --affine-v2-layer-insideBorder-primaryBorder: #1e96eb;
  --affine-v2-layer-insideBorder-splitviewActived: #0000002b;
  --affine-v2-layer-insideBorder-whiteBorder: #ffffff8f;
  --affine-v2-layer-background-codeBlock: #f5f5f5;
  --affine-v2-layer-background-edgelessGrid: #e6e6e6;
  --affine-v2-layer-background-error: #fff1f1;
  --affine-v2-layer-background-hoverOverlay: #0000000d;
  --affine-v2-layer-background-linkedDocOnEdgeless: #ffffff;
  --affine-v2-layer-background-modal: #000000b2;
  --affine-v2-layer-background-modalWhite: #ffffff2b;
  --affine-v2-layer-background-overlayPanel: #ffffff;
  --affine-v2-layer-background-primary: #ffffff;
  --affine-v2-layer-background-processing: #eef2ff;
  --affine-v2-layer-background-secondary: #f5f5f5;
  --affine-v2-layer-background-success: #f1fdf4;
  --affine-v2-layer-background-tertiary: #f3f3f3;
  --affine-v2-layer-background-translucentUI: #ffffffb8;
  --affine-v2-layer-background-warning: #fff7ee;
  --affine-v2-layer-background-mobile-iOSControl: #000000;
  --affine-v2-layer-background-mobile-modal: #0000002b;
  --affine-v2-layer-background-mobile-primary: #f5f5f5;
  --affine-v2-layer-background-mobile-secondary: #ffffff;
  --affine-v2-layer-background-mobile-tertiary: #e6e6e6;
  --affine-v2-loading-background: #0000001a;
  --affine-v2-loading-backgroundLayer: #92929238;
  --affine-v2-loading-foreground: #1e96eb;
  --affine-v2-loading-imageLoadingBackground: #92929238;
  --affine-v2-loading-imageLoadingLayer: #ffffff8f;
  --affine-v2-others-warnLabel-black: #000000;
  --affine-v2-others-warnLabel-yellow: #facc15;
  --affine-v2-pagelist-hoverBorder: #e6e6e6;
  --affine-v2-portrait-localPortrait: #00000038;
  --affine-v2-portrait-localPortraitBackground: #0000001a;
  --affine-v2-radio-disable: #cdcdcd;
  --affine-v2-radio-active-chekced: #1e96eb;
  --affine-v2-radio-active-default: #7a7a7a;
  --affine-v2-readwise-quoteBackground: #f9f9f9;
  --affine-v2-readwise-quoteDivider: #1e96eb;
  --affine-v2-segment-background: #0000000d;
  --affine-v2-segment-button: #ffffff;
  --affine-v2-selfhost-portrait-localPortraitBackground: #0000000d;
  --affine-v2-selfhost-button-disable: #7a7a7a;
  --affine-v2-selfhost-button-primary: #141414;
  --affine-v2-selfhost-button-secondary: #ffffff;
  --affine-v2-selfhost-button-sidebarButton-bg-hover: #0000000d;
  --affine-v2-selfhost-button-sidebarButton-bg-select: #0000000d;
  --affine-v2-selfhost-icon-buttonIcon: #ffffff;
  --affine-v2-selfhost-icon-buttonIconError: #ffffff;
  --affine-v2-selfhost-icon-disable: #b3b3b3;
  --affine-v2-selfhost-icon-primary: #141414;
  --affine-v2-selfhost-icon-secondary: #7a7a7a;
  --affine-v2-selfhost-icon-tertiary: #b3b3b3;
  --affine-v2-selfhost-layer-background-hoverOverlay: #ffffff3b;
  --affine-v2-selfhost-layer-background-primary: #ffffff;
  --affine-v2-selfhost-layer-background-secondary: #f9f9f9;
  --affine-v2-selfhost-layer-background-sidebarBg-sidebarBg: #f9f9f9;
  --affine-v2-selfhost-layer-border-border: #141414;
  --affine-v2-selfhost-progress-error: #ed3f3f;
  --affine-v2-selfhost-progress-primary: #141414;
  --affine-v2-selfhost-text-placeholder: #b3b3b3;
  --affine-v2-selfhost-text-button-error: #ffffff;
  --affine-v2-selfhost-text-button-primary: #ffffff;
  --affine-v2-selfhost-text-sidebar-primary: #141414;
  --affine-v2-selfhost-text-sidebar-secondary: #252525;
  --affine-v2-selfhost-toggle-backgroundDisable: #e6e6e6;
  --affine-v2-selfhost-toggle-backgroundOff: #cdcdcd;
  --affine-v2-selfhost-toggle-backgroundOn: #141414;
  --affine-v2-selfhost-toggle-foreground: #ffffff;
  --affine-v2-selfhost-toggle-foregroundDisable: #f9f9f9;
  --affine-v2-skeleton-skeleton: #e6e6e6;
  --affine-v2-slashMenu-background: #ffffff;
  --affine-v2-status-error: #ed3f3f;
  --affine-v2-status-success: #44b931;
  --affine-v2-switch-buttonBackground-active: #ffffff;
  --affine-v2-switch-buttonBackground-hover: #0000000d;
  --affine-v2-switch-fontColor-primary: #141414;
  --affine-v2-switch-fontColor-secondary: #7a7a7a;
  --affine-v2-switch-fontColor-tertiary: #929292;
  --affine-v2-switch-iconColor-active: #565656;
  --affine-v2-switch-iconColor-default: #929292;
  --affine-v2-switch-switchBackground-background: #f3f3f3;
  --affine-v2-tab-divider-divider: #00000012;
  --affine-v2-tab-divider-indicator: #1e96eb;
  --affine-v2-tab-fontColor-active: #141414;
  --affine-v2-tab-fontColor-default: #b3b3b3;
  --affine-v2-tab-fontColor-hover: #141414;
  --affine-v2-tab-iconColor-active: #565656;
  --affine-v2-tab-iconColor-default: #b3b3b3;
  --affine-v2-tab-iconColor-hover: #565656;
  --affine-v2-tab-tabBackground-active: #ffffff;
  --affine-v2-tab-tabBackground-default: #f3f3f3;
  --affine-v2-tab-tabBackground-hover: #f3f3f3;
  --affine-v2-table-border: #0000001a;
  --affine-v2-table-focusBackground: #1e96eb0a;
  --affine-v2-table-focusBorder: #1e96eb;
  --affine-v2-table-textSecondary: #00000085;
  --affine-v2-table-headerBackground-blue: #f0f9ff;
  --affine-v2-table-headerBackground-default: #ffffff;
  --affine-v2-table-headerBackground-green: #efffec;
  --affine-v2-table-headerBackground-grey: #f5f5f5;
  --affine-v2-table-headerBackground-headerColor: #f3f3f3;
  --affine-v2-table-headerBackground-orange: #fff7ee;
  --affine-v2-table-headerBackground-purple: #f7f5ff;
  --affine-v2-table-headerBackground-red: #fff4f5;
  --affine-v2-table-headerBackground-teal: #eefffd;
  --affine-v2-table-headerBackground-yellow: #fffded;
  --affine-v2-table-indicator-activated: #1e96eb;
  --affine-v2-table-indicator-border: #e6e6e6;
  --affine-v2-table-indicator-drag: #0000002b;
  --affine-v2-table-indicator-hover: #0000000d;
  --affine-v2-table-indicator-pointerActive: #ffffff;
  --affine-v2-table-indicator-pointerDefault: #b3b3b3;
  --affine-v2-text-disable: #7a7a7a;
  --affine-v2-text-emphasis: #1e96eb;
  --affine-v2-text-link: #035f9f;
  --affine-v2-text-listDotAndNumber: #0077cb;
  --affine-v2-text-placeholder: #929292;
  --affine-v2-text-primary: #141414;
  --affine-v2-text-pureWhite: #ffffff;
  --affine-v2-text-secondary: #7a7a7a;
  --affine-v2-text-tertiary: #929292;
  --affine-v2-text-highlight-border: #00000038;
  --affine-v2-text-highlight-bg-blue: #daf0ff;
  --affine-v2-text-highlight-bg-green: #f0fccb;
  --affine-v2-text-highlight-bg-grey: #e6e6e6;
  --affine-v2-text-highlight-bg-magenta: #ffecf6;
  --affine-v2-text-highlight-bg-orange: #ffebd5;
  --affine-v2-text-highlight-bg-purple: #ede9ff;
  --affine-v2-text-highlight-bg-red: #fce5e6;
  --affine-v2-text-highlight-bg-teal: #c7f8f2;
  --affine-v2-text-highlight-bg-yellow: #fff9b6;
  --affine-v2-text-highlight-fg-blue: #003c67;
  --affine-v2-text-highlight-fg-green: #225c18;
  --affine-v2-text-highlight-fg-grey: #7a7a7a;
  --affine-v2-text-highlight-fg-magenta: #941555;
  --affine-v2-text-highlight-fg-orange: #db7123;
  --affine-v2-text-highlight-fg-purple: #7c3aed;
  --affine-v2-text-highlight-fg-red: #c83030;
  --affine-v2-text-highlight-fg-teal: #0e4841;
  --affine-v2-text-highlight-fg-yellow: #ac7400;
  --affine-v2-toast-cardLayer-second: #f9f9f9;
  --affine-v2-toast-cardLayer-third: #f5f5f5;
  --affine-v2-toast-iconState-error: #ed3f3f;
  --affine-v2-toast-iconState-regular: #0077cb;
  --affine-v2-toast-iconState-success: #44b931;
  --affine-v2-toast-overlay-secondary: #00000008;
  --affine-v2-toast-overlay-tertiary: #0000000d;
  --affine-v2-toggle-background: #1e96eb;
  --affine-v2-toggle-backgroundDisable: #b3b3b3;
  --affine-v2-toggle-backgroundOff: #929292;
  --affine-v2-toggle-foreground: #ffffff;
  --affine-v2-toggle-foregroundDisable: #e6e6e6;
  --affine-v2-tooltips-background: #000000;
  --affine-v2-tooltips-foreground: #ffffff;
  --affine-v2-tooltips-secondaryBackground: #ffffff2b;
  --affine-v2-workspacePicker-border: #e6e6e6;
  --affine-v2-workspacePicker-secondaryBackground: #9292921a;
  --affine-v2-tableOfContent-background: #ffffff;
}
[data-theme=light] {
  --affine-theme-mode: light;
  --affine-brand-color: #1E96EB;
  --affine-tertiary-color: rgba(239, 250, 255, 1);
  --affine-primary-color: #1E96EB;
  --affine-primary-color-04: rgba(30, 150, 235, .04);
  --affine-secondary-color: rgb(125, 145, 255);
  --affine-blue-50: rgba(239, 250, 255, 1);
  --affine-blue-100: rgba(219, 244, 254, 1);
  --affine-blue-200: rgba(191, 236, 254, 1);
  --affine-blue-300: rgba(147, 226, 253, 1);
  --affine-blue-400: rgba(96, 207, 250, 1);
  --affine-blue-500: rgba(58, 181, 247, 1);
  --affine-blue-600: rgba(30, 150, 235, 1);
  --affine-blue-700: rgba(28, 129, 217, 1);
  --affine-blue-800: rgba(30, 103, 175, 1);
  --affine-blue-900: rgba(30, 87, 138, 1);
  --affine-blue-950: rgba(23, 54, 84, 1);
  --affine-background-success-color: rgba(231, 250, 243, 1);
  --affine-background-error-color: rgba(253, 236, 235, 1);
  --affine-background-processing-color: rgba(233, 241, 255, 1);
  --affine-background-warning-color: rgba(255, 237, 219, 1);
  --affine-background-primary-color: rgb(255, 255, 255);
  --affine-background-overlay-panel-color: rgb(251, 251, 252);
  --affine-background-secondary-color: rgba(244, 244, 245, 1);
  --affine-background-tertiary-color: rgb(238, 238, 238);
  --affine-background-code-block: rgba(247, 248, 250, 1);
  --affine-background-modal-color: rgba(0, 0, 0, .75);
  --affine-text-primary-color: rgb(18, 18, 18);
  --affine-text-secondary-color: rgb(142, 141, 145);
  --affine-text-disable-color: rgb(169, 169, 173);
  --affine-text-emphasis-color: #1E96EB;
  --affine-hover-color: rgba(0, 0, 0, .04);
  --affine-hover-color-filled: rgb(245, 245, 245);
  --affine-link-color: #1E67AF;
  --affine-quote-color: rgba(194, 193, 197, 1);
  --affine-list-color: rgba(133, 131, 140, 1);
  --affine-icon-color: rgb(119, 117, 125);
  --affine-icon-secondary: rgba(119, 117, 125, .6);
  --affine-border-color: rgb(227, 226, 228);
  --affine-divider-color: rgb(227, 226, 228);
  --affine-placeholder-color: rgb(192, 191, 193);
  --affine-edgeless-grid-color: rgb(230, 230, 230);
  --affine-success-color: rgb(16, 203, 134);
  --affine-warning-color: rgb(235, 67, 53);
  --affine-error-color: rgb(235, 67, 53);
  --affine-processing-color: rgb(39, 118, 255);
  --affine-black-10: rgba(0, 0, 0, .1);
  --affine-black-30: rgba(0, 0, 0, .3);
  --affine-black-50: rgba(0, 0, 0, .5);
  --affine-black-60: rgba(0, 0, 0, .6);
  --affine-black-80: rgba(0, 0, 0, .8);
  --affine-black-90: rgba(0, 0, 0, .9);
  --affine-black: rgb(0, 0, 0);
  --affine-white-10: rgba(255, 255, 255, .1);
  --affine-white-30: rgba(255, 255, 255, .3);
  --affine-white-50: rgba(255, 255, 255, .5);
  --affine-white-60: rgba(255, 255, 255, .6);
  --affine-white-80: rgba(255, 255, 255, .8);
  --affine-white-90: rgba(255, 255, 255, .9);
  --affine-white: rgb(255, 255, 255);
  --affine-tag-white: rgba(245, 245, 245, 1);
  --affine-tag-gray: rgba(227, 226, 224, 1);
  --affine-tag-red: rgba(255, 225, 225, 1);
  --affine-tag-orange: rgba(255, 233, 201, 1);
  --affine-tag-yellow: rgba(255, 243, 215, 1);
  --affine-tag-green: rgba(222, 244, 231, 1);
  --affine-tag-teal: rgba(222, 244, 243, 1);
  --affine-tag-blue: rgba(225, 238, 255, 1);
  --affine-tag-purple: rgba(243, 240, 255, 1);
  --affine-tag-pink: rgba(251, 231, 255, 1);
  --affine-tag-magenta: rgba(249, 232, 255, 1);
  --affine-tooltip: rgba(0, 0, 0, 1);
  --affine-button-shadow: 0px 0px 1px 0px rgba(0, 0, 0, .12), 0px 1px 5px 0px rgba(0, 0, 0, .12);
  --affine-overlay-panel-shadow: 0px 1px 6px rgba(0,0,0,.16), 0px 8px 14px rgba(0,0,0,.08);
  --affine-active-shadow: 0px 0px 0px 2px rgba(30, 150, 235, .3);
  --affine-embed-shadow: 0px 0px 0px 2px rgba(0, 0, 0, .08);
  --affine-menu-shadow: 0px 10px 18px rgba(0,0,0,.14), 0px -1px 12px rgba(0,0,0,.08);
  --affine-toolbar-shadow: 0px 6px 16px #00000024;
  --affine-shadow-1: 0px 0px 4px 0px rgba(66, 65, 73, .14);
  --affine-shadow-2: 0px 0px 12px 0px rgba(66, 65, 73, .18);
  --affine-shadow-3: 0px 0px 20px 0px rgba(66, 65, 73, .22);
  --affine-overlay-shadow: 0px 1px 6px 0px rgba(0, 0, 0, .16), 0px 8px 14px 0px rgba(0, 0, 0, .08);
  --affine-popover-shadow: 0px 0px 30px rgba(75, 75, 75, .2), 0px 0px 4px rgba(75, 75, 75, .3), inset 0px 0px 0px rgba(227, 226, 228, 1);
  --affine-float-button-shadow: 0px 0px 10px rgba(0, 0, 0, .05), 0px 0px 0px .5px rgba(0, 0, 0, .1);
  --affine-float-button-shadow-1: 0px 4px 6px -3px rgba(66, 65, 73, .1), 0px 10px 12px -2px rgba(66, 65, 73, .1);
  --affine-float-button-shadow-2: 0px 4px 4px -2px rgba(66, 65, 73, .1), 0px 6px 8px 1px rgba(66, 65, 73, .05);
  --affine-kanban-shadow: 0px 2px 3px 0px rgba(0, 0, 0, .05);
  --affine-cmd-shadow: 0px 10px 80px 0px rgba(0, 0, 0, .2);
  --affine-large-button-effect: 0px 12px 21px 4px rgba(30, 150, 235, .15);
  --affine-note-shadow-box: 0px 0px 4px 0px rgba(0, 0, 0, .14), 0px 2px 12px 0px rgba(0, 0, 0, .14);
  --affine-note-shadow-sticker: 0px 6px 16px 0px rgba(0, 0, 0, .08), 0px 26px 18px -20px rgba(0, 0, 0, .1);
  --affine-note-shadow-paper: 0px 2px 4px 0px rgba(0, 0, 0, .05), 0px 0px 0px 10px #FFF, 0px 3px 6px 12px rgba(0, 0, 0, .14);
  --affine-note-shadow-float: 0px 0px 32px 0px rgba(0, 0, 0, .09), 0px 0px 3px 0px rgba(0, 0, 0, .1);
  --affine-note-shadow-film: 10px 10px 0px 6px #000, 0px 0px 0px 6px #000;
  --affine-ai-empty-shadow: 0px 4px 4px rgba(66, 65, 73, .1), 0px 6px 8px rgba(66, 65, 73, .05);
  --affine-button-gray-color: rgba(245, 245, 245, 1);
  --affine-card-background-blue: linear-gradient(180deg, #F0F3FD 0%, #FCFCFD 100%);
  --affine-card-background-green: linear-gradient(180deg, #F3F9FD 0%, #FCFCFD 100%);
  --affine-card-background-grey: linear-gradient(180deg, #F1F1F1 0%, #FCFCFD 100%);
  --affine-windows-close-button: #C42B1C;
  --affine-text-highlight-pink: rgba(255, 206, 206, 1);
  --affine-text-highlight-red: rgba(254, 213, 213, 1);
  --affine-text-highlight-orange: rgba(254, 223, 187, 1);
  --affine-text-highlight-yellow: rgba(254, 243, 161, 1);
  --affine-text-highlight-green: rgba(225, 250, 177, 1);
  --affine-text-highlight-teal: rgba(173, 248, 233, 1);
  --affine-text-highlight-blue: rgba(204, 226, 254, 1);
  --affine-text-highlight-purple: rgba(237, 221, 255, 1);
  --affine-text-highlight-grey: rgba(234, 236, 239, 1);
  --affine-text-highlight-foreground-red: rgba(198, 34, 34, 1);
  --affine-text-highlight-foreground-orange: rgba(211, 79, 11, 1);
  --affine-text-highlight-foreground-yellow: rgba(182, 124, 4, 1);
  --affine-text-highlight-foreground-green: rgba(20, 147, 67, 1);
  --affine-text-highlight-foreground-teal: rgba(7, 130, 160, 1);
  --affine-text-highlight-foreground-blue: rgba(33, 89, 211, 1);
  --affine-text-highlight-foreground-purple: rgba(132, 46, 211, 1);
  --affine-text-highlight-foreground-grey: rgba(122, 122, 122, 1);
  --affine-note-background-yellow: rgba(253, 230, 138, 1);
  --affine-note-background-orange: rgba(255, 196, 143, 1);
  --affine-note-background-red: rgba(250, 182, 182, 1);
  --affine-note-background-magenta: rgba(255, 218, 237, 1);
  --affine-note-background-purple: rgba(221, 214, 254, 1);
  --affine-note-background-blue: rgba(205, 235, 255, 1);
  --affine-note-background-teal: rgba(199, 248, 242, 1);
  --affine-note-background-green: rgba(201, 248, 193, 1);
  --affine-note-background-black: rgba(0, 0, 0, 1);
  --affine-note-background-grey: rgba(230, 230, 230, 1);
  --affine-note-background-white: rgba(255, 255, 255, 1);
  --affine-v2-aI-applyBackground: #92929212;
  --affine-v2-aI-applyDeleteHighlight: #ed3f3f21;
  --affine-v2-aI-applyTextHighlight: #1e96eb;
  --affine-v2-aI-applyTextHighlightBackground: #1e96eb14;
  --affine-v2-aI-errorBackground: #fff4f5;
  --affine-v2-aI-errorDetailBackground: #ffffff99;
  --affine-v2-aI-errorText: #ed3f3f;
  --affine-v2-aI-thinkingOutputBackground: #0000000d;
  --affine-v2-aI-thinkingOutputText: #000000a6;
  --affine-v2-aI-userTextBackground: #f3f3f3;
  --affine-v2-adjustmentHandle-background: #00000085;
  --affine-v2-adjustmentHandle-border: #ffffff;
  --affine-v2-backlinks-blockBackgroundColor: #9292920d;
  --affine-v2-backlinks-blockBorder: #9292921a;
  --affine-v2-backlinks-blockHover: #0000000d;
  --affine-v2-badge-believer: #002742;
  --affine-v2-badge-free: #29a3fa;
  --affine-v2-badge-pro: #29a3fa;
  --affine-v2-block-callout-background-blue: #f0f9ff;
  --affine-v2-block-callout-background-green: #fbfef1;
  --affine-v2-block-callout-background-grey: #f9f9f9;
  --affine-v2-block-callout-background-magenta: #fefaff;
  --affine-v2-block-callout-background-orange: #fff7ee;
  --affine-v2-block-callout-background-purple: #f9f7ff;
  --affine-v2-block-callout-background-red: #fff4f5;
  --affine-v2-block-callout-background-teal: #eefffd;
  --affine-v2-block-callout-background-yellow: #fdfcf4;
  --affine-v2-block-callout-icon-blue: #53b2ef;
  --affine-v2-block-callout-icon-green: #22bf07;
  --affine-v2-block-callout-icon-grey: #cdcdcd;
  --affine-v2-block-callout-icon-magenta: #cc4187;
  --affine-v2-block-callout-icon-orange: #ffae63;
  --affine-v2-block-callout-icon-purple: #7c3aed;
  --affine-v2-block-callout-icon-red: #c83030;
  --affine-v2-block-callout-icon-teal: #448e86;
  --affine-v2-block-callout-icon-yellow: #fde047;
  --affine-v2-block-code-lineNum: #b3b3b3;
  --affine-v2-block-comment-hanelActive: #1e96eb05;
  --affine-v2-block-comment-highlightActive: #1e96eb4d;
  --affine-v2-block-comment-highlightDefault: #1e96eb14;
  --affine-v2-block-comment-highlightUnderline: #1e96ebb2;
  --affine-v2-block-divider-divider: #92929238;
  --affine-v2-block-footnote-numberBg: #e6e6e6;
  --affine-v2-block-footnote-numberBgHover: #1e96eb;
  --affine-v2-block-list-header: #0077cb;
  --affine-v2-block-notSupportedBlock-background: #ffffff;
  --affine-v2-block-notSupportedBlock-inlineBg-default: #f3f3f3;
  --affine-v2-block-notSupportedBlock-inlineBg-hover: #e6e6e6;
  --affine-v2-block-recordBlock-buttonBg: #f3f3f3;
  --affine-v2-block-recordBlock-primary: #f45353;
  --affine-v2-block-recordBlock-secordary: #ff9a9a;
  --affine-v2-block-recordBlock-timelineIndeicator: #ed3f3f;
  --affine-v2-button-actionActive: #1e96eb14;
  --affine-v2-button-badgesColor: #ed3f3f;
  --affine-v2-button-buttonOverHover: #ffffff;
  --affine-v2-button-checkBox: #1e96eb;
  --affine-v2-button-disable: #b3b3b3;
  --affine-v2-button-emptyIconBackground: #0000000d;
  --affine-v2-button-error: #ed3f3f;
  --affine-v2-button-iconButtonSolid: #ffffff;
  --affine-v2-button-innerBlackBorder: #0000001a;
  --affine-v2-button-primary: #1e96eb;
  --affine-v2-button-pureWhiteText: #ffffff;
  --affine-v2-button-secondary: #ffffff;
  --affine-v2-button-success: #44b931;
  --affine-v2-button-templateLabelBackground: #1e96eb0a;
  --affine-v2-button-grabber-select: #00000038;
  --affine-v2-button-grabber-default: #0000001a;
  --affine-v2-button-mobile-aIActionBackground: #252525;
  --affine-v2-button-mobile-deletedAction: #ed3f3f;
  --affine-v2-button-sidebarButton-background: #ffffff08;
  --affine-v2-button-siderbarPrimary-background: #ffffffab;
  --affine-v2-button-signinbutton-background: #ffffff;
  --affine-v2-calendar-blue: #4ab1fa;
  --affine-v2-calendar-green: #44b931;
  --affine-v2-calendar-grey: #b3b3b3;
  --affine-v2-calendar-magenta: #f37fba;
  --affine-v2-calendar-orange: #ffae63;
  --affine-v2-calendar-purple: #9681ef;
  --affine-v2-calendar-red: #f43f48;
  --affine-v2-calendar-teal: #8be7dc;
  --affine-v2-calendar-yellow: #fde047;
  --affine-v2-centerPeek-background: #ffffff;
  --affine-v2-centerPeek-buttonBackground: #ffffff;
  --affine-v2-centerPeek-icon: #7a7a7a;
  --affine-v2-centerPeek-overlay: #0000002b;
  --affine-v2-chatBlock-chatBlockBg: #ffffff;
  --affine-v2-chatBlock-chatBlockBoder: #e6e6e6;
  --affine-v2-chatBlock-chatBlockIcon: #7a7a7a;
  --affine-v2-chatBlock-chatBlockText: #141414;
  --affine-v2-chip-label-blue: #e6f5ff;
  --affine-v2-chip-label-green: #dcfdd7;
  --affine-v2-chip-label-grey: #e6e6e6;
  --affine-v2-chip-label-magenta: #ffecf6;
  --affine-v2-chip-label-orange: #ffebd5;
  --affine-v2-chip-label-purple: #ede9ff;
  --affine-v2-chip-label-red: #fce5e6;
  --affine-v2-chip-label-teal: #d7fbf6;
  --affine-v2-chip-label-text: #00000085;
  --affine-v2-chip-label-white: #f5f5f5;
  --affine-v2-chip-label-yellow: #fef3c7;
  --affine-v2-chip-tag-blue: #84cfff;
  --affine-v2-chip-tag-green: #69b87d;
  --affine-v2-chip-tag-grey: #b3b3b3;
  --affine-v2-chip-tag-orange: #ff8c38;
  --affine-v2-chip-tag-purple: #7c3aed;
  --affine-v2-chip-tag-red: #ed3f3f;
  --affine-v2-chip-tag-teal: #8be7dc;
  --affine-v2-chip-tag-yellow: #facc15;
  --affine-v2-database-border: #0000001a;
  --affine-v2-database-buttonBackground: #ffffff;
  --affine-v2-database-cardHover: #00000008;
  --affine-v2-database-filterHeaderFadeIn: #ffffff;
  --affine-v2-database-filterHeaderFadeOut: #ffffff08;
  --affine-v2-database-focusBackground: #1e96eb0a;
  --affine-v2-database-textSecondary: #00000085;
  --affine-v2-database-attachment-fileSolidBackground: #e6e6e6;
  --affine-v2-dialog-background-primary: #ffffff;
  --affine-v2-edgeless-alignment-edgeGuides: #cc4187;
  --affine-v2-edgeless-alignment-guides: #8b5cf6;
  --affine-v2-edgeless-frame-background-black: #cdcdcd;
  --affine-v2-edgeless-frame-background-blue: #e6f5ff;
  --affine-v2-edgeless-frame-background-green: #f1fdf4;
  --affine-v2-edgeless-frame-background-grey: #f3f3f3;
  --affine-v2-edgeless-frame-background-magenta: #ffecf6;
  --affine-v2-edgeless-frame-background-orange: #ffebd5;
  --affine-v2-edgeless-frame-background-purple: #ede9ff;
  --affine-v2-edgeless-frame-background-red: #fce5e6;
  --affine-v2-edgeless-frame-background-teal: #e2fdf9;
  --affine-v2-edgeless-frame-background-white: #ffffff;
  --affine-v2-edgeless-frame-background-yellow: #fffbd5;
  --affine-v2-edgeless-frame-border-active: #1e96eb;
  --affine-v2-edgeless-frame-border-default: #0000002b;
  --affine-v2-edgeless-frame-fontColor-font: #000000f2;
  --affine-v2-edgeless-group-background-background: #ffffff;
  --affine-v2-edgeless-group-border-active: #1e96eb;
  --affine-v2-edgeless-group-border-borderHint: #8fd1ff;
  --affine-v2-edgeless-group-border-hover: #1e96eb;
  --affine-v2-edgeless-group-fontColor-active: #1e96eb;
  --affine-v2-edgeless-group-fontColor-default: #00000085;
  --affine-v2-edgeless-group-fontColor-hover: #1e96eb;
  --affine-v2-edgeless-group-fontColor-rename: #000000;
  --affine-v2-edgeless-line-black: #000000;
  --affine-v2-edgeless-line-blue: #29a3fa;
  --affine-v2-edgeless-line-green: #3cbc36;
  --affine-v2-edgeless-line-grey: #929292;
  --affine-v2-edgeless-line-magenta: #e660a4;
  --affine-v2-edgeless-line-orange: #ff8c38;
  --affine-v2-edgeless-line-purple: #6e52df;
  --affine-v2-edgeless-line-red: #e11e41;
  --affine-v2-edgeless-line-teal: #5cc7ba;
  --affine-v2-edgeless-line-white: #ffffff;
  --affine-v2-edgeless-line-yellow: #facc15;
  --affine-v2-edgeless-lock-locked: #92929285;
  --affine-v2-edgeless-mindMap-line: #000000;
  --affine-v2-edgeless-note-black: #b3b3b3;
  --affine-v2-edgeless-note-blue: #ceecff;
  --affine-v2-edgeless-note-green: #c9f8c1;
  --affine-v2-edgeless-note-grey: #e6e6e6;
  --affine-v2-edgeless-note-magenta: #ffdaed;
  --affine-v2-edgeless-note-orange: #ffc58f;
  --affine-v2-edgeless-note-purple: #ddd6fe;
  --affine-v2-edgeless-note-red: #fbb7b7;
  --affine-v2-edgeless-note-teal: #c7f8f2;
  --affine-v2-edgeless-note-white: #ffffff;
  --affine-v2-edgeless-note-yellow: #fde68a;
  --affine-v2-edgeless-palette-black: #000000;
  --affine-v2-edgeless-palette-white: #ffffff;
  --affine-v2-edgeless-palette-heavy-blue: #1c70a5;
  --affine-v2-edgeless-palette-heavy-green: #447756;
  --affine-v2-edgeless-palette-heavy-magenta: #941555;
  --affine-v2-edgeless-palette-heavy-orange: #b55309;
  --affine-v2-edgeless-palette-heavy-purple: #5a21b6;
  --affine-v2-edgeless-palette-heavy-red: #761717;
  --affine-v2-edgeless-palette-heavy-yellow: #ac7400;
  --affine-v2-edgeless-palette-light-blueLight: #e6f5ff;
  --affine-v2-edgeless-palette-light-greenLight: #f1fdf4;
  --affine-v2-edgeless-palette-light-greyLight: #e6e6e6;
  --affine-v2-edgeless-palette-light-magentaLight: #ffecf6;
  --affine-v2-edgeless-palette-light-orangeLight: #ffebd5;
  --affine-v2-edgeless-palette-light-purpleLight: #ede9ff;
  --affine-v2-edgeless-palette-light-redLight: #fce5e6;
  --affine-v2-edgeless-palette-light-yellowLight: #fffbd5;
  --affine-v2-edgeless-palette-medium-blueMedium: #84cfff;
  --affine-v2-edgeless-palette-medium-greenMedium: #3cbc36;
  --affine-v2-edgeless-palette-medium-greyMedium: #929292;
  --affine-v2-edgeless-palette-medium-magentaMedium: #e96cab;
  --affine-v2-edgeless-palette-medium-orangeMedium: #ff8c38;
  --affine-v2-edgeless-palette-medium-purpleMedium: #6e52df;
  --affine-v2-edgeless-palette-medium-redMedium: #fb7081;
  --affine-v2-edgeless-palette-medium-yellowMedium: #fcd34d;
  --affine-v2-edgeless-selection-selectionMarqueeBackground: #1e96eb14;
  --affine-v2-edgeless-selection-selectionMarqueeBorder: #1e96eb;
  --affine-v2-edgeless-shape-black: #000000;
  --affine-v2-edgeless-shape-blue: #9fd9ff;
  --affine-v2-edgeless-shape-green: #9bda91;
  --affine-v2-edgeless-shape-grey: #cdcdcd;
  --affine-v2-edgeless-shape-magenta: #ffc0e0;
  --affine-v2-edgeless-shape-orange: #ffae63;
  --affine-v2-edgeless-shape-purple: #d7cdff;
  --affine-v2-edgeless-shape-red: #fecdd1;
  --affine-v2-edgeless-shape-teal: #8be7dc;
  --affine-v2-edgeless-shape-white: #ffffff;
  --affine-v2-edgeless-shape-yellow: #fde047;
  --affine-v2-edgelessToolbar-highlightPen-body: #fafafa;
  --affine-v2-edgelessToolbar-highlightPen-body1Linear1-1: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body1Linear1-2: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body1Linear1-3: #000000;
  --affine-v2-edgelessToolbar-highlightPen-body1Linear2-1: #ffffff00;
  --affine-v2-edgelessToolbar-highlightPen-body1Linear2-2: #ffffff00;
  --affine-v2-edgelessToolbar-highlightPen-body1Linear2-3: #ffffff00;
  --affine-v2-edgelessToolbar-highlightPen-body1Linear2-4: #ffffff00;
  --affine-v2-edgelessToolbar-highlightPen-body2: #f3f3f3;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear1-1: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear1-2: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear1-3: #000000;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear2-1: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear2-2: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear2-3: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear2-4: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear2-5: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-bodyColorLinear-1: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-bodyColorLinear-2: #000000fc;
  --affine-v2-edgelessToolbar-highlightPen-bodyColorLinear-3: #000000c4;
  --affine-v2-edgelessToolbar-media-whiteVector: #ffffff8f;
  --affine-v2-edgelessToolbar-note-background: #ffffff;
  --affine-v2-edgelessToolbar-note-textColor: #0000001a;
  --affine-v2-edgelessToolbar-others-background: #ffffff1f;
  --affine-v2-edgelessToolbar-others-highlightLinearEnd: #ffffff;
  --affine-v2-edgelessToolbar-others-highlightLinearStart: #ffffff00;
  --affine-v2-edgelessToolbar-others-linearCenter: #000000c4;
  --affine-v2-edgelessToolbar-others-linearEnd: #0000001f;
  --affine-v2-edgelessToolbar-others-linearStart: #ffffff1f;
  --affine-v2-edgelessToolbar-penEraser-eraserBlue-1: #173654;
  --affine-v2-edgelessToolbar-penEraser-eraserBlue-2: #effaff;
  --affine-v2-edgelessToolbar-penEraser-eraserBlue-3: #1e96eb;
  --affine-v2-edgelessToolbar-penEraser-eraserBodyFill: #f1f1f1;
  --affine-v2-edgelessToolbar-penEraser-eraserBodyHighlight: #ffffff8f;
  --affine-v2-edgelessToolbar-penEraser-eraserBodyShade2: #00000033;
  --affine-v2-edgelessToolbar-penEraser-eraserBodyShade3: #ffffff;
  --affine-v2-edgelessToolbar-penEraser-eraserBorder: #e7e7e7;
  --affine-v2-edgelessToolbar-penEraser-eraserBorder2: #e3e2e4;
  --affine-v2-edgelessToolbar-penEraser-eraserClothHighlight: #ffffff1c;
  --affine-v2-edgelessToolbar-penEraser-eraserClothShade2: #0f0f0f;
  --affine-v2-edgelessToolbar-penEraser-eraserClothShade3: #ffffff17;
  --affine-v2-edgelessToolbar-penEraser-eraserShadow: #00000040;
  --affine-v2-edgelessToolbar-penEraser-penBackground: #fafafa;
  --affine-v2-edgelessToolbar-penEraser-penBodyShade-1: #00000033;
  --affine-v2-edgelessToolbar-penEraser-penBodyShade-2: #0000001a;
  --affine-v2-edgelessToolbar-penEraser-penBodyShade-3: #00000003;
  --affine-v2-edgelessToolbar-penEraser-penBodyShade-4: #ffffff14;
  --affine-v2-edgelessToolbar-penEraser-penInlineShadow: #ffffff00;
  --affine-v2-icon-activated: #1e96eb;
  --affine-v2-icon-disable: #b3b3b3;
  --affine-v2-icon-fileIconBorder: #cdcdcd;
  --affine-v2-icon-monotone: #7a7a7a;
  --affine-v2-icon-primary: #7a7a7a;
  --affine-v2-icon-secondary: #b3b3b3;
  --affine-v2-icon-tertiary: #cdcdcd;
  --affine-v2-icon-transparentBlack: #00000085;
  --affine-v2-icon-fileIconColors-blue: #0077cb;
  --affine-v2-icon-fileIconColors-green: #1d9c07;
  --affine-v2-icon-fileIconColors-grey: #1e1b4b;
  --affine-v2-icon-fileIconColors-magenta: #e660a4;
  --affine-v2-icon-fileIconColors-purple: #6e52df;
  --affine-v2-icon-fileIconColors-red: #ed3f3f;
  --affine-v2-icon-fileIconColors-yellow: #facc15;
  --affine-v2-input-background: #ffffff;
  --affine-v2-input-scrollBar-handle: #0000001a;
  --affine-v2-input-border-active: #1e96eb;
  --affine-v2-input-border-default: #0000001a;
  --affine-v2-input-border-error: #ed3f3f;
  --affine-v2-integrations-background-iconSolid: #ffffff;
  --affine-v2-layer-black: #000000;
  --affine-v2-layer-pureBlack: #000000;
  --affine-v2-layer-pureWhite: #ffffff;
  --affine-v2-layer-white: #ffffff;
  --affine-v2-layer-insideBorder-blackBorder: #0000001a;
  --affine-v2-layer-insideBorder-border: #e6e6e6;
  --affine-v2-layer-insideBorder-primaryBorder: #1e96eb;
  --affine-v2-layer-insideBorder-splitviewActived: #0000002b;
  --affine-v2-layer-insideBorder-whiteBorder: #ffffff8f;
  --affine-v2-layer-background-codeBlock: #f5f5f5;
  --affine-v2-layer-background-edgelessGrid: #e6e6e6;
  --affine-v2-layer-background-error: #fff1f1;
  --affine-v2-layer-background-hoverOverlay: #0000000d;
  --affine-v2-layer-background-linkedDocOnEdgeless: #ffffff;
  --affine-v2-layer-background-modal: #000000b2;
  --affine-v2-layer-background-modalWhite: #ffffff2b;
  --affine-v2-layer-background-overlayPanel: #ffffff;
  --affine-v2-layer-background-primary: #ffffff;
  --affine-v2-layer-background-processing: #eef2ff;
  --affine-v2-layer-background-secondary: #f5f5f5;
  --affine-v2-layer-background-success: #f1fdf4;
  --affine-v2-layer-background-tertiary: #f3f3f3;
  --affine-v2-layer-background-translucentUI: #ffffffb8;
  --affine-v2-layer-background-warning: #fff7ee;
  --affine-v2-layer-background-mobile-iOSControl: #000000;
  --affine-v2-layer-background-mobile-modal: #0000002b;
  --affine-v2-layer-background-mobile-primary: #f5f5f5;
  --affine-v2-layer-background-mobile-secondary: #ffffff;
  --affine-v2-layer-background-mobile-tertiary: #e6e6e6;
  --affine-v2-loading-background: #0000001a;
  --affine-v2-loading-backgroundLayer: #92929238;
  --affine-v2-loading-foreground: #1e96eb;
  --affine-v2-loading-imageLoadingBackground: #92929238;
  --affine-v2-loading-imageLoadingLayer: #ffffff8f;
  --affine-v2-others-warnLabel-black: #000000;
  --affine-v2-others-warnLabel-yellow: #facc15;
  --affine-v2-pagelist-hoverBorder: #e6e6e6;
  --affine-v2-portrait-localPortrait: #00000038;
  --affine-v2-portrait-localPortraitBackground: #0000001a;
  --affine-v2-radio-disable: #cdcdcd;
  --affine-v2-radio-active-chekced: #1e96eb;
  --affine-v2-radio-active-default: #7a7a7a;
  --affine-v2-readwise-quoteBackground: #f9f9f9;
  --affine-v2-readwise-quoteDivider: #1e96eb;
  --affine-v2-segment-background: #0000000d;
  --affine-v2-segment-button: #ffffff;
  --affine-v2-selfhost-portrait-localPortraitBackground: #0000000d;
  --affine-v2-selfhost-button-disable: #7a7a7a;
  --affine-v2-selfhost-button-primary: #141414;
  --affine-v2-selfhost-button-secondary: #ffffff;
  --affine-v2-selfhost-button-sidebarButton-bg-hover: #0000000d;
  --affine-v2-selfhost-button-sidebarButton-bg-select: #0000000d;
  --affine-v2-selfhost-icon-buttonIcon: #ffffff;
  --affine-v2-selfhost-icon-buttonIconError: #ffffff;
  --affine-v2-selfhost-icon-disable: #b3b3b3;
  --affine-v2-selfhost-icon-primary: #141414;
  --affine-v2-selfhost-icon-secondary: #7a7a7a;
  --affine-v2-selfhost-icon-tertiary: #b3b3b3;
  --affine-v2-selfhost-layer-background-hoverOverlay: #ffffff3b;
  --affine-v2-selfhost-layer-background-primary: #ffffff;
  --affine-v2-selfhost-layer-background-secondary: #f9f9f9;
  --affine-v2-selfhost-layer-background-sidebarBg-sidebarBg: #f9f9f9;
  --affine-v2-selfhost-layer-border-border: #141414;
  --affine-v2-selfhost-progress-error: #ed3f3f;
  --affine-v2-selfhost-progress-primary: #141414;
  --affine-v2-selfhost-text-placeholder: #b3b3b3;
  --affine-v2-selfhost-text-button-error: #ffffff;
  --affine-v2-selfhost-text-button-primary: #ffffff;
  --affine-v2-selfhost-text-sidebar-primary: #141414;
  --affine-v2-selfhost-text-sidebar-secondary: #252525;
  --affine-v2-selfhost-toggle-backgroundDisable: #e6e6e6;
  --affine-v2-selfhost-toggle-backgroundOff: #cdcdcd;
  --affine-v2-selfhost-toggle-backgroundOn: #141414;
  --affine-v2-selfhost-toggle-foreground: #ffffff;
  --affine-v2-selfhost-toggle-foregroundDisable: #f9f9f9;
  --affine-v2-skeleton-skeleton: #e6e6e6;
  --affine-v2-slashMenu-background: #ffffff;
  --affine-v2-status-error: #ed3f3f;
  --affine-v2-status-success: #44b931;
  --affine-v2-switch-buttonBackground-active: #ffffff;
  --affine-v2-switch-buttonBackground-hover: #0000000d;
  --affine-v2-switch-fontColor-primary: #141414;
  --affine-v2-switch-fontColor-secondary: #7a7a7a;
  --affine-v2-switch-fontColor-tertiary: #929292;
  --affine-v2-switch-iconColor-active: #565656;
  --affine-v2-switch-iconColor-default: #929292;
  --affine-v2-switch-switchBackground-background: #f3f3f3;
  --affine-v2-tab-divider-divider: #00000012;
  --affine-v2-tab-divider-indicator: #1e96eb;
  --affine-v2-tab-fontColor-active: #141414;
  --affine-v2-tab-fontColor-default: #b3b3b3;
  --affine-v2-tab-fontColor-hover: #141414;
  --affine-v2-tab-iconColor-active: #565656;
  --affine-v2-tab-iconColor-default: #b3b3b3;
  --affine-v2-tab-iconColor-hover: #565656;
  --affine-v2-tab-tabBackground-active: #ffffff;
  --affine-v2-tab-tabBackground-default: #f3f3f3;
  --affine-v2-tab-tabBackground-hover: #f3f3f3;
  --affine-v2-table-border: #0000001a;
  --affine-v2-table-focusBackground: #1e96eb0a;
  --affine-v2-table-focusBorder: #1e96eb;
  --affine-v2-table-textSecondary: #00000085;
  --affine-v2-table-headerBackground-blue: #f0f9ff;
  --affine-v2-table-headerBackground-default: #ffffff;
  --affine-v2-table-headerBackground-green: #efffec;
  --affine-v2-table-headerBackground-grey: #f5f5f5;
  --affine-v2-table-headerBackground-headerColor: #f3f3f3;
  --affine-v2-table-headerBackground-orange: #fff7ee;
  --affine-v2-table-headerBackground-purple: #f7f5ff;
  --affine-v2-table-headerBackground-red: #fff4f5;
  --affine-v2-table-headerBackground-teal: #eefffd;
  --affine-v2-table-headerBackground-yellow: #fffded;
  --affine-v2-table-indicator-activated: #1e96eb;
  --affine-v2-table-indicator-border: #e6e6e6;
  --affine-v2-table-indicator-drag: #0000002b;
  --affine-v2-table-indicator-hover: #0000000d;
  --affine-v2-table-indicator-pointerActive: #ffffff;
  --affine-v2-table-indicator-pointerDefault: #b3b3b3;
  --affine-v2-text-disable: #7a7a7a;
  --affine-v2-text-emphasis: #1e96eb;
  --affine-v2-text-link: #035f9f;
  --affine-v2-text-listDotAndNumber: #0077cb;
  --affine-v2-text-placeholder: #929292;
  --affine-v2-text-primary: #141414;
  --affine-v2-text-pureWhite: #ffffff;
  --affine-v2-text-secondary: #7a7a7a;
  --affine-v2-text-tertiary: #929292;
  --affine-v2-text-highlight-border: #00000038;
  --affine-v2-text-highlight-bg-blue: #daf0ff;
  --affine-v2-text-highlight-bg-green: #f0fccb;
  --affine-v2-text-highlight-bg-grey: #e6e6e6;
  --affine-v2-text-highlight-bg-magenta: #ffecf6;
  --affine-v2-text-highlight-bg-orange: #ffebd5;
  --affine-v2-text-highlight-bg-purple: #ede9ff;
  --affine-v2-text-highlight-bg-red: #fce5e6;
  --affine-v2-text-highlight-bg-teal: #c7f8f2;
  --affine-v2-text-highlight-bg-yellow: #fff9b6;
  --affine-v2-text-highlight-fg-blue: #003c67;
  --affine-v2-text-highlight-fg-green: #225c18;
  --affine-v2-text-highlight-fg-grey: #7a7a7a;
  --affine-v2-text-highlight-fg-magenta: #941555;
  --affine-v2-text-highlight-fg-orange: #db7123;
  --affine-v2-text-highlight-fg-purple: #7c3aed;
  --affine-v2-text-highlight-fg-red: #c83030;
  --affine-v2-text-highlight-fg-teal: #0e4841;
  --affine-v2-text-highlight-fg-yellow: #ac7400;
  --affine-v2-toast-cardLayer-second: #f9f9f9;
  --affine-v2-toast-cardLayer-third: #f5f5f5;
  --affine-v2-toast-iconState-error: #ed3f3f;
  --affine-v2-toast-iconState-regular: #0077cb;
  --affine-v2-toast-iconState-success: #44b931;
  --affine-v2-toast-overlay-secondary: #00000008;
  --affine-v2-toast-overlay-tertiary: #0000000d;
  --affine-v2-toggle-background: #1e96eb;
  --affine-v2-toggle-backgroundDisable: #b3b3b3;
  --affine-v2-toggle-backgroundOff: #929292;
  --affine-v2-toggle-foreground: #ffffff;
  --affine-v2-toggle-foregroundDisable: #e6e6e6;
  --affine-v2-tooltips-background: #000000;
  --affine-v2-tooltips-foreground: #ffffff;
  --affine-v2-tooltips-secondaryBackground: #ffffff2b;
  --affine-v2-workspacePicker-border: #e6e6e6;
  --affine-v2-workspacePicker-secondaryBackground: #9292921a;
  --affine-v2-tableOfContent-background: #ffffff;
}
[data-theme=dark] {
  --affine-theme-mode: dark;
  --affine-brand-color: #1E96EB;
  --affine-primary-color: #1C9EE4;
  --affine-primary-color-04: rgba(52, 116, 173, .1);
  --affine-secondary-color: rgb(144, 150, 245);
  --affine-tertiary-color: rgb(30, 30, 30);
  --affine-blue-950: rgba(32, 45, 55, 1);
  --affine-blue-50: rgba(181, 208, 242, 1);
  --affine-blue-100: rgba(171, 204, 237, 1);
  --affine-blue-200: rgba(149, 194, 234, 1);
  --affine-blue-300: rgba(115, 182, 226, 1);
  --affine-blue-400: rgba(79, 162, 216, 1);
  --affine-blue-500: rgba(53, 140, 208, 1);
  --affine-blue-600: rgba(52, 116, 173, 1);
  --affine-blue-700: rgba(55, 106, 154, 1);
  --affine-blue-800: rgba(51, 88, 122, 1);
  --affine-blue-900: rgba(47, 75, 96, 1);
  --affine-hover-color: rgba(255, 255, 255, .1);
  --affine-hover-color-filled: rgb(42, 42, 42);
  --affine-icon-color: rgb(168, 168, 160);
  --affine-icon-secondary: rgba(168,168,160,.6);
  --affine-border-color: rgba(46, 46, 46, 1);
  --affine-divider-color: rgb(114, 114, 114);
  --affine-placeholder-color: rgb(62, 62, 63);
  --affine-quote-color: rgba(142, 141, 145, 1);
  --affine-list-color: rgba(156, 155, 160, 1);
  --affine-link-color: #78BEFF;
  --affine-edgeless-grid-color: rgba(49, 49, 49, .35);
  --affine-success-color: rgb(13, 162, 107);
  --affine-warning-color: rgb(188, 54, 42);
  --affine-error-color: rgb(188, 54, 42);
  --affine-processing-color: rgb(31, 94, 204);
  --affine-text-emphasis-color: #1E96EB;
  --affine-text-primary-color: rgb(234, 234, 234);
  --affine-text-secondary-color: rgb(156, 156, 160);
  --affine-text-disable-color: rgb(119, 117, 125);
  --affine-black-10: rgba(255, 255, 255, .1);
  --affine-black-30: rgba(255, 255, 255, .3);
  --affine-black-50: rgba(255, 255, 255, .5);
  --affine-black-60: rgba(255, 255, 255, .6);
  --affine-black-80: rgba(255, 255, 255, .8);
  --affine-black-90: rgba(255, 255, 255, .9);
  --affine-black: rgb(255, 255, 255);
  --affine-white-10: rgba(0, 0, 0, .1);
  --affine-white-30: rgba(0, 0, 0, .3);
  --affine-white-50: rgba(0, 0, 0, .5);
  --affine-white-60: rgba(0, 0, 0, .6);
  --affine-white-80: rgba(0, 0, 0, .8);
  --affine-white-90: rgba(0, 0, 0, .9);
  --affine-white: rgb(0, 0, 0);
  --affine-background-code-block: rgba(31, 32, 34, 1);
  --affine-background-tertiary-color: rgb(48, 48, 48);
  --affine-background-processing-color: rgba(22, 32, 48, 1);
  --affine-background-error-color: rgba(46, 26, 24, 1);
  --affine-background-warning-color: rgba(48, 35, 19, 1);
  --affine-background-success-color: rgba(20, 42, 34, 1);
  --affine-background-primary-color: rgb(20, 20, 20);
  --affine-background-secondary-color: rgba(37, 37, 37, 1);
  --affine-background-modal-color: rgba(0, 0, 0, .5);
  --affine-background-overlay-panel-color: rgb(30, 30, 30);
  --affine-tag-blue: rgba(8, 67, 136, 1);
  --affine-tag-green: rgba(44, 108, 63, 1);
  --affine-tag-teal: rgba(26, 115, 110, 1);
  --affine-tag-white: rgba(67, 67, 67, 1);
  --affine-tag-purple: rgba(47, 30, 113, 1);
  --affine-tag-red: rgba(111, 50, 50, 1);
  --affine-tag-pink: rgba(155, 106, 106, 1);
  --affine-tag-magenta: rgba(105, 47, 111, 1);
  --affine-tag-yellow: rgba(150, 132, 49, 1);
  --affine-tag-orange: rgba(185, 129, 46, 1);
  --affine-tag-gray: rgba(41, 41, 41, 1);
  --affine-tooltip: rgba(234, 234, 234, 1);
  --affine-button-shadow: 0px 0px 1px 0px rgba(0, 0, 0, .2), 0px 1px 5px 0px rgba(0, 0, 0, .2);
  --affine-overlay-panel-shadow: 0px 1px 6px rgba(0,0,0,.2), 0px 8px 14px rgba(0,0,0,.3);
  --affine-active-shadow: 0px 0px 0px 2px rgba(28, 158, 228, .3);
  --affine-embed-shadow: 0px 0px 0px 2px rgba(255, 255, 255, .14);
  --affine-menu-shadow: 0px 10px 18px rgba(0,0,0,.14), 0px -1px 12px rgba(0,0,0,.08);
  --affine-toolbar-shadow: 0px 6px 18px #00000052;
  --affine-shadow-1: 0px 0px 4px 0px rgba(0, 0, 0, .24);
  --affine-shadow-2: 0px 0px 12px 0px rgba(0, 0, 0, .28);
  --affine-shadow-3: 0px 0px 20px 0px rgba(0, 0, 0, .32);
  --affine-overlay-shadow: 0px 1px 6px 0px rgba(0, 0, 0, .72), 0px 8px 14px 0px rgba(0, 0, 0, .32);
  --affine-popover-shadow: 0px 0px 30px 0px rgba(0, 0, 0, .1), 0px 0px 8px 0px rgba(0, 0, 0, .18), 0px 0px 0px .5px rgba(48, 48, 48, 1) inset;
  --affine-float-button-shadow: 0px 0px 10px rgba(0, 0, 0, .05), 0px 0px 0px .5px rgba(0, 0, 0, .1);
  --affine-float-button-shadow-1: 0px 4px 6px -3px rgba(0, 0, 0, .1), 0px 10px 12px -2px rgba(0, 0, 0, .1);
  --affine-float-button-shadow-2: 0px 4px 4px -2px rgba(15, 15, 15, .1), 0px 6px 8px 1px rgba(15, 15, 15, .05);
  --affine-kanban-shadow: 0px 2px 3px 0px rgba(0, 0, 0, .6);
  --affine-cmd-shadow: 0px 16px 80px 0px rgba(0, 0, 0, .8);
  --affine-large-button-effect: 0px 12px 20px 4px rgba(28, 158, 228, .18);
  --affine-note-shadow-box: 0px 0px 2px 0px rgba(255, 255, 255, .44), 0px 2px 12px 0px rgba(0, 0, 0, .3);
  --affine-note-shadow-sticker: 0px 24px 26px -10px rgba(0, 0, 0, .22), 0px 26px 18px -18px rgba(0, 0, 0, .52);
  --affine-note-shadow-paper: 0px 2px 4px 0px rgba(0, 0, 0, .3), 0px 0px 10px #7A7A7A, 0px 6px 12px rgba(0, 0, 0, .4);
  --affine-note-shadow-float: 0px 0px 32px 0px rgba(0, 0, 0, .3), 0px 0px 2px 0px rgba(255, 255, 255, .44);
  --affine-note-shadow-film: 10px 10px 0px 6px #7A7A7A, 0px 0px 0px 6px #7A7A7A;
  --affine-ai-empty-shadow: 0px 4px 4px rgba(66, 65, 73, .1), 0px 6px 8px rgba(66, 65, 73, .05);
  --affine-button-gray-color: rgba(85, 85, 85, 1);
  --affine-card-background-blue: linear-gradient(180deg, #14171F 0%, #202020 100%);
  --affine-card-background-green: linear-gradient(180deg, #192023 0%, #202020 100%);
  --affine-card-background-grey: linear-gradient(180deg, #313131 0%, #202020 100%);
  --affine-windows-close-button: #C42B1C;
  --affine-text-highlight-pink: rgba(127, 93, 93, 1);
  --affine-text-highlight-red: rgba(108, 39, 39, 1);
  --affine-text-highlight-orange: rgba(112, 58, 21, 1);
  --affine-text-highlight-yellow: rgba(106, 84, 15, 1);
  --affine-text-highlight-green: rgba(26, 91, 50, 1);
  --affine-text-highlight-teal: rgba(14, 85, 97, 1);
  --affine-text-highlight-blue: rgba(56, 75, 122, 1);
  --affine-text-highlight-purple: rgba(80, 46, 111, 1);
  --affine-text-highlight-grey: rgba(64, 67, 74, 1);
  --affine-text-highlight-foreground-red: rgba(249, 141, 141, 1);
  --affine-text-highlight-foreground-orange: rgba(252, 168, 99, 1);
  --affine-text-highlight-foreground-yellow: rgba(251, 214, 68, 1);
  --affine-text-highlight-foreground-green: rgba(110, 229, 153, 1);
  --affine-text-highlight-foreground-teal: rgba(87, 221, 204, 1);
  --affine-text-highlight-foreground-blue: rgba(128, 183, 251, 1);
  --affine-text-highlight-foreground-purple: rgba(205, 157, 253, 1);
  --affine-text-highlight-foreground-grey: rgba(86, 86, 86, 1);
  --affine-note-background-yellow: rgba(111, 65, 0, 1);
  --affine-note-background-orange: rgba(132, 59, 6, 1);
  --affine-note-background-red: rgba(118, 23, 23, 1);
  --affine-note-background-magenta: rgba(148, 21, 85, 1);
  --affine-note-background-purple: rgba(49, 46, 129, 1);
  --affine-note-background-blue: rgba(3, 95, 159, 1);
  --affine-note-background-teal: rgba(28, 107, 99, 1);
  --affine-note-background-green: rgba(59, 83, 21, 1);
  --affine-note-background-black: rgba(255, 255, 255, 1);
  --affine-note-background-grey: rgba(86, 86, 86, 1);
  --affine-note-background-white: rgba(0, 0, 0, 1);
  --affine-v2-aI-applyBackground: #9292921a;
  --affine-v2-aI-applyDeleteHighlight: #ed3f3f3b;
  --affine-v2-aI-applyTextHighlight: #29a3fa;
  --affine-v2-aI-applyTextHighlightBackground: #1e96eb1a;
  --affine-v2-aI-errorBackground: #ed3f3f2e;
  --affine-v2-aI-errorDetailBackground: #00000054;
  --affine-v2-aI-errorText: #fff4f5;
  --affine-v2-aI-thinkingOutputBackground: #000000;
  --affine-v2-aI-thinkingOutputText: #ffffff8f;
  --affine-v2-aI-userTextBackground: #252525;
  --affine-v2-adjustmentHandle-background: #00000085;
  --affine-v2-adjustmentHandle-border: #ffffff;
  --affine-v2-backlinks-blockBackgroundColor: #9292921a;
  --affine-v2-backlinks-blockBorder: #9292922b;
  --affine-v2-backlinks-blockHover: #9292922b;
  --affine-v2-badge-believer: #002742;
  --affine-v2-badge-free: #29a3fa;
  --affine-v2-badge-pro: #29a3fa;
  --affine-v2-block-callout-background-blue: #002742;
  --affine-v2-block-callout-background-green: #192e06;
  --affine-v2-block-callout-background-grey: #414141;
  --affine-v2-block-callout-background-magenta: #5f0a35;
  --affine-v2-block-callout-background-orange: #451a02;
  --affine-v2-block-callout-background-purple: #1e1b4b;
  --affine-v2-block-callout-background-red: #460606;
  --affine-v2-block-callout-background-teal: #0e4841;
  --affine-v2-block-callout-background-yellow: #321a04;
  --affine-v2-block-callout-icon-blue: #2f94d5;
  --affine-v2-block-callout-icon-green: #22bf07;
  --affine-v2-block-callout-icon-grey: #cdcdcd;
  --affine-v2-block-callout-icon-magenta: #cc4187;
  --affine-v2-block-callout-icon-orange: #d97705;
  --affine-v2-block-callout-icon-purple: #7c3aed;
  --affine-v2-block-callout-icon-red: #c83030;
  --affine-v2-block-callout-icon-teal: #5cc7ba;
  --affine-v2-block-callout-icon-yellow: #e0aa00;
  --affine-v2-block-code-lineNum: #7a7a7a;
  --affine-v2-block-comment-hanelActive: #ffffff0d;
  --affine-v2-block-comment-highlightActive: #1e96eb4d;
  --affine-v2-block-comment-highlightDefault: #1e96eb14;
  --affine-v2-block-comment-highlightUnderline: #1e96ebb2;
  --affine-v2-block-divider-divider: #9292922b;
  --affine-v2-block-footnote-numberBg: #565656;
  --affine-v2-block-footnote-numberBgHover: #1e96eb;
  --affine-v2-block-list-header: #4ab1fa;
  --affine-v2-block-notSupportedBlock-background: #000000;
  --affine-v2-block-notSupportedBlock-inlineBg-default: #252525;
  --affine-v2-block-notSupportedBlock-inlineBg-hover: #414141;
  --affine-v2-block-recordBlock-buttonBg: #761717;
  --affine-v2-block-recordBlock-primary: #f45353;
  --affine-v2-block-recordBlock-secordary: #c83030;
  --affine-v2-block-recordBlock-timelineIndeicator: #ed3f3f;
  --affine-v2-button-actionActive: #ffffff0d;
  --affine-v2-button-badgesColor: #c83030;
  --affine-v2-button-buttonOverHover: #414141;
  --affine-v2-button-checkBox: #1e96eb;
  --affine-v2-button-disable: #7a7a7a;
  --affine-v2-button-emptyIconBackground: #ffffff0d;
  --affine-v2-button-error: #c83030;
  --affine-v2-button-iconButtonSolid: #ffffff17;
  --affine-v2-button-innerBlackBorder: #ffffff0d;
  --affine-v2-button-primary: #1e96eb;
  --affine-v2-button-pureWhiteText: #ffffff;
  --affine-v2-button-secondary: #ffffff17;
  --affine-v2-button-success: #1d9c07;
  --affine-v2-button-templateLabelBackground: #1e96eb14;
  --affine-v2-button-grabber-select: #ffffff21;
  --affine-v2-button-grabber-default: #ffffff17;
  --affine-v2-button-mobile-aIActionBackground: #252525;
  --affine-v2-button-mobile-deletedAction: #c83030;
  --affine-v2-button-sidebarButton-background: #ffffff08;
  --affine-v2-button-siderbarPrimary-background: #0000002b;
  --affine-v2-button-signinbutton-background: #414141;
  --affine-v2-calendar-blue: #29a3fa;
  --affine-v2-calendar-green: #3cbc36;
  --affine-v2-calendar-grey: #929292;
  --affine-v2-calendar-magenta: #e660a4;
  --affine-v2-calendar-orange: #ff8c38;
  --affine-v2-calendar-purple: #6e52df;
  --affine-v2-calendar-red: #ed3f3f;
  --affine-v2-calendar-teal: #5cc7ba;
  --affine-v2-calendar-yellow: #facc15;
  --affine-v2-centerPeek-background: #000000;
  --affine-v2-centerPeek-buttonBackground: #252525;
  --affine-v2-centerPeek-icon: #cdcdcd;
  --affine-v2-centerPeek-overlay: #00000085;
  --affine-v2-chatBlock-chatBlockBg: #252525;
  --affine-v2-chatBlock-chatBlockBoder: #414141;
  --affine-v2-chatBlock-chatBlockIcon: #cdcdcd;
  --affine-v2-chatBlock-chatBlockText: #e6e6e6;
  --affine-v2-chip-label-blue: #004b7b;
  --affine-v2-chip-label-green: #225c18;
  --affine-v2-chip-label-grey: #414141;
  --affine-v2-chip-label-magenta: #5f0a35;
  --affine-v2-chip-label-orange: #843b06;
  --affine-v2-chip-label-purple: #25136d;
  --affine-v2-chip-label-red: #460606;
  --affine-v2-chip-label-teal: #1c6b63;
  --affine-v2-chip-label-text: #ffffffab;
  --affine-v2-chip-label-white: #252525;
  --affine-v2-chip-label-yellow: #ac7400;
  --affine-v2-chip-tag-blue: #84cfff;
  --affine-v2-chip-tag-green: #69b87d;
  --affine-v2-chip-tag-grey: #b3b3b3;
  --affine-v2-chip-tag-orange: #ff8c38;
  --affine-v2-chip-tag-purple: #7c3aed;
  --affine-v2-chip-tag-red: #ed3f3f;
  --affine-v2-chip-tag-teal: #8be7dc;
  --affine-v2-chip-tag-yellow: #facc15;
  --affine-v2-database-border: #ffffff21;
  --affine-v2-database-buttonBackground: #414141;
  --affine-v2-database-cardHover: #ffffff08;
  --affine-v2-database-filterHeaderFadeIn: #000000;
  --affine-v2-database-filterHeaderFadeOut: #00000008;
  --affine-v2-database-focusBackground: #1e96eb0a;
  --affine-v2-database-textSecondary: #ffffff8f;
  --affine-v2-database-attachment-fileSolidBackground: #414141;
  --affine-v2-dialog-background-primary: #252525;
  --affine-v2-edgeless-alignment-edgeGuides: #e660a4;
  --affine-v2-edgeless-alignment-guides: #8b5cf6;
  --affine-v2-edgeless-frame-background-black: #cdcdcd;
  --affine-v2-edgeless-frame-background-blue: #e6f5ff;
  --affine-v2-edgeless-frame-background-green: #f1fdf4;
  --affine-v2-edgeless-frame-background-grey: #f3f3f3;
  --affine-v2-edgeless-frame-background-magenta: #ffecf6;
  --affine-v2-edgeless-frame-background-orange: #ffebd5;
  --affine-v2-edgeless-frame-background-purple: #ede9ff;
  --affine-v2-edgeless-frame-background-red: #fce5e6;
  --affine-v2-edgeless-frame-background-teal: #e2fdf9;
  --affine-v2-edgeless-frame-background-white: #ffffff;
  --affine-v2-edgeless-frame-background-yellow: #fffbd5;
  --affine-v2-edgeless-frame-border-active: #1e96eb;
  --affine-v2-edgeless-frame-border-default: #ffffff2b;
  --affine-v2-edgeless-frame-fontColor-font: #000000f2;
  --affine-v2-edgeless-group-background-background: #ffffff;
  --affine-v2-edgeless-group-border-active: #1e96eb;
  --affine-v2-edgeless-group-border-borderHint: #8fd1ff;
  --affine-v2-edgeless-group-border-hover: #1e96eb;
  --affine-v2-edgeless-group-fontColor-active: #1e96eb;
  --affine-v2-edgeless-group-fontColor-default: #ffffff8f;
  --affine-v2-edgeless-group-fontColor-hover: #1e96eb;
  --affine-v2-edgeless-group-fontColor-rename: #000000;
  --affine-v2-edgeless-line-black: #000000;
  --affine-v2-edgeless-line-blue: #29a3fa;
  --affine-v2-edgeless-line-green: #3cbc36;
  --affine-v2-edgeless-line-grey: #929292;
  --affine-v2-edgeless-line-magenta: #e660a4;
  --affine-v2-edgeless-line-orange: #ff8c38;
  --affine-v2-edgeless-line-purple: #6e52df;
  --affine-v2-edgeless-line-red: #ed3f3f;
  --affine-v2-edgeless-line-teal: #5cc7ba;
  --affine-v2-edgeless-line-white: #ffffff;
  --affine-v2-edgeless-line-yellow: #facc15;
  --affine-v2-edgeless-lock-locked: #92929285;
  --affine-v2-edgeless-mindMap-line: #ffffff;
  --affine-v2-edgeless-note-black: #252525;
  --affine-v2-edgeless-note-blue: #004b7b;
  --affine-v2-edgeless-note-green: #3b5315;
  --affine-v2-edgeless-note-grey: #565656;
  --affine-v2-edgeless-note-magenta: #5f0a35;
  --affine-v2-edgeless-note-orange: #843b06;
  --affine-v2-edgeless-note-purple: #312e81;
  --affine-v2-edgeless-note-red: #460606;
  --affine-v2-edgeless-note-teal: #0e4841;
  --affine-v2-edgeless-note-white: #252525;
  --affine-v2-edgeless-note-yellow: #704200;
  --affine-v2-edgeless-palette-black: #ffffff;
  --affine-v2-edgeless-palette-white: #000000;
  --affine-v2-edgeless-palette-heavy-blue: #1c70a5;
  --affine-v2-edgeless-palette-heavy-green: #447756;
  --affine-v2-edgeless-palette-heavy-magenta: #941555;
  --affine-v2-edgeless-palette-heavy-orange: #b55309;
  --affine-v2-edgeless-palette-heavy-purple: #5a21b6;
  --affine-v2-edgeless-palette-heavy-red: #761717;
  --affine-v2-edgeless-palette-heavy-yellow: #ac7400;
  --affine-v2-edgeless-palette-light-blueLight: #e6f5ff;
  --affine-v2-edgeless-palette-light-greenLight: #f1fdf4;
  --affine-v2-edgeless-palette-light-greyLight: #e6e6e6;
  --affine-v2-edgeless-palette-light-magentaLight: #ffecf6;
  --affine-v2-edgeless-palette-light-orangeLight: #ffebd5;
  --affine-v2-edgeless-palette-light-purpleLight: #d7cdff;
  --affine-v2-edgeless-palette-light-redLight: #fce5e6;
  --affine-v2-edgeless-palette-light-yellowLight: #fffbd5;
  --affine-v2-edgeless-palette-medium-blueMedium: #84cfff;
  --affine-v2-edgeless-palette-medium-greenMedium: #3cbc36;
  --affine-v2-edgeless-palette-medium-greyMedium: #929292;
  --affine-v2-edgeless-palette-medium-magentaMedium: #e96cab;
  --affine-v2-edgeless-palette-medium-orangeMedium: #ff8c38;
  --affine-v2-edgeless-palette-medium-purpleMedium: #6e52df;
  --affine-v2-edgeless-palette-medium-redMedium: #fb7081;
  --affine-v2-edgeless-palette-medium-yellowMedium: #fcd34d;
  --affine-v2-edgeless-selection-selectionMarqueeBackground: #1e96eb14;
  --affine-v2-edgeless-selection-selectionMarqueeBorder: #1e96eb;
  --affine-v2-edgeless-shape-black: #000000;
  --affine-v2-edgeless-shape-blue: #9fd9ff;
  --affine-v2-edgeless-shape-green: #9bda91;
  --affine-v2-edgeless-shape-grey: #cdcdcd;
  --affine-v2-edgeless-shape-magenta: #ffc0e0;
  --affine-v2-edgeless-shape-orange: #ffae63;
  --affine-v2-edgeless-shape-purple: #d7cdff;
  --affine-v2-edgeless-shape-red: #fbb7b7;
  --affine-v2-edgeless-shape-teal: #8be7dc;
  --affine-v2-edgeless-shape-white: #ffffff;
  --affine-v2-edgeless-shape-yellow: #fde047;
  --affine-v2-edgelessToolbar-highlightPen-body: #3d3d3d;
  --affine-v2-edgelessToolbar-highlightPen-body1Linear1-1: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body1Linear1-2: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body1Linear1-3: #000000;
  --affine-v2-edgelessToolbar-highlightPen-body1Linear2-1: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body1Linear2-2: #00000080;
  --affine-v2-edgelessToolbar-highlightPen-body1Linear2-3: #000000;
  --affine-v2-edgelessToolbar-highlightPen-body1Linear2-4: #ffffff;
  --affine-v2-edgelessToolbar-highlightPen-body2: #303030;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear1-1: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear1-2: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear1-3: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear2-1: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear2-2: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear2-3: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear2-4: #000000;
  --affine-v2-edgelessToolbar-highlightPen-body2Linear2-5: #797979;
  --affine-v2-edgelessToolbar-highlightPen-bodyColorLinear-1: #00000000;
  --affine-v2-edgelessToolbar-highlightPen-bodyColorLinear-2: #000000;
  --affine-v2-edgelessToolbar-highlightPen-bodyColorLinear-3: #000000c4;
  --affine-v2-edgelessToolbar-media-whiteVector: #00000038;
  --affine-v2-edgelessToolbar-note-background: #414141;
  --affine-v2-edgelessToolbar-note-textColor: #ffffff21;
  --affine-v2-edgelessToolbar-others-background: #4a4a4ab2;
  --affine-v2-edgelessToolbar-others-highlightLinearEnd: #ffffff1f;
  --affine-v2-edgelessToolbar-others-highlightLinearStart: #ffffff0f;
  --affine-v2-edgelessToolbar-others-linearCenter: #000000a8;
  --affine-v2-edgelessToolbar-others-linearEnd: #00000000;
  --affine-v2-edgelessToolbar-others-linearStart: #00000000;
  --affine-v2-edgelessToolbar-penEraser-eraserBlue-1: #1c3d5d;
  --affine-v2-edgelessToolbar-penEraser-eraserBlue-2: #a1c5d3;
  --affine-v2-edgelessToolbar-penEraser-eraserBlue-3: #1a7cc1;
  --affine-v2-edgelessToolbar-penEraser-eraserBodyFill: #3d3d3d;
  --affine-v2-edgelessToolbar-penEraser-eraserBodyHighlight: #ffffff17;
  --affine-v2-edgelessToolbar-penEraser-eraserBodyShade2: #000000cc;
  --affine-v2-edgelessToolbar-penEraser-eraserBodyShade3: #ffffff66;
  --affine-v2-edgelessToolbar-penEraser-eraserBorder: #7f7f7f;
  --affine-v2-edgelessToolbar-penEraser-eraserBorder2: #9b9b9b;
  --affine-v2-edgelessToolbar-penEraser-eraserClothHighlight: #ffffff1c;
  --affine-v2-edgelessToolbar-penEraser-eraserClothShade2: #0f0f0f;
  --affine-v2-edgelessToolbar-penEraser-eraserClothShade3: #ffffff17;
  --affine-v2-edgelessToolbar-penEraser-eraserShadow: #000000c4;
  --affine-v2-edgelessToolbar-penEraser-penBackground: #3d3d3d;
  --affine-v2-edgelessToolbar-penEraser-penBodyShade-1: #00000099;
  --affine-v2-edgelessToolbar-penEraser-penBodyShade-2: #00000066;
  --affine-v2-edgelessToolbar-penEraser-penBodyShade-3: #00000033;
  --affine-v2-edgelessToolbar-penEraser-penBodyShade-4: #0000001a;
  --affine-v2-edgelessToolbar-penEraser-penInlineShadow: #00000040;
  --affine-v2-icon-activated: #1e96eb;
  --affine-v2-icon-disable: #414141;
  --affine-v2-icon-fileIconBorder: #565656;
  --affine-v2-icon-monotone: #7a7a7a;
  --affine-v2-icon-primary: #f3f3f3;
  --affine-v2-icon-secondary: #cdcdcd;
  --affine-v2-icon-tertiary: #565656;
  --affine-v2-icon-transparentBlack: #ffffffb8;
  --affine-v2-icon-fileIconColors-blue: #0077cb;
  --affine-v2-icon-fileIconColors-green: #1d9c07;
  --affine-v2-icon-fileIconColors-grey: #312e81;
  --affine-v2-icon-fileIconColors-magenta: #e660a4;
  --affine-v2-icon-fileIconColors-purple: #6e52df;
  --affine-v2-icon-fileIconColors-red: #ed3f3f;
  --affine-v2-icon-fileIconColors-yellow: #facc15;
  --affine-v2-input-background: #ffffff17;
  --affine-v2-input-scrollBar-handle: #ffffff2b;
  --affine-v2-input-border-active: #1e96eb;
  --affine-v2-input-border-default: #ffffff0d;
  --affine-v2-input-border-error: #ed3f3f;
  --affine-v2-integrations-background-iconSolid: #ffffff;
  --affine-v2-layer-black: #ffffff;
  --affine-v2-layer-pureBlack: #000000;
  --affine-v2-layer-pureWhite: #ffffff;
  --affine-v2-layer-white: #000000;
  --affine-v2-layer-insideBorder-blackBorder: #ffffff0d;
  --affine-v2-layer-insideBorder-border: #414141;
  --affine-v2-layer-insideBorder-primaryBorder: #1e96eb;
  --affine-v2-layer-insideBorder-splitviewActived: #ffffffab;
  --affine-v2-layer-insideBorder-whiteBorder: #ffffff0d;
  --affine-v2-layer-background-codeBlock: #252525;
  --affine-v2-layer-background-edgelessGrid: #565656;
  --affine-v2-layer-background-error: #460606;
  --affine-v2-layer-background-hoverOverlay: #ffffff17;
  --affine-v2-layer-background-linkedDocOnEdgeless: #252525;
  --affine-v2-layer-background-modal: #00000085;
  --affine-v2-layer-background-modalWhite: #ffffff2b;
  --affine-v2-layer-background-overlayPanel: #252525;
  --affine-v2-layer-background-primary: #141414;
  --affine-v2-layer-background-processing: #002742;
  --affine-v2-layer-background-secondary: #252525;
  --affine-v2-layer-background-success: #1c3027;
  --affine-v2-layer-background-tertiary: #565656;
  --affine-v2-layer-background-translucentUI: #000000a6;
  --affine-v2-layer-background-warning: #321a04;
  --affine-v2-layer-background-mobile-iOSControl: #ffffff;
  --affine-v2-layer-background-mobile-modal: #00000085;
  --affine-v2-layer-background-mobile-primary: #000000;
  --affine-v2-layer-background-mobile-secondary: #252525;
  --affine-v2-layer-background-mobile-tertiary: #414141;
  --affine-v2-loading-background: #ffffff2b;
  --affine-v2-loading-backgroundLayer: #929292f2;
  --affine-v2-loading-foreground: #0077cb;
  --affine-v2-loading-imageLoadingBackground: #92929238;
  --affine-v2-loading-imageLoadingLayer: #ffffff8f;
  --affine-v2-others-warnLabel-black: #000000;
  --affine-v2-others-warnLabel-yellow: #facc15;
  --affine-v2-pagelist-hoverBorder: #7a7a7a;
  --affine-v2-portrait-localPortrait: #ffffff3b;
  --affine-v2-portrait-localPortraitBackground: #ffffff2b;
  --affine-v2-radio-disable: #7a7a7a;
  --affine-v2-radio-active-chekced: #1e96eb;
  --affine-v2-radio-active-default: #b3b3b3;
  --affine-v2-readwise-quoteBackground: #252525;
  --affine-v2-readwise-quoteDivider: #1e96eb;
  --affine-v2-segment-background: #ffffff0d;
  --affine-v2-segment-button: #ffffff17;
  --affine-v2-selfhost-portrait-localPortraitBackground: #ffffff21;
  --affine-v2-selfhost-button-disable: #252525;
  --affine-v2-selfhost-button-primary: #f3f3f3;
  --affine-v2-selfhost-button-secondary: #ffffff17;
  --affine-v2-selfhost-button-sidebarButton-bg-hover: #ffffff17;
  --affine-v2-selfhost-button-sidebarButton-bg-select: #ffffff17;
  --affine-v2-selfhost-icon-buttonIcon: #141414;
  --affine-v2-selfhost-icon-buttonIconError: #ffffff;
  --affine-v2-selfhost-icon-disable: #565656;
  --affine-v2-selfhost-icon-primary: #f3f3f3;
  --affine-v2-selfhost-icon-secondary: #cdcdcd;
  --affine-v2-selfhost-icon-tertiary: #565656;
  --affine-v2-selfhost-layer-background-hoverOverlay: #fffffffa;
  --affine-v2-selfhost-layer-background-primary: #141414;
  --affine-v2-selfhost-layer-background-secondary: #252525;
  --affine-v2-selfhost-layer-background-sidebarBg-sidebarBg: #252525;
  --affine-v2-selfhost-layer-border-border: #e6e6e6;
  --affine-v2-selfhost-progress-error: #c83030;
  --affine-v2-selfhost-progress-primary: #e6e6e6;
  --affine-v2-selfhost-text-placeholder: #7a7a7a;
  --affine-v2-selfhost-text-button-error: #ffffff;
  --affine-v2-selfhost-text-button-primary: #141414;
  --affine-v2-selfhost-text-sidebar-primary: #e6e6e6;
  --affine-v2-selfhost-text-sidebar-secondary: #cdcdcd;
  --affine-v2-selfhost-toggle-backgroundDisable: #414141;
  --affine-v2-selfhost-toggle-backgroundOff: #565656;
  --affine-v2-selfhost-toggle-backgroundOn: #b3b3b3;
  --affine-v2-selfhost-toggle-foreground: #fffffffa;
  --affine-v2-selfhost-toggle-foregroundDisable: #565656;
  --affine-v2-skeleton-skeleton: #252525;
  --affine-v2-slashMenu-background: #252525;
  --affine-v2-status-error: #c83030;
  --affine-v2-status-success: #1d9c07;
  --affine-v2-switch-buttonBackground-active: #414141;
  --affine-v2-switch-buttonBackground-hover: #ffffff0d;
  --affine-v2-switch-fontColor-primary: #e6e6e6;
  --affine-v2-switch-fontColor-secondary: #929292;
  --affine-v2-switch-fontColor-tertiary: #7a7a7a;
  --affine-v2-switch-iconColor-active: #cdcdcd;
  --affine-v2-switch-iconColor-default: #7a7a7a;
  --affine-v2-switch-switchBackground-background: #252525;
  --affine-v2-tab-divider-divider: #ffffff21;
  --affine-v2-tab-divider-indicator: #1e96eb;
  --affine-v2-tab-fontColor-active: #e6e6e6;
  --affine-v2-tab-fontColor-default: #565656;
  --affine-v2-tab-fontColor-hover: #e6e6e6;
  --affine-v2-tab-iconColor-active: #cdcdcd;
  --affine-v2-tab-iconColor-default: #7a7a7a;
  --affine-v2-tab-iconColor-hover: #cdcdcd;
  --affine-v2-tab-tabBackground-active: #414141;
  --affine-v2-tab-tabBackground-default: #252525;
  --affine-v2-tab-tabBackground-hover: #252525;
  --affine-v2-table-border: #ffffff21;
  --affine-v2-table-focusBackground: #1e96eb0a;
  --affine-v2-table-focusBorder: #1e96eb;
  --affine-v2-table-textSecondary: #ffffff8f;
  --affine-v2-table-headerBackground-blue: #004b7b;
  --affine-v2-table-headerBackground-default: #252525;
  --affine-v2-table-headerBackground-green: #10340a;
  --affine-v2-table-headerBackground-grey: #565656;
  --affine-v2-table-headerBackground-headerColor: #252525;
  --affine-v2-table-headerBackground-orange: #843b06;
  --affine-v2-table-headerBackground-purple: #25136d;
  --affine-v2-table-headerBackground-red: #460606;
  --affine-v2-table-headerBackground-teal: #0e4841;
  --affine-v2-table-headerBackground-yellow: #704200;
  --affine-v2-table-indicator-activated: #1e96eb;
  --affine-v2-table-indicator-border: #414141;
  --affine-v2-table-indicator-drag: #ffffff21;
  --affine-v2-table-indicator-hover: #ffffff17;
  --affine-v2-table-indicator-pointerActive: #ffffff;
  --affine-v2-table-indicator-pointerDefault: #cdcdcd;
  --affine-v2-text-disable: #565656;
  --affine-v2-text-emphasis: #29a3fa;
  --affine-v2-text-link: #7ac8ff;
  --affine-v2-text-listDotAndNumber: #4ab1fa;
  --affine-v2-text-placeholder: #7a7a7a;
  --affine-v2-text-primary: #e6e6e6;
  --affine-v2-text-pureWhite: #ffffff;
  --affine-v2-text-secondary: #929292;
  --affine-v2-text-tertiary: #7a7a7a;
  --affine-v2-text-highlight-border: #ffffff3b;
  --affine-v2-text-highlight-bg-blue: #002742;
  --affine-v2-text-highlight-bg-green: #192e06;
  --affine-v2-text-highlight-bg-grey: #414141;
  --affine-v2-text-highlight-bg-magenta: #5f0a35;
  --affine-v2-text-highlight-bg-orange: #843b06;
  --affine-v2-text-highlight-bg-purple: #2e1065;
  --affine-v2-text-highlight-bg-red: #460606;
  --affine-v2-text-highlight-bg-teal: #0e4841;
  --affine-v2-text-highlight-bg-yellow: #321a04;
  --affine-v2-text-highlight-fg-blue: #2f94d5;
  --affine-v2-text-highlight-fg-green: #9bda91;
  --affine-v2-text-highlight-fg-grey: #565656;
  --affine-v2-text-highlight-fg-magenta: #f37fba;
  --affine-v2-text-highlight-fg-orange: #ffae63;
  --affine-v2-text-highlight-fg-purple: #9681ef;
  --affine-v2-text-highlight-fg-red: #fc7979;
  --affine-v2-text-highlight-fg-teal: #448e86;
  --affine-v2-text-highlight-fg-yellow: #facc15;
  --affine-v2-toast-cardLayer-second: #252525;
  --affine-v2-toast-cardLayer-third: #252525;
  --affine-v2-toast-iconState-error: #c83030;
  --affine-v2-toast-iconState-regular: #035f9f;
  --affine-v2-toast-iconState-success: #1d9c07;
  --affine-v2-toast-overlay-secondary: #0000000d;
  --affine-v2-toast-overlay-tertiary: #00000008;
  --affine-v2-toggle-background: #0077cb;
  --affine-v2-toggle-backgroundDisable: #414141;
  --affine-v2-toggle-backgroundOff: #565656;
  --affine-v2-toggle-foreground: #fffffffa;
  --affine-v2-toggle-foregroundDisable: #929292;
  --affine-v2-tooltips-background: #414141;
  --affine-v2-tooltips-foreground: #ffffff;
  --affine-v2-tooltips-secondaryBackground: #ffffff2b;
  --affine-v2-workspacePicker-border: #414141;
  --affine-v2-workspacePicker-secondaryBackground: #9292922b;
  --affine-v2-tableOfContent-background: #252525;
}
@media print {
  :root {
    --affine-font-family: "Inter", "Source Sans 3", Poppins, "Helvetica Neue", Tahoma, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji","Segoe UI Symbol", "Noto Color Emoji";
    --affine-font-serif-family: "Source Serif 4", "Noto Serif" , serif, "Cambria", "Helvetica Neue", Tahoma, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji","Segoe UI Symbol", "Noto Color Emoji";
    --affine-font-mono-family: "Source Code Pro", "IBM Plex Mono", "Roboto Mono","Noto Sans Mono", "Noto Sans CJK", "Helvetica Neue", Tahoma, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji","Segoe UI Symbol", "Noto Color Emoji";
    --affine-font-sans-family: "Inter", "Source Sans 3", Poppins, "Helvetica Neue", Tahoma, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji","Segoe UI Symbol", "Noto Color Emoji";
    --affine-font-number-family: "Roboto Mono", "Noto Sans Mono", "Helvetica Neue", Tahoma, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji","Segoe UI Symbol", "Noto Color Emoji";
    --affine-font-code-family: "IBM Plex Mono", "Space Mono", Consolas, Menlo, Monaco, Courier, monospace, "Helvetica Neue", Tahoma, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji","Segoe UI Symbol", "Noto Color Emoji";
  }
}
.xn1iio0 {
  font-size: 34px;
  font-weight: 400;
  line-height: 41px;
  letter-spacing: .4px;
  font-style: normal;
}
.xn1iio1 {
  font-size: 34px;
  font-weight: 700;
  line-height: 41px;
  letter-spacing: .4px;
  font-style: normal;
}
.xn1iio2 {
  font-size: 28px;
  font-weight: 400;
  line-height: 34px;
  letter-spacing: .38px;
  font-style: normal;
}
.xn1iio3 {
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: .38px;
  font-style: normal;
}
.xn1iio4 {
  font-size: 22px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: -.26px;
  font-style: normal;
}
.xn1iio5 {
  font-size: 22px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: -.26px;
  font-style: normal;
}
.xn1iio6 {
  font-size: 20px;
  font-weight: 400;
  line-height: 25px;
  letter-spacing: -.45px;
  font-style: normal;
}
.xn1iio7 {
  font-size: 20px;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: -.45px;
  font-style: normal;
}
.xn1iio8 {
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -.43px;
  font-style: normal;
}
.xn1iio9 {
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -.43px;
  font-style: italic;
}
.xn1iioa {
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -.43px;
  font-style: normal;
}
.xn1iiob {
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -.43px;
  font-style: normal;
}
.xn1iioc {
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -.43px;
  font-style: italic;
}
.xn1iiod {
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -.43px;
  font-style: italic;
}
.xn1iioe {
  font-size: 16px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: -.31px;
  font-style: normal;
}
.xn1iiof {
  font-size: 16px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: -.31px;
  font-style: normal;
}
.xn1iiog {
  font-size: 16px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: -.31px;
  font-style: italic;
}
.xn1iioh {
  font-size: 16px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: -.31px;
  font-style: italic;
}
.xn1iioi {
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -.23px;
  font-style: normal;
}
.xn1iioj {
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -.23px;
  font-style: normal;
}
.xn1iiok {
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -.23px;
  font-style: italic;
}
.xn1iiol {
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -.23px;
  font-style: italic;
}
.xn1iiom {
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -.08px;
  font-style: normal;
}
.xn1iion {
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -.08px;
  font-style: normal;
}
.xn1iioo {
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -.08px;
  font-style: italic;
}
.xn1iiop {
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -.08px;
  font-style: italic;
}
.xn1iioq {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: inherit;
  font-style: normal;
}
.xn1iior {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: inherit;
  font-style: normal;
}
.xn1iios {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: inherit;
  font-style: italic;
}
.xn1iiot {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: inherit;
  font-style: italic;
}
.xn1iiou {
  font-size: 11px;
  font-weight: 400;
  line-height: 13px;
  letter-spacing: .06px;
  font-style: normal;
}
.xn1iiov {
  font-size: 11px;
  font-weight: 600;
  line-height: 13px;
  letter-spacing: .06px;
  font-style: normal;
}
.xn1iiow {
  font-size: 11px;
  font-weight: 400;
  line-height: 13px;
  letter-spacing: .06px;
  font-style: italic;
}
.xn1iiox {
  font-size: 11px;
  font-weight: 600;
  line-height: 13px;
  letter-spacing: .06px;
  font-style: italic;
}
@layer base {
  *,
  ::after,
  ::before,
  ::backdrop,
  ::file-selector-button {
    border-color: var(--color-gray-200, currentColor);
  }
}
@layer base {
  :root {
    --background: 0 0% 100%;
    --foreground: 240 10% 3.9%;
    --card: 0 0% 100%;
    --card-foreground: 240 10% 3.9%;
    --popover: 0 0% 100%;
    --popover-foreground: 240 10% 3.9%;
    --primary: 240 5.9% 10%;
    --primary-foreground: 0 0% 98%;
    --secondary: 240 4.8% 95.9%;
    --secondary-foreground: 240 5.9% 10%;
    --muted: 240 4.8% 95.9%;
    --muted-foreground: 240 3.8% 46.1%;
    --accent: 240 4.8% 95.9%;
    --accent-foreground: 240 5.9% 10%;
    --destructive: 0 84.2% 60.2%;
    --destructive-foreground: 0 0% 98%;
    --border: 240 5.9% 90%;
    --input: 240 5.9% 90%;
    --ring: 240 10% 3.9%;
    --radius: 0.5rem;
  }
  .dark {
    --background: 240 10% 3.9%;
    --foreground: 0 0% 98%;
    --card: 240 10% 3.9%;
    --card-foreground: 0 0% 98%;
    --popover: 240 10% 3.9%;
    --popover-foreground: 0 0% 98%;
    --primary: 0 0% 98%;
    --primary-foreground: 240 5.9% 10%;
    --secondary: 240 3.7% 15.9%;
    --secondary-foreground: 0 0% 98%;
    --muted: 240 3.7% 15.9%;
    --muted-foreground: 240 5% 64.9%;
    --accent: 240 3.7% 15.9%;
    --accent-foreground: 0 0% 98%;
    --destructive: 0 62.8% 30.6%;
    --destructive-foreground: 0 0% 98%;
    --border: 240 3.7% 15.9%;
    --input: 240 3.7% 15.9%;
    --ring: 240 4.9% 83.9%;
  }
}
@layer base {
  * {
    border-color: var(--color-border);
  }
  body {
    background-color: var(--color-background);
    color: var(--color-foreground);
  }
}
@keyframes enter {
  from {
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit {
  to {
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
@keyframes enter {
  from {
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit {
  to {
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-space-x-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-divide-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-tracking {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@property --tw-content {
  syntax: "*";
  initial-value: "";
  inherits: false;
}
@property --tw-scale-x {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-y {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-z {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}
@keyframes accordion-down {
  from {
    height: 0;
  }
  to {
    height: var(--radix-accordion-content-height);
  }
}
@keyframes accordion-up {
  from {
    height: var(--radix-accordion-content-height);
  }
  to {
    height: 0;
  }
}
@keyframes accordion-down {
  from {
    height: 0;
  }
  to {
    height: var(--radix-accordion-content-height);
  }
}
@keyframes accordion-up {
  from {
    height: var(--radix-accordion-content-height);
  }
  to {
    height: 0;
  }
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-space-y-reverse: 0;
      --tw-space-x-reverse: 0;
      --tw-divide-y-reverse: 0;
      --tw-border-style: solid;
      --tw-leading: initial;
      --tw-font-weight: initial;
      --tw-tracking: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-outline-style: solid;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-backdrop-blur: initial;
      --tw-backdrop-brightness: initial;
      --tw-backdrop-contrast: initial;
      --tw-backdrop-grayscale: initial;
      --tw-backdrop-hue-rotate: initial;
      --tw-backdrop-invert: initial;
      --tw-backdrop-opacity: initial;
      --tw-backdrop-saturate: initial;
      --tw-backdrop-sepia: initial;
      --tw-duration: initial;
      --tw-ease: initial;
      --tw-content: "";
      --tw-scale-x: 1;
      --tw-scale-y: 1;
      --tw-scale-z: 1;
    }
  }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
